"use strict";
import React from "react";
import { flushSync } from "react-dom";
import { createRoot } from "react-dom/client";
import Editor from "../../Editor/Editor";
import smetaAxios from "../../SmetaAxios";
import { renderMessageBox, resumeRequest, tokenProcessingTest } from "../../TokenProcessing/TokenProcessing";
import { AxiosRequest, getOptionsForUser, ImgURLSRC } from "../../Url";
import DialogCreateObj from "../Module/Dialogs/DialogCreateObj";
import DialogSetObjText from "../Module/Dialogs/DialogSetObjText";
import MessageBox from "../Module/MessageBox";
import { openHelpContextDialog } from "../NotWorkArea(Side&Head)/Header/SupportButton";
import CheckBoxMultiCheck from "../Sections/ElementsSections/CheckBoxMultiCheck";
import { getImageHint } from "../Sections/ElementsSections/SectionDocuments/DocumentsConsts";
import { smetaModals } from "../Tools/modalManager";
import { Button as DlgButton, DlgRes, DlgType, ParamSetOption } from "../Tools/ProjectX";
import {
  EditColumnField,
  GetColumnDetails,
  GetColumnHintDocs,
  getColumnParams,
  GetDocDialogParams,
} from "../Tools/Requests";
import {
  defaultFieldInfo,
  getDateOfInt,
  getIcons,
  getIconsAsync,
  getStyleWindow,
  isEmptyObject,
  setColor,
  throttle,
} from "../Tools/Tools";
import CardModeButton from "./CardModeButton";
import ColumnButton from "./ColumnButton";
import { isCollapsibleRecord } from "./GridTools/collapsibleRecordsTools";
import FilterGridComponent from "./GridTools/FilterGridComponent";
import { getParamColumnsOptions } from "./GridTools/parseColumnTools";
import StatusButtonCardMode from "./GridTools/StatusButtonCardMode";
import queuedGridScroll from "./queuedGridScroll";
import { smetaStore, systemInfoAtom } from "../../../atoms";

const modalButton = 0;
const listButton = 1;

function appendEvent(e, f, el) {
  if (el) {
    el.addEventListener(e, f);
  } else {
    document.addEventListener(e, f);
  }
}

function deleteEvent(e, f, el) {
  if (el) {
    el.removeEventListener(e, f);
  } else {
    document.removeEventListener(e, f);
  }
}

function showApplicationMask(parent, text) {
  if (parent) {
    const maskbox = document.createElement("div");
    maskbox.setAttribute("class", "login-form-mask-box");
    maskbox.setAttribute("id", "mask-box");
    parent.appendChild(maskbox);

    const maskicon = document.createElement("img");
    maskicon.setAttribute("class", "login-form-mask-icon");
    maskbox.appendChild(maskicon);

    const maskboxtext = document.createElement("div");
    maskboxtext.setAttribute("class", "login-form-mask-text");
    maskboxtext.innerText = !text ? "Загрузка данных" : text;
    maskbox.appendChild(maskboxtext);
  }
}
function hideApplicationMask(parent) {
  if (parent) {
    const el = document.getElementById("mask-box");
    if (el) el.remove();
  }
}

function delayCall(f) {
  setTimeout(() => {
    f();
  }, 1);
}

function minint(x, y) {
  if (x < y) return x;
  else return y;
}

function maxint(x, y) {
  if (x > y) return x;
  else return y;
}

function midint(min, max, val) {
  return maxint(min, minint(max, val));
}

function intInRange(int, min, max) {
  return int >= min && int <= max;
}

function showElement(el) {
  el.style.display = "";
}

function hideElement(el) {
  el.style.display = "none";
}

function moddiv(baseval, divider) {
  if (divider > 0) {
    return (baseval - (baseval % divider)) / divider;
  } else return 0;
}

// Состояние источника
export const dsInactive = 0,
  dsBrowse = 1,
  dsEdit = 2,
  dsInsert = 3;

const // Статус записи
  STATUS_GROUPED = 32,
  STATUS_COLLAPSED = 128,
  // Состояние записи
  usUnmodified = 0,
  usModified = 1,
  usInserted = 2,
  usDeleted = 3;

export function createRecordSource() {
  const me = this,
    points = new Map();
  let state = {},
    bof = true,
    eof = true,
    recordIndex = -1,
    indexFields = "",
    groupFields = "",
    editRec = null,
    gen = 0,
    keyFieldName = "",
    changes = [],
    gridStateChanged = false,
    savecurrentvalues = {};
  // public properties
  me.recordCount = 0;
  me.onGridStateChange = null;
  me.activeRecord = 0;
  me.fields = [];
  me.modified = false;
  me.active = false;
  me.defaultFields = false;
  me.InsertFlag = 0;
  me.acquireFields = acquireFields;
  me.Master = {
    isEmpty: false,
  };
  me.onHandleRequest = null;
  me.onRecordCollapsed = null;
  me.CreateCollapsibleRecords = null;
  me.onRecordAttributeHandling = null;
  me.updatesPending = false;
  me.selection = "";
  me.NeedToSave = false;
  me.rights = {
    modify: false,
    insert: false,
    delete: false,
    accsess: false,
  };
  me.actual = false;
  const insertFlagValue = { "": 0, 1: 1, 0: 2 };
  /**
   * Определяет, учитывается ли регистр имен полей при их поиске.
   * Если `true`, то 'Name' и 'name' считаются разными полями.
   * Если `false`, регистр игнорируется.
   * @type {boolean}
   * @default true
   */
  me.caseSensitive = true;

  /**
   * @type {((source: createRecordSource) => void | Promise<void>) | undefined}
   */
  me.onRecordIndexChanged = undefined;

  /**
   * @type {((fieldText: string, fieldName: string) => string | number | Promise<string | number>) | undefined}
   */
  me.booksGetImage = undefined;

  async function handleRequest(request, loadCursor, wsm, subParams) {
    if (me.onHandleRequest) {
      const json = await me.onHandleRequest(request, loadCursor, wsm, subParams);
      if (json) {
        me.updatesPending = json.UpdatesPending === "1";
        me.actual = json.Actual === "1";
      }
      // if (json.UpdatesPending === "1") {
      me.ChangeSave();
      // }
      return json;
    }
  }

  me.saveState = function () {
    if (gridStateChanged) {
      gridStateChanged = false;
      return state;
    }
  };

  me.getKeyFieldNameData = (text = true) => {
    if (text) return me.getFieldTextSync(keyFieldName) || 0;
    else return me.getFieldValueSync(keyFieldName) || 0;
  };

  me.getKeyFieldName = function () {
    return keyFieldName;
  };

  me.setKeyFieldName = function (key) {
    keyFieldName = key;
  };

  function acquireFields() {
    if (me.active) return;
    const request = { command: "getFields" };
    if (indexFields) {
      request.indexFields = indexFields;
      indexFields = "";
    }
    if (groupFields) {
      request.groupFields = groupFields;
      groupFields = "";
    }
    // json =
    return handleRequest(request, true).then((json) => {
      if (json && json.Fields) {
        me.fields = [];
        const fields = json.Fields;
        for (let i = 0; i < fields.length; i++) {
          const sourField = fields[i];
          if (sourField.Name) {
            const destField = {};
            destField.fieldName = sourField.Name;
            if (sourField.Title) destField.displayLabel = sourField.Title;
            else destField.displayLabel = destField.fieldName;
            if (sourField.Width) destField.displayWidth = sourField.Width;
            else destField.displayWidth = 10;
            if (sourField.Type) destField.dataType = sourField.Type;
            else destField.dataType = 1;
            if (sourField.Size) destField.dataSize = sourField.Size;
            else sourField.dataSize = 0;
            if (sourField.Alignment) destField.alignment = sourField.Alignment;
            else destField.alignment = 0;
            if (sourField.Values) {
              //todo
              destField.list = Object.values(sourField.Values);
            } else destField.list = [];
            me.fields.push(destField);
          }
        }
        if (json.RecordCount) me.recordCount = parseInt(json.RecordCount);
        else me.recordCount = 0;
        if (json.Selection) me.selection = json.Selection;
        if (json.KeyFieldName) keyFieldName = json.KeyFieldName;
        if (json.DisableInsert) me.InsertFlag = insertFlagValue[json.DisableInsert];
      }
    });
  }

  function checkScrollRecord() {}
  function checkRecordUpdates() {}
  async function recordIndexChanged() {
    if (me.onRecordIndexChanged) {
      await me.getFieldText("ID");
      // await me.acquireRecords(me.activeRecord, 1);
      await me.onRecordIndexChanged(me);
      recordIndex = me.activeRecord;
    }
    sourceStateChanged();
  }
  me.ChangeSave = function (bool) {
    // if (me.updatesPending === bool) return;
    // me.NeedToSave = bool;
    onNeedToSaveChange();
  };
  function onNeedToSaveChange() {
    me.onNeedToSaveChanged?.(me);
  }
  async function dataChanged() {
    await me.onDataChanged?.(me);
  }
  function sourceStateChanged() {}
  function recordStateChanged() {}

  async function createNewRecord(info, subData) {
    return new Promise(async (resolve) => {
      const request = { command: "CreateRecord", RecordIndex: me.activeRecord };
      if (info) request.info = info;
      if (subData) {
        for (const [key, value] of Object.entries(subData)) {
          request[key] = value;
        }
      }
      // json =
      const json = await handleRequest(request, true);
      if (json && json.RecordSet) {
        const fields = json.RecordSet.Attributes;
        if (fields) {
          const records = json.RecordSet.Records;
          if (records && records.length > 0) {
            editRec = { vals: [], info: {} };
            editRec.insert = true;
            editRec.active = me.activeRecord;
            loadRecordValues(editRec, records[0], fields);
            //todo: EditFields = fields.commaText;
            resolve(true);
          }
        }
      } else {
        resolve();
      }
    });
  }

  me.saveCurrentMarkedValues = function (field) {
    if (field.marked) {
      const id = me.getFieldValueSync(field.fieldName),
        text = me.getFieldTextSync(field.fieldName);
      const index = me.getFieldIndex(field.fieldName);
      savecurrentvalues = {
        ...savecurrentvalues,
        [index]: {
          id: id === undefined ? "" : id,
          text: text === undefined ? "" : text,
        },
      };
    } else {
      delete savecurrentvalues[field.fieldName];
    }
  };

  me.updateCurrentMarkedValues = async function () {
    for (const key of Object.keys(savecurrentvalues)) {
      const fieldName = me.fields[key].fieldName;
      // const fieldName = key;
      const id = await me.getFieldValue(fieldName),
        text = await me.getFieldText(fieldName);
      savecurrentvalues = {
        ...savecurrentvalues,
        [key]: {
          id: id === undefined ? "" : id,
          text: text === undefined ? "" : text,
        },
      };
    }
  };

  async function fieldHasData(fieldName) {
    const rec = await getRecordNode(me.activeRecord);
    if (rec) {
      return true;
    }
  }

  const getMarkedValue = (dest, index) => {
    if (savecurrentvalues[index] && dest.insert === true) {
      if (savecurrentvalues[index].id || savecurrentvalues[index].text) {
        return savecurrentvalues[index];
      } else {
        return { id: "", text: "" };
      }
    }
    return {};
  };

  function loadRecordValues(dest, sour, fields, index) {
    if (dest && sour && fields && fields.length) {
      if (!dest.info) dest.info = {};
      if (sour.UpdateStatus) {
        dest.info.updateStatus = parseInt(sour.UpdateStatus);
      } else {
        dest.info.updateStatus = 0;
      }
      if (sour.RecordLevel) dest.info.recordLevel = parseInt(sour.RecordLevel);
      else dest.info.recordLevel = 0;
      if (sour.RecordState) dest.info.recordState = parseInt(sour.RecordState);
      else dest.info.recordState = 0;
      if (sour.Data$content) dest.info.Data$content = sour.Data$content;
      else dest.info.Data$content = "";
      if (sour.levelsField) dest.info.levelsField = sour.levelsField;
      if (sour.Title) dest.info.title = sour.Title;
      if (sour.LockStatus) dest.info.LockStatus = Number(sour.LockStatus);
      if (sour.RecordTitle) dest.info.recordTitle = sour.RecordTitle;
      else dest.info.recordTitle = "";
      if (sour.Text) dest.info.recordText = sour.Text;
      else dest.info.recordText = "";
      dest.info.hidden = sour.Hidden === "1";
      dest.info.locked = sour.Locked === "1";
      dest.info.recordIndex = index;
      if (sour.Day || sour.Year || sour.Month || sour.Number)
        dest.info.rangeInfo = {
          day: sour.Day || 0,
          year: sour.Year || 0,
          month: sour.Month || 0,
          number: sour.Number || 0,
        };
      if (me.onRecordAttributeHandling) me.onRecordAttributeHandling(sour, index);
      checkRecordInfo(dest, fields);
      const data = sour.Data || sour.vals;
      for (let i = 0, fieldName, index, d, v, markedData; i < fields.length; i++) {
        fieldName = typeof fields[i] === "object" ? fields[i].fieldName : fields[i];
        index = me.getFieldIndex(fieldName);
        if (index !== -1) {
          while (dest.vals.length <= index) {
            const destIndex = dest.vals.length;
            markedData = getMarkedValue(dest, destIndex);
            dest.vals.push(isEmptyObject(markedData) ? {} : markedData);
          }
          try {
            d = data[i];
            if (!d || !isEmptyObject(markedData)) continue;
            v = dest.vals[index];
            if (typeof d === "object" && !Array.isArray(d)) {
              v.text = d.text ?? "";
              v.id = d.id;
            } else v.text = d;
          } catch (error) {
            console.error(error);
          }
        }
      }
    }
  }

  function checkRecordInfo(dest, attributes) {
    const dataContent = dest.info.Data$content;
    let fixedDataContent = "0".repeat(me.fields.length);
    if (dataContent !== "" && dataContent && me.fields.length > 0 && attributes) {
      for (let i = 1; i <= attributes.length; i++) {
        const index = me.getFieldIndex(attributes[i - 1]);
        if (index !== undefined && index !== -1 && i <= dataContent.length) {
          fixedDataContent = fixedDataContent.replaceAt(index, dataContent[i - 1]);
        }
      }

      dest.info.Data$content = fixedDataContent;
    }
  }

  function saveRecordValues(sour, dest, fields) {
    if (sour && dest && fields) {
      if (sour.vals) {
        const data = dest.$Data;
        if (data) {
          for (let i = 0, index, fieldName, s, d; i < fields.length; i++) {
            fieldName = fields[i];
            index = me.getFieldIndex(fieldName);
            d = {};
            if (intInRange(index, 0, sour.vals.length - 1)) {
              s = sour.vals[index];
              if (s.text === "" && !s.id) {
                //|| isEmptyObject(s.text)
                d = "";
              } else {
                if (s.text || s.id) {
                  d.text = s.text;
                  d.id = s.id;
                } else d.text = "";
              }
            }
            data.push(d);
          }
        }
      }
    }
  }

  async function loadSingleRecord(first, rec, count, load = true) {
    const request = { command: "getRecords", first: first, count: count ? count : 1 };
    const json = await handleRequest(request, load);
    if (json && json.RecordSet) {
      const attributes = json.RecordSet.Attributes;
      const records = json.RecordSet.Records;
      if (attributes && records && records.length > 0) {
        const record = records[0];
        loadRecordValues(rec, record, attributes, first);
        return json;
      }
    }
  }

  function getRecordNode(index) {
    return new Promise(async (resolve) => {
      if (editRec !== null) {
        if (editRec.index === index) return resolve(editRec);
        if (editRec.insert && index > editRec.index) index--;
      }
      let rec = points.get(index);
      if (!rec) {
        rec = { vals: [], info: {} };
        await loadSingleRecord(index, rec);
        points.set(index, rec);
      }
      return resolve(rec);
    });
  }

  me.acquireRecords = async function (first, count, load) {
    return new Promise(async (resolve) => {
      const rec = { vals: [], info: {} };
      let attributes,
        records = [],
        data;
      const firstRec = maxint(first, 0),
        lastRec = minint(firstRec + count - 1, me.recordCount - 1);
      let fr = firstRec,
        countToGet = 0;
      while (fr <= lastRec) {
        if (points.get(fr) !== undefined) {
          ++fr;
        } else {
          break;
        }
      }
      for (let i = fr; i <= lastRec; i++) {
        if (points.get(i) === undefined) {
          ++countToGet;
        }
      }
      if (editRec && editRec.insert === true) {
        --countToGet;
      }
      if (countToGet !== 0) {
        data = await loadSingleRecord(fr, rec, countToGet, load);
        if (data && data.RecordSet) {
          attributes = data.RecordSet.Attributes;
          records = data.RecordSet.Records;
          for (const [key, value] of Object.entries(records)) {
            const rec = { vals: [], info: {} };
            const isCard = value.levelsField !== undefined;
            const index = isCard ? Number(key) : fr;
            loadRecordValues(rec, value, attributes, index);
            points.set(index, rec);
            fr++;
          }
        }
      }
      return resolve(countToGet);
    });
  };

  me.setGridState = function (obj, changed) {
    state = obj;
    if (changed) {
      if (me.onGridStateChange) me.onGridStateChange();
      gridStateChanged = true;
    }
  };

  me.getGridState = function () {
    return state;
  };

  me.open = async function () {
    return new Promise(async (resolve) => {
      if (me.active) return resolve();
      if (me.fields.length == 0) {
        await acquireFields();
        me.defaultFields = me.fields.length > 0;

        // me.defaultFields = me.fields.length > 0;
      } else await me.refresh();
      me.active = true;
      recordIndex = -1;
      me.first();
      sourceStateChanged();
      resolve();
    });
    // me.active = true;
    // recordIndex = -1;
    // me.first();
    // sourceStateChanged();
  };

  me.close = function () {
    if (!me.active) return;
    points.clear();
    if (me.defaultFields) me.fields = [];
    me.active = false;
    sourceStateChanged();
  };

  me.refresh = async function (key, info) {
    return new Promise(async (resolve) => {
      if (key == "!") {
        points.clear();
        if (editRec) {
          editRec = null;
          recordStateChanged();
        }
        const request = { command: "GetRecordCount" };
        if (!me.isEmpty()) {
          request.recordIndex = me.activeRecord;
        }
        const json = await handleRequest(request, true);
        if (json) {
          if (json.RecordCount !== undefined) me.recordCount = parseInt(json.RecordCount);
          else me.recordCount = 0;
          if (json.RecordIndex !== undefined) {
            me.activeRecord = parseInt(json.RecordIndex);
          }
        }
        return resolve(json);
      } else {
        checkRecordUpdates();
        const request = { command: "refresh" };
        if (key) request.key = key;
        if (info) request.info = info;
        const json = await handleRequest(request, true);
        if (json) {
          recordIndex = -1;
          me.recordCount = json.RecordCount !== undefined ? parseInt(json.RecordCount) : 0;
          points.clear();
          if (editRec) {
            editRec = null;
            recordStateChanged();
          }
          if (json.DisableInsert !== undefined) {
            me.InsertFlag = insertFlagValue[json.DisableInsert];
          }
          if (json.RecordIndex !== undefined) {
            me.activeRecord = parseInt(json.RecordIndex);
          } else if (json.key) {
            me.activeRecord = parseInt(json.key.replace("!", "").replace("^", ""));
          } else {
            me.activeRecord = Math.max(Math.min(me.activeRecord, me.recordCount - 1), 0);
          }
        }
        return resolve(json);
      }
    });
  };

  me.getRecordData = async function (recIndex) {
    return await getRecordNode(recIndex !== undefined ? recIndex : me.activeRecord);
  };

  me.getRecordState = async function () {
    const rec = await getRecordNode(me.activeRecord);
    if (rec.info) {
      return rec.info.recordState;
    }
    return 0;
  };

  me.getRecordInfo = function () {
    let rec = {},
      index = Number(me.activeRecord);
    // = await getRecordNode(me.activeRecord);
    if (editRec) {
      if (editRec.index === index) rec = editRec;
      if (editRec.insert && index > editRec.index) index--;
    } else {
      rec = points.get(index);
    }
    try {
      if (rec.info) {
        return rec.info;
      }
      return {};
    } catch {
      return "";
    }
  };

  me.getRecordID = async function (id) {
    const rec = await getRecordNode(id);
    if (rec) return rec.info.recordIndex;
  };

  me.getRecordTitle = async function () {
    const rec = await getRecordNode(me.activeRecord);
    if (rec.info) {
      return rec.info.recordTitle;
    }
    return "";
  };

  me.getRecordLevel = async function () {
    const rec = await getRecordNode(me.activeRecord);
    if (rec.info) {
      return rec.info.recordLevel ? rec.info.recordLevel : 0;
    }
    return 0;
  };

  me.getFieldTitle = function (fieldName) {
    const index = me.getFieldIndex(fieldName);

    if (index == -1) {
      return "";
    }

    return me.fields[index]?.displayLabel || "";
  };

  me.getFieldText = async function (fieldName, recordIndex) {
    const index = me.getFieldIndex(fieldName);

    if (index == -1) {
      return "";
    }
    const rec = await getRecordNode(recordIndex ?? me.activeRecord);

    if (!rec || !rec.vals || !rec.vals[index]) return "";
    return rec.vals.length !== 0 && rec.vals[index].text ? rec.vals[index].text : "";
  };

  me.getFieldTextSync = function (fieldName, recordIndex) {
    const index = me.getFieldIndex(fieldName);
    const localRecordIndex = recordIndex ?? me.activeRecord;
    let rec = "";
    if (index == -1) {
      return "";
    }
    if (editRec) {
      if (editRec.index === localRecordIndex) rec = editRec;
      if (editRec.insert && localRecordIndex > editRec.index) {
        rec = points.get(localRecordIndex - 1);
      }
    } else {
      rec = points.get(localRecordIndex);
    }
    if (!rec || !rec.vals || !rec.vals[index]) return "";
    return rec.vals[index].text || "";
  };

  me.getFieldValueSync = function (fieldName, recordIndex) {
    const index = me.getFieldIndex(fieldName);
    let rec = "";
    const localRecordIndex = recordIndex ?? me.activeRecord;
    if (index == -1) {
      return "";
    }
    if (editRec) {
      if (editRec.index === localRecordIndex) rec = editRec;
      if (editRec.insert && localRecordIndex > editRec.index) {
        rec = points.get(localRecordIndex - 1);
      }
    } else {
      rec = points.get(localRecordIndex);
    }
    if (!rec || !rec.vals || !rec.vals[index]) return "";
    return rec.vals[index].id || "";
  };

  me.findField = function (fieldName) {
    let isExits = false;
    me.fields.filter((fieldInfo) => {
      if (fieldInfo.fieldName === fieldName) isExits = true;
    });
    return isExits;
  };

  me.setFieldText = async function (fieldName, value, index) {
    const rec = await getRecordNode(index || me.activeRecord);
    if (rec) {
      const index = me.getFieldIndex(fieldName);
      if (index !== -1) {
        while (rec.vals.length <= index) rec.vals.push({});
        const v = rec.vals[index];
        v.text = value;
      }
      me.setFieldModified(fieldName, true);
      me.modified = true;
    }
  };

  me.setFieldValue = async function (fieldName, value, index) {
    const rec = await getRecordNode(index || me.activeRecord);
    if (rec) {
      const index = me.getFieldIndex(fieldName);
      if (index !== -1) {
        while (rec.vals.length <= index) rec.vals.push({});
        const v = rec.vals[index];
        v.id = value;
      }
      me.setFieldModified(fieldName, true);
    }
  };

  me.getFieldValue = async function (fieldName, recordIndex) {
    const index = me.getFieldIndex(fieldName);

    if (index == -1) {
      return "";
    }

    const rec = await getRecordNode(recordIndex ?? me.activeRecord);

    if (!rec || !rec.vals || !rec.vals[index]) return;
    return (rec.vals.length !== 0 && rec.vals[index]?.id) || undefined;
  };

  /**
   * Устанавливает текст записи для указанного индекса.
   * @param {string} text - Новый текст записи.
   * @param {number} [index=me.activeRecord] - Индекс записи, для которой необходимо обновить текст. По умолчанию использует значение `me.activeRecord`.
   * @returns {Promise<void>} - Promise, который разрешается после выполнения обновления.
   */
  me.setRecordText = async function (text, index = me.activeRecord) {
    const rec = await getRecordNode(index);
    if (rec?.info) rec.info.recordText = text;
  };

  me.getActiveRecordText = async function () {
    const rec = await getRecordNode(me.activeRecord);
    return { text: rec.info.recordText, id: me.activeRecord };
  };

  // me.setActiveRecordText = function (id, text) {
  //   const rec = getRecordNode(id);
  //   rec.info.recordText = text;
  // };

  // me.searchRecord = function (objref) {
  //   for (let i = 0; i < this.recordCount; i++) {
  //     const rec = getRecordNode(i);
  //     if (rec !== undefined && rec.vals[1].id == objref) return i;
  //   }
  //   return 0;
  // };

  me.moveBy = function (distance) {
    checkScrollRecord();
    me.activeRecord += distance;
    if (me.activeRecord < 0) me.first();
    else if (me.activeRecord >= me.recordCount) me.last();
    else recordIndexChanged();
  };

  me.first = function () {
    me.activeRecord = 0;
    bof = true;
    eof = me.recordCount == 0;
    recordIndexChanged();
  };

  me.last = function () {
    me.activeRecord = maxint(0, me.recordCount - 1);
    eof = true;
    bof = me.recordCount == 0;
    recordIndexChanged();
  };

  me.setRecordIndex = function (value) {
    me.activeRecord = value;
    this.moveBy(0);
  };

  /**
   * Возвращает индекс поля по имени.
   * В зависимости от настроек чувствительности к регистру (`me.caseSensitive`),
   * поиск выполняется либо с учетом регистра, либо без.
   * @param {string} fieldName - Название поля для поиска.
   * @returns {number} Индекс найденного поля в массиве me.fields, или -1, если поле не найдено.
   */
  me.getFieldIndex = function (fieldName) {
    if (me.caseSensitive) {
      return me.fields.findIndex((el) => el.fieldName === fieldName);
    }
    const lowerFieldName = fieldName.toLowerCase();
    return me.fields.findIndex((el) => el.fieldName.toLowerCase() === lowerFieldName);
  };

  me.orderRecords = function (indexFieldNames, selection) {
    return new Promise(async (resolve) => {
      const request = { command: "SortRecords" };
      if (indexFieldNames) {
        request.fields = indexFieldNames;
        request.recordIndex = me.activeRecord;
      }
      if (selection) request.selection = selection.value;
      const json = await handleRequest(request, true);
      if (json) {
        recordIndex = -1;
        points.clear();
        if (editRec) {
          editRec = null;
          recordStateChanged();
        }
        if (json.RecordIndex) me.activeRecord = parseInt(json.RecordIndex);
        if (selection && json.Selection) selection.value = json.Selection;
        await recordIndexChanged();
      }
      return resolve(json.Selection);
    });
  };

  me.SearchRecord = async function (fieldName, text, recordIndex) {
    const request = { command: "SearchRecord", RecordIndex: recordIndex !== undefined ? recordIndex : me.activeRecord };
    if (fieldName) request.FieldName = fieldName;
    if (text) request.Text = text;
    const json = await handleRequest(request, false);
    if (json) {
      if (editRec) {
        editRec = null;
      }
      return parseInt(json.RecordIndex) === -1 ? 0 : parseInt(json.RecordIndex);
    }
  };

  me.groupRecords = function (groupFieldNames) {
    return new Promise(async (resolve) => {
      const request = { command: "GroupRecords", fields: groupFieldNames, recordIndex: me.activeRecord };
      const json = await handleRequest(request, true);
      if (json) {
        recordIndex = -1;
        points.clear();
        if (editRec) {
          editRec = null;
          recordStateChanged();
        }
        if (json.RecordIndex) me.activeRecord = parseInt(json.RecordIndex);
        if (json.RecordCount) me.recordCount = parseInt(json.RecordCount);
        await recordIndexChanged();
      }
      resolve();
    });
  };

  me.collapseGroup = function (collapse) {
    return new Promise(async (resolve) => {
      const request = { command: "CollapseGroup", recordIndex: me.activeRecord, collapsed: collapse ? 1 : 0 };
      const json = await handleRequest(request, false);
      if (json) {
        recordIndex = -1;
        points.clear();
        if (editRec) {
          editRec = null;
          recordStateChanged();
        }
        if (json.RecordIndex) me.activeRecord = parseInt(json.RecordIndex);
        if (json.RecordCount) me.recordCount = parseInt(json.RecordCount);
        await recordIndexChanged();
      }
      resolve();
    });
  };

  me.getGroupRecord = function () {
    return new Promise(async (resolve) => {
      const request = { command: "GetRecordGroup", recordIndex: me.activeRecord };
      let subParams;
      if (me.CreateCollapsibleRecords !== null)
        subParams = {
          Key: await me.getFieldText(keyFieldName || "ID"),
          RecordIndex: me.activeRecord,
          comand: "GetRecordGroup",
        };
      const json = await handleRequest(request, true, undefined, subParams);
      if (json) {
        if (json.RecordIndex) {
          return resolve(parseInt(json.RecordIndex));
        }
      }
      return resolve(-1);
    });
  };

  me.applyFieldFilter = function (filter) {
    return new Promise(async (resolve) => {
      const request = { command: "ApplyFilter", recordIndex: me.activeRecord, fields: filter };
      const json = await handleRequest(request, true);
      if (json) {
        recordIndex = -1;
        points.clear();
        if (editRec) {
          editRec = null;
          recordStateChanged();
        }
        if (json.RecordIndex) me.activeRecord = parseInt(json.RecordIndex);
        if (json.RecordCount) me.recordCount = parseInt(json.RecordCount);
        else me.recordCount = 0;
        await recordIndexChanged();
      }
      resolve();
    });
  };

  me.checkActive = function (activate) {
    if (!me.active && activate) {
      if (me.fields.length == 0) {
        acquireFields();
        me.defaultFields = me.fields.length > 0;
      }
      me.active = true;
      recordIndex = -1;
      sourceStateChanged();
    }
    return me.active;
  };

  me.isEmpty = function () {
    return me.recordCount == 0;
  };

  me.insertRecord = async function (down, info, subData) {
    if (await createNewRecord(info, subData)) {
      // me.ChangeSave(true);
      if (down && me.recordCount > 0) me.activeRecord++;
      editRec.index = me.activeRecord;
      me.recordCount++;
      recordIndex = -1;
      await recordIndexChanged();
    }
  };

  me.appendRecord = async function () {
    if (await createNewRecord()) {
      me.ChangeSave(true);
      me.activeRecord = me.recordCount;
      editRec.index = me.activeRecord;
      me.recordCount++;
      recordIndex = -1;
      await recordIndexChanged();
    }
  };

  me.editRecord = async function (recordIndex) {
    if (me.recordCount === 0) {
      await me.appendRecord();
    } else {
      if (!editRec) {
        const rec = await getRecordNode(recordIndex || me.activeRecord);
        if (rec) {
          editRec = { vals: [], info: {} };
          editRec.insert = false;
          editRec.active = recordIndex || me.activeRecord;
          editRec.index = recordIndex || me.activeRecord;
          loadRecordValues(editRec, rec, me.fields);
        }
      }
    }
  };

  me.CheckFieldText = function (field, objRef, text) {
    const request = { command: "CheckFieldText", RecordIndex: me.activeRecord, FieldName: field, ObjRef: objRef };
    if (text) request.text = text;
    return handleRequest(request, false).then((json) => {
      return json;
    });
  };

  me.GetFieldTextRequest = async function (flag, field) {
    const request = { command: "GetFieldText", RecordIndex: me.activeRecord, FieldName: field, ForEdit: flag };
    return handleRequest(request, false).then((res) => {
      return res;
    });
  };

  me.deleteRecord = async function (index) {
    checkRecordUpdates();
    const request = { Command: "DeleteRecord", RecordIndex: index !== undefined ? index : me.activeRecord };
    if (keyFieldName !== "") request.RecordKey = await me.getFieldText(keyFieldName, index);
    const json = await handleRequest(request, true);
    if (json) {
      points.clear();
      if (json.RecordCount) me.recordCount = parseInt(json.RecordCount);
      if (me.recordCount > 0 && json.RecordIndex) me.activeRecord = parseInt(json.RecordIndex);
      else me.activeRecord = 0;
      me.moveBy(0);
      recordStateChanged();
    }
  };

  me.postRecord = function (index) {
    return new Promise(async (resolve) => {
      const postProcessing = async (json) => {
        points.clear();
        editRec = null;
        if (json.RecordCount) me.recordCount = parseInt(json.RecordCount);
        if (json.RecordIndex !== undefined) me.activeRecord = parseInt(json.RecordIndex);
        else me.activeRecord = 0;
        me.modified = false;
        await dataChanged();
        recordStateChanged();

        await this.Master.refreshRecord?.();
        changes = [];
        resolve();
      };

      if (editRec) {
        checkRecordUpdates();
        // let fieldName;
        const request = {
          Command: "PostRecord",
          RecordIndex: index || editRec.index || me.activeRecord,
          RecordSet: { Attributes: [], Records: { Record: {} } },
        };
        if (me.getState() === dsInsert) request.NewRecord = "1";
        else if (keyFieldName !== "") request.RecordKey = await me.getFieldText(keyFieldName, request.RecordIndex);
        const fields = request.RecordSet.Attributes;
        if (editRec.insert) {
          for (let i = 0; i < editRec.vals.length; i++) {
            // fieldName = editRec.vals[i];
            if (fieldHasData(me.fields[i].fieldName)) {
              // todo
              fields.push(me.fields[i].fieldName);
            }
          }
        } else {
          for (let i = 0; i < changes.length; i++) {
            fields.push(changes[i]);
          }
        }
        const rec = { $Data: [] };
        saveRecordValues(editRec, rec, fields);
        request.RecordSet.Records.Record = rec;
        const json = await handleRequest(request, false, true);
        if (json && !isEmptyObject(json)) {
          if (json.Token) {
            tokenProcessingTest(json, {
              from: "grid",
              func: async () => {
                await postProcessing(json);
              },
            });
          } else {
            await postProcessing(json);
          }
        } else {
          await me.cancelRecord();
          changes = [];
          resolve();
        }

        // me.CommitToSaveChanges(false);
      }
    });
  };

  me.refreshRecord = async function () {
    const rec = await getRecordNode(me.activeRecord);
    if (rec) {
      const request = { Command: "RefreshRecord", First: me.activeRecord, Count: 1 };
      if (keyFieldName) {
        request.RecordKey = await me.getFieldText(keyFieldName);
      }
      const json = await handleRequest(request);
      if (json && json.RecordSet) {
        const fields = json.RecordSet.Attributes;
        if (fields) {
          const records = json.RecordSet.Records[0];
          loadRecordValues(rec, records, fields);
          points.set(me.activeRecord, rec);
        }
      }
    }
  };

  me.cancelRecord = function (needToChangeActive) {
    return new Promise(async (resolve) => {
      if (editRec) {
        if (editRec.insert) {
          if (editRec.active !== undefined && needToChangeActive !== false) me.activeRecord = editRec.active;
          me.recordCount--;
          if (needToChangeActive !== false) me.moveBy(0);
        }
        editRec = null;
        recordStateChanged();
      }
      me.modified = false;
      resolve();
    });
  };

  me.isEditMode = function () {
    const state = me.getState();
    return state === dsEdit || state === dsInsert;
  };

  me.isEditModeState = function () {
    return me.getState();
  };

  me.getState = function () {
    if (me.active) {
      if (editRec) {
        if (editRec.insert) return dsInsert;
        else return dsEdit;
      }
      return dsBrowse;
    }
    return dsInactive;
  };

  me.getFieldModified = function (fieldName) {
    return changes.indexOf(fieldName) !== -1;
  };

  me.setFieldModified = function (fieldName, value) {
    const index = changes.indexOf(fieldName);
    if (index === -1) {
      if (value) changes.push(fieldName);
    } else if (!value) changes.splice(index, 1);
  };

  me.getUpdateStatus = async function (index) {
    return getRecordNode(index).then((rec) => {
      if (rec && rec.info && rec.info.updateStatus) {
        return rec.info.updateStatus;
      }
      return usUnmodified;
    });
  };

  return me;
}

function createScrollbar(view, scrollView, event) {
  this.view = view;
  const containerForScrollElements = '<div id="scrollArrows" class="lazy-scroll-arrows">';
  const scrollHtml = `
      <button class="lazy-scroll-arrow-up">&#9650;</button>
      <div class="lazy-scroll"></div>
      <button class="lazy-scroll-arrow-down">&#9660;</button>
    `;
  view.insertAdjacentHTML("beforeend", containerForScrollElements);
  const scrollContainer = view.querySelector(".lazy-scroll-arrows");
  scrollContainer.insertAdjacentHTML("beforeend", scrollHtml);

  const barContainer = view.lastChild;
  const bar = barContainer.childNodes[3];
  bar.style.zIndex = 2;

  let lastPageY,
    scrollTop = 0,
    maxScroll = 0,
    timeOut;

  const upArrow = barContainer.childNodes[1];
  const downArrow = barContainer.childNodes[5];

  let scrollInterval = null;
  let isScrolling = false;
  let scrollDirection = 0;
  let isMouseDown = false;

  function startSmoothScroll(direction) {
    if (isScrolling && scrollDirection === direction) return;
    stopSmoothScroll();
    scrollDirection = direction;
    isScrolling = true;

    scrollView(scrollDirection, false);

    let drawing = false;

    scrollInterval = setInterval(() => {
      if (!drawing) {
        drawing = true;
        scrollView(scrollDirection, false).then(() => {
          drawing = false;
        });
      }
    }, 100);
  }

  function stopSmoothScroll() {
    if (scrollInterval) {
      clearInterval(scrollInterval);
      scrollInterval = null;
    }
    isScrolling = false;
    scrollDirection = 0;
  }

  function handleMouseDown(direction, e) {
    if (!isMouseDown) {
      e.preventDefault();
      e.stopPropagation();
      isMouseDown = true;
      startSmoothScroll(direction);
    }
  }

  function handleMouseUp() {
    if (isMouseDown) {
      isMouseDown = false;
      stopSmoothScroll();
    }
  }

  upArrow.addEventListener("mousedown", (e) => handleMouseDown(-1, e));
  downArrow.addEventListener("mousedown", (e) => handleMouseDown(1, e));

  upArrow.addEventListener("mouseleave", () => {
    if (isMouseDown) handleMouseUp();
  });
  upArrow.addEventListener("mouseup", () => {
    if (isMouseDown) handleMouseUp();
  });
  downArrow.addEventListener("mouseleave", () => {
    if (isMouseDown) handleMouseUp();
  });
  downArrow.addEventListener("mouseup", () => {
    if (isMouseDown) handleMouseUp();
  });

  appendEvent(
    "mousedown",
    function (e) {
      lastPageY = e.pageY;

      appendEvent("mousemove", drag);
      appendEvent("mouseup", stop);

      return false;
    },
    bar,
  );

  function drag(e) {
    if (true) {
      scrollTop += e.pageY - lastPageY;
      lastPageY = e.pageY;
      scrollTop = midint(0, maxScroll, scrollTop);
      bar.style.top = scrollTop + "px";

      if (event) {
        clearTimeout(timeOut);
        timeOut = setTimeout(() => {
          queuedGridScroll.scrollGrid(scrollTop / maxScroll, event);
        }, 300);
      }
    }
  }

  function stop() {
    deleteEvent("mousemove", drag);
    deleteEvent("mouseup", stop);
  }

  this.updateBar = function (visibleRows, recordCount, scrollPos) {
    const scrollRatio = visibleRows / recordCount;

    if (scrollRatio < 1) {
      let top;
      const totalSize = this.view.getBoundingClientRect().height,
        right = (this.view.clientWidth - bar.clientWidth - 50) * -1,
        height = Math.max(scrollRatio * 100, 5),
        barSize = (totalSize / 100) * height;
      maxScroll = totalSize - barSize - 45;
      if (scrollPos != undefined) {
        scrollTop = (maxScroll / (recordCount - visibleRows)) * scrollPos;
        top = scrollTop + "px";
      } else top = bar.style.top;
      if (!top) {
        top = "0px";
      }
      bar.style.cssText = "height:" + height + "%; top: " + top + ";right:" + right + "px";
      showElement(bar);
      showElement(upArrow);
      showElement(downArrow);
    } else {
      hideElement(bar);
      hideElement(upArrow);
      hideElement(downArrow);
    }
  };

  return this;
}

export const nfStateChanged = "StateChanged",
  mfInsert = 0,
  mfEdit = 1,
  mfDelete = 2,
  mfPaste = 3,
  mfView = 4;

export function createGrid(panel) {
  const // константы
    REGION_GROUP = "group",
    REGION_TITLE = "title",
    REGION_DATUM = "datum",
    ROLE_COLUMN = "column",
    ROLE_COLDATA = "col-data",
    ROLE_CHECKBOX = "check-box",
    ROLE_COLLAPSE = "collapse",
    ROLE_GROUP = "group",
    ROLE_FILTER = "filter",
    ROLE_MARKED = "marked",
    ROLE_COLLAPSE_GROUP = "collapsegroup",
    GRID_BACKGROUND = "var(--indicatorColor)",
    INDICATOR_IMAGE_ONLYVIEW =
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAANCAYAAACUwi84AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAABVSURBVChThdG7DcAgEATRs0sgd0j/BTkkpwWbOQnEZ7EnAKF9GcdTso9OjnxFf6gc0A41QAoNgGa0AOqRBFTRFoR0+y1BHWkB/UgDmEdqQI308xdmL4bnGEE5vnElAAAAAElFTkSuQmCC",
    INDICATOR_IMAGE_BROWSE = // плюс
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAANCAYAAACUwi84AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAzSURBVChTY2AgEvwnpA6kAK8imAKcipAVYFWErgBDETYFKIpINgHD10T7Amd4EQxJnDoBZO8j3Xd97XYAAAAASUVORK5CYII=",
    INDICATOR_IMAGE_EDITING =
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAANCAYAAACUwi84AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAgSURBVChTY2AgEvwHqgNhGEDnE5YgqHOEKCA6JDFiBgCPRhnnsmWU1gAAAABJRU5ErkJggg==",
    INDICATOR_IMAGE_INSERTED = //синий плюс
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAANCAYAAACUwi84AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAsSURBVChTY2CgMvj/n4EBhHEC8hTAdOGiwXbiwyjuIc8NyEYQNIHKwQo2DgAiSzfJCmFmxgAAAABJRU5ErkJggg==",
    INDICATOR_IMAGE_MODIFIED =
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAANCAYAAACUwi84AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAA3SURBVChTY2AgHvz/z8AAw1h10VgBsvEY7sAmCRKDA3TH4fQJTBeKbnT/IktiVYjXFIIBhT1SAGnISbdGg+UeAAAAAElFTkSuQmCC",
    INDICATOR_IMAGE_NEW = // звезда
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAA5SURBVBhXY/wPBAx4ABNMjpGREa4MhY1sAkwC2VBGkAJkHci2gRSCFaBbg2wCihtAEmBdyO4h5AsAEQoi/Ix3kjkAAAAASUVORK5CYII=",
    INDICATOR_IMAGE_UPDATED =
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAANCAYAAACUwi84AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAA3SURBVChTY2AgBth7nPmPVx1IAV5FMAU4FSErwKoIXQGGImwKUBSRbAKGl4n2Bc7AIhiS+IIZABZaU4nPjT65AAAAAElFTkSuQmCC",
    INDICATOR_IMAGE_DELETED =
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGHaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8P3hwYWNrZXQgYmVnaW49J++7vycgaWQ9J1c1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCc/Pg0KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyI+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIj48dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCjw/eHBhY2tldCBlbmQ9J3cnPz4slJgLAAAANUlEQVRoQ+3PMQoAIAwEwcT//zmWQrAP4ky51V0EAAAAwITs4ajqZVZet64eXuMAAAAAwJ82ooMCCOHHaAUAAAAASUVORK5CYII=";

  let // размеры и прочее
    titleSize = 24,
    rowHeight = 24,
    indicatorSize = 42,
    groupSize = 0,
    groups = [],
    showIndicator = true,
    filterSize = 0,
    visibleRows = 0,
    firstRecord = 0,
    overflowColumns = false,
    rightOverflow = false,
    leftRightMover = null,
    columnOffset = 0,
    currentRow = 0,
    currentCol = 0,
    childColumnSize = 24,
    isJustMouseDown = false,
    viewInfo = { horizontal: false, saveSource: null, saveColumns: null },
    assignBMList = [],
    selectedField = undefined,
    editor = null,
    inputEditor = null,
    indicator = null,
    imageFields = [],
    multiSelect = [],
    gridItemClassName = "grid-item-outline-selected",
    sortedFileds = "",
    fixedColumn = null,
    constOptions = {
      filter: 1,
      groupBy: 2,
      showIndicator: 4,
    },
    filterData = {},
    userOS = "",
    canRotate = true;

  const me = this;
  /** @type {HTMLDivElement | undefined} */
  let sizeMarker;
  /** @type {HTMLDivElement | undefined} */
  let dragZone;
  let handleColumnField;

  me.columns = { title: [] };
  me.OnlyViewMode = false;
  me.BkClrField = undefined;
  me.ColorField = undefined;
  me.StyleField = undefined;
  me.doccfgid = undefined;
  me.gridState = "";
  me.defaultColumns = false;
  /**
   * @type {createRecordSource | undefined}
   */
  me.source = undefined;

  me.MultiCLsSelect = null;
  me.ClsSelection = {};

  /**
   * Кастомная функция, которая вызывается вместо стандартного удаления.
   * @type {((index: string | number | undefined, grid: createGrid) => (void | Promise<void>)) | undefined}
   */
  me.onDeleteRecord = undefined;

  /**
   * @type {((grid: createGrid) => void) | undefined}
   */
  me.onRecordCountChange = undefined;

  /**
   * @type {((grid: createGrid) => (void | Promise<void>)) | undefined}
   */
  me.onMultiSelectChange = undefined;

  /**
   * @type {(() => void | Promise<void>) | undefined}
   */
  me.onColumnWidthChange = undefined;

  /**
   * @type {((oldIndex: number, newIndex: number) => void | Promise<void>) | undefined}
   */
  me.onColumnOrderChange = undefined;

  /**
   * @type {((groups: any) => void | Promise<void>) | undefined}
   */
  me.onRowGroupingChange = undefined;

  const updateGridSelectedClass = () => {
    const { gridSelectedRecordColor } = getOptionsForUser();
    gridItemClassName = gridSelectedRecordColor ? "grid-item-outline-selected-bg" : "grid-item-outline-selected";
    if (viewInfo.horizontal) gridItemClassName = "grid-card-selected";
  };

  me.setSource = function (source, clearMultiSelect) {
    if (!userOS) userOS = smetaStore.get(systemInfoAtom).os;
    if (me.source != source) {
      if (me.defaultColumns) me.columns = {};
    }
    me.source = source;
    me.setSourceLoad = true;
    return new Promise(async (resolve) => {
      if (source.active === false) await source.open();
      if (source) {
        if (me.source && me.defaultColumns) {
          me.columns.fields = [];
          me.columns.levels = [];
          me.columns.title = [];
          const fields = me.source.fields;
          for (let i = 0; i < fields.length; i++) {
            const f = fields[i];
            me.columns.title.push({
              fieldName: f.fieldName,
              title: f.displayLabel,
              width: f.displayWidth * 11,
              level: 0,
            });
          }
          prepareLevels();
        }
        if (clearMultiSelect !== false) multiSelect = [];
        currentRow = me.source.activeRecord;
        prepareLevels();
        zaglushka();
        buildColumns();
        // buildGroups();
        buildGroupsContent();
        // showApplicationMask(panel);
        await queuedGridScroll.scrollGrid(undefined, buildRecords);

        // hideApplicationMask(panel)

        me.setSourceLoad = false;
      }
      resolve();
    });
  };

  me.canGroup = function (field) {
    return field.fieldInfo?.options?.group;
  };

  me.canSort = function (field) {
    return field.fieldInfo?.options?.sort;
  };

  me.canModify = function (flag, column, me) {
    return me.localCanModify(flag, column, me);
  };

  me.setFilterData = function (data) {
    filterData = data;
    saveState();
  };

  me.getFilterData = function () {
    return filterData;
  };

  me.changeIndicator = changeIndicator;

  me.localCanModify = function (flag, column, me) {
    // значение возможности редактирования по умолчанию
    const isEmptySource = me.getActiveSource().recordCount === 0;
    if (me.OnlyViewMode || ((flag === mfEdit || flag === mfDelete) && isEmptySource)) return false;
    // разрешения на основе флага и прав
    switch (flag) {
      case mfInsert:
        return me.getActiveSource().rights.insert;
      case mfEdit:
        return me.getActiveSource().rights.modify;
      case mfDelete:
        return me.getActiveSource().rights.delete;
    }
    return false;
  };

  me.insertRecord = async function (down, info, subData) {
    const source = me.getActiveSource();
    if (source && source.active && source.getState() !== dsInsert && (await me.canModify(mfInsert, undefined, me))) {
      await source.insertRecord(down, info, subData);
      await updateRecordTable();
      await scrollToRecord(source.activeRecord, true);
      await changeIndicator(dsInsert);
      me.CommitToSaveChanges?.(me);
      if (viewInfo.horizontal) updateCard();
      // zaglushka();
    }
  };

  me.appendRecord = async function () {
    const source = me.getActiveSource();
    if (source && source.active && source.getState() !== dsInsert && (await me.canModify(mfInsert, undefined, me))) {
      await source.appendRecord();
      await me.postExicstedEditRec();
      await updateRecordTable();

      // await scrollToRecord(source.activeRecord, true);
      // indicator.setAttribute("src", INDICATOR_IMAGE_BROWSE);
    }
  };

  me.postRecord = async function (index) {
    if (sourceActive()) {
      await setColumnText(editor.column, editor.content);
      if (editor.objref) await setColumnValue(editor.column, editor.objref);
      await me.source.postRecord(index);
      const source = this.getActiveSource();
      if (source !== me.source && source.isEditMode()) {
        await source.postRecord();
        // await me.source.acquireRecords(0, me.source.recordCount - 1);
      }
      await updateRecordTable(true);
      scrollToRecord(me.source.activeRecord, true);
    }
  };

  me.cancelRecord = async function (needToChangeActive) {
    async function cancelSource(source) {
      const b = source && source.active && source.isEditMode();
      if (b) await source.cancelRecord(needToChangeActive);
    }

    await cancelSource(me.source);
    if (viewInfo.horizontal) await cancelSource(viewInfo.saveSource);

    await scrollToRecord(me.source.activeRecord, true);
    await updateRecordTable(true);

    if (me.editorMode()) {
      await hideEditor();
      //todo
    }
    await me.CommitToSaveChanges?.(false);
    await changeIndicator(dsBrowse);
    // zaglushka();
  };

  me.editorMode = function () {
    if (editor) return editor.visible;
  };

  me.switchFilter = null;

  /**
   * @returns {createRecordSource}
   */
  me.getActiveSource = function () {
    if (viewInfo.horizontal) return viewInfo.saveSource;
    return me.source;
  };

  me.applyColumnFilter = async (filter) => {
    const data = getFilterContent(filter);
    await me.source.applyFieldFilter(data);
    await updateRecordTable();
    saveState();
    await scrollToRecord(me.source.activeRecord, true);
    me.onMultiSelectChange?.(me);
  };

  me.clearAllFilters = async () => {
    me?.setFilterData({});
    await me?.applyColumnFilter({});
    if (me.filter?.style?.display === "grid") {
      showFilter();
    }
    await me?.refreshSource("!");
  };

  me.getCurrentFieldName = function () {
    const td = panel.querySelector(".grid-item-focused");
    return td?.field?.fieldName || "";
  };

  const getFilterContent = (data) => {
    const res = {};
    Object.entries(data).forEach(([key, value]) => {
      if (!value["$tag"] && !isEmptyObject(value)) {
        res[`$${key}`] = value;
      } else res[key] = value;
    });
    return res;
  };

  function sourceActive() {
    return me.source != undefined && me.source != null && me.source.active;
  }

  function getPointRegion(x, y) {
    const checkElement = (el) => {
      const r = el.getBoundingClientRect();
      return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
    };

    if (checkElement(me.header)) {
      return REGION_TITLE;
    }
    if (checkElement(me.table)) {
      return REGION_DATUM;
    }
    if (checkElement(me.groups)) {
      return REGION_GROUP;
    }
  }

  /**
   * @param {MouseEvent} e
   */
  function sizeColumn(e) {
    const x = e.x - panel.getBoundingClientRect().x;
    if (x > handleColumnField.offset && x < panel.clientWidth) {
      sizeMarker.style.left = x + "px";
      handleColumnField.eventSize = x;
    }
  }

  function autoFitColumnWidth(f) {
    if (!f) return;
    let maxWidth = 0;
    const textCol = document.createElement("span");
    textCol.className = "grid-cell-inner";
    textCol.style.visibility = "hidden";
    textCol.style.position = "absolute";
    textCol.style.whiteSpace = "nowrap";
    document.body.appendChild(textCol);
    for (let i = 0; i < visibleRows; i++) {
      const row = getRowElement(i);
      const cells = row.getElementsByClassName("grid-td");
      let value = "";
      for (let j = 0; j < cells.length; j++) {
        if (cells[j].field.fieldName === f.fieldName) {
          const cell = cells[j].firstChild;
          if (cell) value = cell.textContent;
          break;
        }
      }
      textCol.textContent = value;
      const width = textCol.offsetWidth;
      if (width > maxWidth) {
        maxWidth = width;
      }
    }
    document.body.removeChild(textCol);
    f.width = maxWidth + 5;
    updateColumns();
    if (sizeMarker) sizeMarker.style.opacity = "0";
  }

  function getFieldAtPoint(x, y, info) {
    let checkMargin = 0;

    function checkColumn(level, colLeft, colTop, width, height) {
      if (level.items && level.expanded) {
        width.value = 0;
        height = childColumnSize;
        for (let i = 0, l, f, field, left = colLeft, w; i < level.items.length; i++) {
          l = level.items[i];
          f = l.field;
          w = { value: f.width };
          field = checkColumn(l, left, colTop + childColumnSize, w, childColumnSize);
          if (checkMargin == 0) {
            if (field) return field;
            left += w.value;
            width.value += w.value;
          } else checkMargin--;
        }
      }
      if (intInRange(x, colLeft, colLeft + width.value) && intInRange(y, colTop, colTop + height)) {
        return level.field;
      }
      return null;
    }

    const r = getPointRegion(x, y);
    if (info) info.region = r;
    switch (r) {
      case REGION_TITLE: {
        const r = me.header.getBoundingClientRect();
        let leftModal = 0,
          topModal = 0;
        const isModalWindow = me.panel.closest(".smart-window");
        if (isModalWindow && isModalWindow.style) {
          leftModal = Number(isModalWindow.style.left.replace("px", ""));
          topModal = Number(isModalWindow.style.top.replace("px", ""));
        }
        for (
          let levels = me.header.children,
            i = 1,
            left = r.left - leftModal,
            top = r.top - topModal,
            width,
            level,
            field;
          i < levels.length;
          i++
        ) {
          level = levels[i].level;
          width = { value: level.field.width };
          field = checkColumn(levels[i].level, left, top, width, titleSize);
          if (checkMargin == 0) {
            if (field) return field;
            left += width.value;
          } else checkMargin--;
        }
        return me.columns.stubField;
      }
      case REGION_GROUP: {
        let rect = me.groups.getBoundingClientRect(),
          left = rect.left,
          top = rect.top,
          bottom = rect.bottom;
        for (let i = 0, el; i < me.groups.childElementCount; i++) {
          el = me.groups.children[i];
          rect = el.getBoundingClientRect();
          if (intInRange(x, rect.left, rect.right)) {
            if (info) {
              info.left = rect.left;
              info.top = rect.top;
              info.bottom = rect.bottom;
            }
            return el.field;
          }
          left = rect.right;
          top = rect.top;
          bottom = rect.bottom;
        }
        if (info) {
          info.left = left;
          info.top = top;
          info.bottom = bottom;
        }
        return null;
      }
    }
    return null;
  }

  function getFieldColumnRect(field) {
    const rect = me.header.getBoundingClientRect();
    return {
      left: field.offset + rect.left,
      top: rect.top + field.top,
      right: field.offset + field.width,
      bottom: rect.bottom,
    };
  }

  function moveColumn(e) {
    if (!isJustMouseDown) {
      isJustMouseDown = true;
      return;
    }

    if (!dragZone) {
      dragZone = document.createElement("div");
      dragZone.classList.add("grid-column");
      dragZone.classList.add("grid-drag-zone");
      dragZone.style.pointerEvents = "none";
      panel.appendChild(dragZone);
      dragZone.moveTop = document.createElement("div");
      dragZone.moveTop.className = "col-move-top";
      dragZone.moveTop.style.display = "none";
      panel.appendChild(dragZone.moveTop);
      dragZone.moveBottom = document.createElement("div");
      dragZone.moveBottom.className = "col-move-bottom";
      dragZone.moveBottom.style.display = "none";
      panel.appendChild(dragZone.moveBottom);
    }
    if (!dragZone.initRect) {
      if (handleColumnField.groupEl) dragZone.initRect = handleColumnField.groupEl.getBoundingClientRect();
      else dragZone.initRect = handleColumnField.el.getBoundingClientRect();
      dragZone.deltaX = e.x - dragZone.initRect.left;
      dragZone.deltaY = e.y - dragZone.initRect.top;
      dragZone.style.display = "";
      dragZone.style.height = dragZone.initRect.height + "px";
      dragZone.style.width = dragZone.initRect.width + "px";
      dragZone.style.left = dragZone.initRect.left + "px";
      dragZone.style.top = dragZone.initRect.top + "px";
      dragZone.style.width = dragZone.initRect.width + "px";
      dragZone.style.height = dragZone.initRect.height + "px";
      dragZone.textContent = handleColumnField.title;
      dragZone.style.display = "";
    }
    const x = e.x - dragZone.deltaX,
      y = e.y - dragZone.deltaY;
    dragZone.style.left = x + "px";
    dragZone.style.top = y + "px";
    const info = {},
      field = getFieldAtPoint(x + 5, y + 5, info);
    if (info.region == REGION_GROUP && me.canGroup(handleColumnField)) {
      dragZone.moveTop.style.left = info.left - 5 + "px";
      dragZone.moveTop.style.top = info.top - dragZone.moveTop.getBoundingClientRect().height + "px";
      dragZone.moveBottom.style.left = info.left - 5 + "px";
      dragZone.moveBottom.style.top = info.bottom + "px";
      showElement(dragZone.moveTop);
      showElement(dragZone.moveBottom);
      dragZone.field = field;
      dragZone.isGroup = true;
      return;
    }
    if (field != null && (field != handleColumnField || field.groupEl) && field.parent == handleColumnField.parent) {
      const rect = getFieldColumnRect(field);
      dragZone.moveTop.style.left = rect.left + "px";
      dragZone.moveTop.style.top = rect.top - dragZone.moveTop.getBoundingClientRect().height + "px";
      dragZone.moveBottom.style.left = rect.left + "px";
      dragZone.moveBottom.style.top = rect.bottom + "px";
      showElement(dragZone.moveTop);
      showElement(dragZone.moveBottom);
      dragZone.field = field;
      dragZone.isGroup = false;
    } else {
      hideElement(dragZone.moveTop);
      hideElement(dragZone.moveBottom);
      dragZone.field = null;
    }
  }

  async function updateColumns() {
    buildColumns();
    await queuedGridScroll.scrollGrid(undefined, buildRecords);
    updateScrollBar();
    updateFilters();
    zaglushka();
    if (me.editorMode()) {
      await showEditor();
    }
  }

  function updateScrollBar() {
    if (me.source) {
      me.scrollBar.updateBar(visibleRows, me.source.recordCount, firstRecord);
    } else {
      me.scrollBar.updateBar(0, 0, 0);
    }
  }

  async function getRecordState() {
    if (sourceActive()) {
      return await me.source.getRecordState();
    }
    return 0;
  }

  async function getLevelOffset() {
    if (!sourceActive()) return 0;

    const level = await me.source.getRecordLevel();
    return level * 15;
  }

  async function isGroupRecord(checkView) {
    if (groups.length > 0) {
      if (checkView && viewInfo.horizontal) {
        return false;
      }

      if (((await getRecordState()) & STATUS_GROUPED) != 0) {
        return true;
      }
    }
    return false;
  }

  async function getRecordCollapsed() {
    return ((await getRecordState()) & STATUS_COLLAPSED) != 0;
  }

  async function setRecordCollapsed(collapse) {
    if (sourceActive()) {
      await me.source.collapseGroup(collapse);
      await queuedGridScroll.scrollGrid(undefined, buildRecords);

      updateScrollBar();
    }
  }

  function updateActive() {
    if (sourceActive()) {
      const newRow = me.source.activeRecord - firstRecord;
      if (currentRow != newRow) {
        currentRow = newRow;
        hideEditor();
      }
      updateEditor();
    }
  }

  async function getGroupString() {
    if (sourceActive()) {
      return await me.source.getRecordTitle();
    } else return "";
  }

  async function updateCurrentView(load) {
    await drawRecords(load);
    await me.getActiveSource().updateCurrentMarkedValues();
    updateScrollBar();
  }

  async function updateRecordTable(load) {
    return new Promise(async (resolve) => {
      if (viewInfo.horizontal) me.source.refresh("!");
      await queuedGridScroll.scrollGrid(load, buildRecords);
      updateScrollBar();
      resolve();
    });
    // zaglushka();
  }

  async function updateAllGrid(queued) {
    return new Promise(async (resolve) => {
      updateGridSizeForCardMode();
      buildColumns();
      if (queued === false) {
        await buildRecords();
      } else {
        await queuedGridScroll.scrollGrid(undefined, buildRecords);
      }
      updateScrollBar();
      if (me.editorMode()) {
        await showEditor();
      }
      resolve();
    });
    // zaglushka();
  }

  function createIndicator(id) {
    const el = document.createElement("img");
    el.className = "strelka";
    el.id = id;
    el.style.width = "9px";
    el.style.height = "12px";
    el.style.position = "absolute";
    el.style.zIndex = "1";
    el.style.top = "5px";
    el.style.right = "4px";
    if (!showIndicator) el.style.display = "none";
    return el;
  }

  async function changeIndicator(state) {
    if (showIndicator) {
      switch (state) {
        case dsBrowse:
          if (sourceActive() && (await me.source.getUpdateStatus(me.source.activeRecord)) > 0) {
            console.log("updated");
            indicator.setAttribute("src", INDICATOR_IMAGE_UPDATED);
          } else indicator.setAttribute("src", me.OnlyViewMode ? INDICATOR_IMAGE_ONLYVIEW : INDICATOR_IMAGE_BROWSE);
          // me.ChangeSave(true);
          break;
        case dsEdit:
          console.log("dsEdit");
          if (viewInfo.horizontal) {
            console.log(panel.querySelector(".titleText"));
          }
          indicator.setAttribute("src", INDICATOR_IMAGE_EDITING);
          break;
        case dsInsert:
          console.log("dsInsert");
          indicator.setAttribute("src", INDICATOR_IMAGE_NEW);
          break;
      }
      indicator.state = state;
    }
  }

  function checkDrawInfo(fieldName, td, tr, i) {
    if (viewInfo.horizontal && i === 0) return;
    const recordInfo = me.getActiveSource().getRecordInfo();
    if (recordInfo && recordInfo.Data$content) {
      const indexOfField = me.getActiveSource().getFieldIndex(fieldName);
      const locking = recordInfo.Data$content;
      const lockingStatus = locking[indexOfField];
      const cellInner = td.getElementsByClassName("grid-cell-inner")[0];
      switch (lockingStatus) {
        case "1": {
          if (td) {
            // td.style.backgroundColor = "rgb(162 174 186)";
            // td.style.color = "rgb(64, 64, 64)";
            td.classList.add("grid-td-locking");
            if (cellInner.innerText === "" && !td.getElementsByClassName("grid-cell-img")) {
              cellInner.innerText = "X";
              // cellInner.style.textAlign = "center";
            }
          }
          break;
        }
        case "2": {
          if (tr) {
          }
          break;
        }
        default: {
          cellInner.style.textAlign = "";
          // td.style.color = ""
          break;
        }
      }
    }
  }

  async function createRecordColumns(tr, isCurrentRow, margin) {
    // Колонки могут ещё не быть подготовлены при смене источника.
    const items = me.columns?.fields;
    if (!items) return;

    let td = document.createElement("td");
    td.marginBlock = true;
    td.style.width = isNaN(margin) ? 0 : margin + "px";
    td.style.backgroundColor = GRID_BACKGROUND;
    tr.appendChild(td);
    for (let i = 0, div, col, width; i < items.length; i++) {
      col = items[i];
      td = document.createElement("td");
      td.className = "grid-td";
      td.col = i + columnOffset;
      td.field = col;
      if (!viewInfo.horizontal) {
        if (
          isCurrentRow &&
          (selectedField === col.fieldName || (currentCol === i + columnOffset && selectedField === undefined))
          // (selectedField === col.fieldName || i == currentCol)
        ) {
          td.classList.add("grid-item-focused");
          // selectedField = col.fieldName;
        }
      }
      if (col.fixed === true) {
        td.classList.add("fixed-col");
      }
      width = col.el.clientWidth + 1;
      // width = isClassifires?col.width + 10:col.width
      if (i == 0) width -= margin;
      // if(width < 24) width = 24
      td.style.width = width + "px";
      td.role = ROLE_COLDATA;
      div = document.createElement("div");
      div.className = "grid-cell-inner";

      me.setUnderlineCell?.(col, div);

      div.innerText = await me.source.getFieldText(col.fieldName);
      div.innerText = div.innerText === "undefined" ? "" : div.innerText;
      // div.appendChild( me.source.getFieldText(col.fieldName))
      const shouldCreateCollapsibleRecords =
        col.fieldName?.toLowerCase() === "code" || col.collapseRecord || viewInfo.horizontal;
      if (typeof me.source.CreateCollapsibleRecords === "function" && shouldCreateCollapsibleRecords) {
        await me.source.CreateCollapsibleRecords(div, me, i, td);
      }

      const fieldName = viewInfo.horizontal ? td.levelsField?.field?.fieldName : col.fieldName;
      const recValue = fieldName ? await me.getActiveSource().getFieldValue(fieldName) : undefined;
      if (recValue) {
        div.recid = recValue;
      }
      renderByFiledInfo(col, td, div, recValue);
      td.appendChild(div);
      if (fieldName) checkDrawInfo(fieldName, td, tr, i);
      tr.appendChild(td);
    }

    tr.isGroup = false;
  }
  const createSquareColor = (td, colorField) => {
    let checkContainer = td.querySelector(".grid-square-color");
    if (!checkContainer) {
      checkContainer = document.createElement("div");
      checkContainer.style.position = "absolute";
      checkContainer.className = "grid-square-color";
      td.appendChild(checkContainer);
    }
    me.getActiveSource()
      .getFieldText(colorField)
      .then((color) => {
        checkContainer.style.backgroundColor = setColor(color);
      });
  };

  const createDesignField = (td, designFieldName) => {
    me.getActiveSource()
      .getFieldValue(designFieldName)
      .then((color) => {
        td.style.backgroundColor = setColor(color);
      });
  };

  function renderByFiledInfo(col, td, div, recValue) {
    let column;
    if (viewInfo.horizontal && td.levelsField && td.levelsField.field) {
      column = td.levelsField.field;
    } else {
      column = col;
    }
    if ((column.fieldInfo && viewInfo.horizontal && col.fieldName !== "Title") || !viewInfo.horizontal) {
      if (column.fieldInfo) {
        if (!viewInfo.horizontal && column.fieldInfo.textAjust === "1") {
          td.style.textAlign = "center";
        }
        if (column.fieldInfo.EditStyle & 4) {
          let checkboxState;
          if (column.fieldInfo.checkField) {
            checkboxState = me.getActiveSource().getFieldValueSync(column.fieldInfo.checkField);
          }
          if (column.fieldInfo.onGetCheckState) {
            checkboxState = column.fieldInfo.onGetCheckState(column);
          } else {
            checkboxState = recValue ? recValue : "0";
          }
          if (me.MultiCLsSelect) {
            if (
              me.ClsSelection[me.getActiveSource().getFieldValueSync(me.getActiveSource().getKeyFieldName())] !==
              undefined
            ) {
              checkboxState = "1";
            } else checkboxState = "0";
          }

          const oldContainer = td.querySelector(`div[role="check-box"]`);

          if (oldContainer) {
            const checkbox = oldContainer.querySelector("#checkbox-multicheck");
            if (checkbox && checkbox.update)
              checkbox.update({
                MultiCheckSet: column.fieldInfo.multiCheckSet,
                CheckState: checkboxState,
              });
          } else {
            const checkContainer = document.createElement("div");
            checkContainer.role = ROLE_CHECKBOX;
            checkContainer.recordIndex = me.getActiveSource().activeRecord;
            checkContainer.checked = checkboxState;
            checkContainer.style.position = "absolute";
            // const checkBoxDisabled = !me.canModify(mfEdit, column, me);
            let modifyFlag = mfEdit;
            if (me.getActiveSource().recordCount === 0) {
              modifyFlag = mfInsert;
            }
            flushSync(() => {
              createRoot(checkContainer).render(
                <CheckBoxMultiCheck
                  MultiCheckSet={column.fieldInfo.multiCheckSet}
                  customDefaultIcons={column.fieldInfo.customDefaultIcons}
                  // disabled={checkBoxDisabled}
                  CheckState={checkboxState}
                  canModify={() => {
                    if (me.MultiCLsSelect && modifyFlag === mfEdit) return true;
                    return me.canModify(modifyFlag, column, me);
                  }}
                  onEdit={(data) => {
                    onCheck(data, checkContainer);
                  }}
                />,
              );
            });
            div.style.marginLeft = "19px";
            td.style.textAlign = "";
            td.appendChild(checkContainer);
          }
        }
        if (column.fieldInfo.type === "Image" && !viewInfo.horizontal) {
          const domImg = td.getElementsByTagName("img");
          if (domImg.length > 0) {
            domImg[0].remove();
          }
          const img = createImgByIndex(div.innerText);
          img.className = "grid-cell-img";
          // img.style.width = "16px";
          // img.style.height = "16px";
          // img.style.verticalAlign = "middle";
          div.innerText = "";
          div.innerHTML = "";
          td.appendChild(img);
        }
        if (column.fieldInfo.squareColorField) {
          div.style.marginLeft = "19px";
          createSquareColor(td, column.fieldInfo.squareColorField);
        }
        if (column.fieldInfo.design) {
          createDesignField(td, column.fieldInfo.design);
        }
        if (column.fieldInfo.backColor) td.style.backgroundColor = column.fieldInfo.backColor;
      }
      if (column.fieldInfo?.options) {
        if (column.fieldInfo?.options?.link && div.innerText !== "") {
          div.style.cursor = "pointer";
        }
        if (column.fieldInfo?.options?.redNegative) {
          const text = div.innerText;
          if (Math.sign(text.replaceAll(" ", "").replace(",", ".")) === -1) {
            td.style.color = "red";
          } else {
            td.style.color = "";
          }
        }
      }
    }
    if (viewInfo.horizontal & (col.fieldName === "Title") && column && column.marked !== undefined) {
      const markedButton = createRoundButton(td.levelsField.field);
      markedButton.style.bottom = "";
      markedButton.style.left = "";
      markedButton.style.width = "4px";
      markedButton.style.height = "4px";
      markedButton.style.margin = "8.5px 0px 0px 1px";
      td.appendChild(markedButton);
    }
  }

  async function onCheck(data, checkContainer) {
    const oldRecordCount = me.getActiveSource().recordCount;
    const checkbox = checkContainer;
    checkbox.checked = data.CheckState;
    const el = checkContainer.parentElement;
    const newCol = el.col,
      newRow = el.parentElement.row;
    if (
      oldRecordCount === 0 &&
      (await canModifyViewInfo(mfInsert, viewInfo.horizontal ? el.levelsField.field : el.field, me))
    ) {
      await me.getActiveSource().appendRecord();
    }
    if (newCol !== currentCol || currentRow !== newRow) await moveColRow(newCol, newRow);

    if (me.MultiCLsSelect) {
      const value = me.getActiveSource().getFieldValueSync(me.getActiveSource().getKeyFieldName());
      const prefixValue = "";
      if (checkbox.checked) {
        me.ClsSelection[value] = `${prefixValue}${value}`;
      } else {
        delete me.ClsSelection[value];
      }
      return;
    }

    if (await canModifyViewInfo(mfEdit, viewInfo.horizontal ? el.levelsField.field : el.field, me)) {
      const postRecordForCheckBox = async () => {
        let fieldName = viewInfo.horizontal ? el.levelsField.field : el.field;
        fieldName =
          fieldName.fieldInfo && fieldName.fieldInfo.checkField ? fieldName.fieldInfo.checkField : fieldName.fieldName;
        await me.postSomeData(fieldName, {
          id: checkbox.checked && checkbox.checked !== "0" ? checkbox.checked : "",
          text: "",
        });
        await me.getActiveSource().postRecord();
      };

      if (viewInfo.horizontal && multiSelect.length > 0) {
        const source = me.getActiveSource(),
          saveActiveRecord = source.activeRecord;
        for (const value of Object.values(multiSelect)) {
          source.activeRecord = Number(value);
          await postRecordForCheckBox();
        }
        source.activeRecord = saveActiveRecord;
      } else {
        await postRecordForCheckBox();
      }
      await updateOrBuild(oldRecordCount);
    }
    if (me.source.getState() !== dsInsert) await changeIndicator(dsBrowse);
  }

  async function updateOrBuild(oldRecordCount, load) {
    if (viewInfo.horizontal) {
      await me.getActiveSource().getFieldText("ID");
      await updateCard(true);
    } else {
      if (oldRecordCount !== me.getActiveSource().recordCount) {
        await updateRecordTable(load !== undefined ? load : true);
      } else await updateCurrentView();
    }
  }

  function createGroupRecord(tr, isCurrentRow, margin) {
    return new Promise(async (resolve) => {
      let td,
        width = -1,
        tmp;
      td = document.createElement("td");
      td.style.width = margin + "px";
      td.style.backgroundColor = GRID_BACKGROUND;

      tr.appendChild(td);
      for (let i = 0, items = me.columns.fields, col; i < items.length; i++) {
        col = items[i];
        width += col.width;
      }
      width -= margin;
      td = document.createElement("td");
      td.className = "grid-td";
      // if (tr.parentElement && tr.parentElement.parentElement) {
      if (isCurrentRow) {
        td.classList.add("grid-item-focused");
      } else {
        td.classList.remove("grid-item-focused");
      }
      // }
      td.style.width = width + "px";
      td.role = ROLE_COLDATA;

      tmp = document.createElement("img");
      tmp.src = "data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
      tmp.classList.add("collapse-img");
      tmp.style.marginTop = "4px";
      if (await getRecordCollapsed()) tmp.classList.add("collapse-plus");
      else tmp.classList.add("collapse-minus");
      tmp.style.width = "20px";
      tmp.role = ROLE_COLLAPSE_GROUP;
      td.appendChild(tmp);

      tmp = document.createElement("span");
      tmp.style.width = "100%";
      tmp.textContent = await getGroupString();
      td.appendChild(tmp);

      tr.appendChild(td);
      tr.isGroup = true;
      resolve();
    });
  }

  async function drawRecords(load = true) {
    const drawRow = async (r) => {
      return new Promise(async (resolve) => {
        if (viewInfo.horizontal && r === 0 && fixedColumn !== null) {
          me.source.activeRecord = 0 + r;
        } else {
          me.source.activeRecord = firstRecord + r;
        }

        let el = getRowElement(r);
        const isCurrentRow = currentRow === r;
        deleteStyleByField(el);
        await createStyleByField(el, undefined);
        if (multiSelect.includes(`${me.source.activeRecord}`)) {
          createMultiRow(el);
        } else {
          deleteStyleInRow(el);
        }
        if (el) el.recordIndex = me.source.activeRecord;
        await me.changeGridStyles?.(el, me);
        if (showIndicator && el) {
          const par = el.getElementsByTagName("tr")[0].firstChild;
          while (par.childElementCount > 0) par.removeChild(par.lastChild);

          function addInd(img) {
            const ind = createIndicator("state");
            par.appendChild(ind);
            ind.setAttribute("src", img);
          }

          switch (await me.source.getUpdateStatus(me.source.activeRecord)) {
            case usInserted:
              addInd(INDICATOR_IMAGE_INSERTED);
              break;
            case usModified:
              addInd(INDICATOR_IMAGE_MODIFIED);
              break;
            case usDeleted:
              addInd(INDICATOR_IMAGE_DELETED);
              break;
          }
          if ((imageFields.length > 0 || me.onGetImageIndex) && !viewInfo.horizontal) {
            await createImageFields(par);
          }
          if (isCurrentRow) {
            placeIndicator(par);
          }
        }
        if (el) el = el.getElementsByTagName("tr")[0];
        // deleteStyleByField(el);
        const isGroup = ((await getRecordState()) & STATUS_GROUPED) != 0 && groups.length > 0;
        const margin = await getLevelOffset();
        if (isCurrentRow) el.parentElement.parentElement.classList.add(gridItemClassName);
        else el.parentElement.parentElement.classList.remove(gridItemClassName);
        if (isGroup || isGroup != el.isGroup || me.source.CreateCollapsibleRecords !== null) {
          while (el.childElementCount > 1) {
            el.removeChild(el.lastChild);
          }
          if (isGroup) {
            await createGroupRecord(el, isCurrentRow, margin);
          } else {
            await createRecordColumns(el, isCurrentRow, margin);
          }
          el.isGroup = isGroup;
        } else {
          if (isGroup) {
            const cl = el.children[2];
            cl.textContent = getGroupString();
            el.style.backgroundColor = "";
          } else {
            for (let i = 0, cl, col, width = 0; i < el.childElementCount; i++) {
              cl = el.children[i];
              if (cl.field) {
                col = cl.col;
                width = cl.field.clientWidth;
                if (i == 2) width -= margin;
                cl.style.width = width + "px";

                const recValue = await me.source.getFieldValue(
                  viewInfo.horizontal ? cl?.levelsField?.field : cl.field.fieldName,
                );

                cl.getElementsByClassName("grid-cell-inner")[0].textContent = await me.source.getFieldText(
                  cl.field.fieldName,
                );
                // cl.children[0].textContent = me.source.getFieldText(cl.field.fieldName);
                if (cl.children.length === 2 && cl.firstChild.type === "checkbox") {
                  cl.firstChild.checked = recValue === "1";
                }
                if (recValue) {
                  cl.getElementsByClassName("grid-cell-inner")[0].recid = recValue;
                } else {
                  delete cl.getElementsByClassName("grid-cell-inner")[0].recid;
                }
                renderByFiledInfo(cl.field, cl, cl.getElementsByClassName("grid-cell-inner")[0], recValue, false);
                checkDrawInfo(cl.field.fieldName, cl);
                cl.classList.remove("grid-item-focused");
                if (col == currentCol) {
                  //
                  if (isCurrentRow) {
                    // CreateStrelkaImg(cl)
                    if (!viewInfo.horizontal) cl.classList.add("grid-item-focused");
                    else el.classList.add(gridItemClassName);

                    selectedField = cl.field.fieldName;
                  }
                }
              } else if (cl.marginBlock) {
                cl.style.width = isNaN(margin) ? 0 : margin + "px";
              }
            }
          }
        }
        resolve();
      });
    };

    const saveActiveRecord = me.source.activeRecord;
    await me.source.acquireRecords(firstRecord, visibleRows, load);
    let id; // = await me.source.getRecordID(saveActiveRecord);
    for (let i = 0; i < visibleRows; i++) {
      await drawRow(i, id);
    }
    me.source.activeRecord = saveActiveRecord;
  }

  async function buildRecords(load) {
    return new Promise(async (resolve) => {
      const oldRecords = [...me.data.children];
      // if (true) {
      //   let last;
      //   if (me.data && me.data.lastChild) {
      //     for (const child of me.data.children) {
      //       child.old = true;
      //     }
      //     // while ((last = me.data.lastChild)) {
      //     //   // me.data.removeChild(last);
      //     //   last.old = true;
      //     // }
      //   }
      // }

      if (!me.source) return resolve();
      me.table.style.top = groupSize + filterSize + titleSize + "px";
      updateGridSelectedClass();
      const saveActiveRecord = me.source.activeRecord;
      let indicatorForCard;

      visibleRows = moddiv(me.data.clientHeight, rowHeight);
      if (visibleRows > me.source.recordCount) {
        visibleRows = me.source.recordCount;
      }
      if (viewInfo.horizontal) {
        const title = panel.querySelector(".TitleForHorizontal");
        if (title) {
          let imageBlock = title.children[0],
            titleText = title.children[1];
          if (!imageBlock) imageBlock = document.createElement("div");
          else imageBlock.innerHTML = "";
          imageBlock.className = "imgCardMode";
          await createImageFields(imageBlock);
          if (!titleText) {
            indicatorForCard = createIndicator("indicatorForCard");
            titleText = document.createElement("div");
          } else {
            indicatorForCard = titleText.children[0];
          }
          titleText.innerText = me.getActiveSource().getRecordInfo().title;
          titleText.innerText = titleText.innerText === "undefined" ? "" : titleText.innerText;
          titleText.style.height = "100%";
          titleText.style.display = "grid";
          titleText.style.alignItems = "center";
          titleText.style.marginRight = "16px";
          if (!indicatorForCard) indicatorForCard = createIndicator("indicatorForCard");
          indicatorForCard.src = "";
          titleText.appendChild(indicatorForCard);
          title.appendChild(imageBlock);
          title.appendChild(titleText);
        }
      }

      async function createRecord(r) {
        if (viewInfo.horizontal && r === 0 && fixedColumn !== null) {
          me.source.activeRecord = 0 + r;
        } else {
          me.source.activeRecord = firstRecord + r;
        }
        if (me.needToRender && (await me.needToRender(me))) {
          return;
        }
        return new Promise(async (resolve) => {
          const table = document.createElement("table"),
            tbody = document.createElement("tbody"),
            tr = document.createElement("tr"),
            isCurrentRow = currentRow === r;
          tr.row = r;
          if (showIndicator) {
            const td = document.createElement("td");
            td.className = "grid-indicator";
            td.style.width = indicatorSize + "px";
            tr.appendChild(td);
          }

          const isGroup = ((await getRecordState()) & STATUS_GROUPED) != 0;
          if (isGroup && groups.length > 0) {
            await createGroupRecord(tr, isCurrentRow, await getLevelOffset());
          } else {
            await createRecordColumns(tr, isCurrentRow, await getLevelOffset());
            // tr.style.animation = "grid-td-anim 200ms linear 0s 1 reverse backwards"
            await createStyleByField(table);
          }
          table.classList.add("grid-item");
          table.recordIndex = me.source.activeRecord;
          if (isCurrentRow) table.classList.add(gridItemClassName);
          if (r % 2 != 0) {
            table.classList.add("grid-item-alt");
          }
          if (multiSelect.includes(`${me.source.activeRecord}`)) {
            createMultiRow(table);
          }
          table.style.width = "0pt";
          table.cellSpacing = "0";
          table.cellPadding = "0";
          tr.style.height = rowHeight + "px";
          tr.style.maxHeight = rowHeight + "px";
          tr.className = "grid-row";

          function addInd(img) {
            const parent = tr.firstChild;
            if (parent) {
              let ind = createIndicator("state");
              if (viewInfo.horizontal) ind = indicatorForCard;
              else parent.appendChild(ind);
              ind?.setAttribute("src", img);
            }
          }

          switch (await me.getActiveSource().getUpdateStatus(me.getActiveSource().activeRecord)) {
            case usInserted:
              addInd(INDICATOR_IMAGE_INSERTED);
              break;
            case usModified:
              addInd(INDICATOR_IMAGE_MODIFIED);
              break;
            case usDeleted:
              addInd(INDICATOR_IMAGE_DELETED);
              break;
          }

          if (isCurrentRow) placeIndicator(tr);
          if ((imageFields.length > 0 || me.onGetImageIndex) && !viewInfo.horizontal) {
            await createImageFields(tr.firstChild);
            // tr.firstChild.appendChild(IndicatorImageFields);
          }

          tbody.appendChild(tr);
          table.appendChild(tbody);
          await me.changeGridStyles?.(table, me);

          me.data.appendChild(table);
          // appendEvent(
          //   "mouseover",
          //   function () {
          //     table.classList.add("grid-item-over");
          //   },
          //   table
          // );
          // appendEvent(
          //   "mouseleave",
          //   function () {
          //     table.classList.remove("grid-item-over");
          //   },
          //   table
          // );
          resolve();
        });
      }

      if (me.source.recordCount < firstRecord) firstRecord = 0;
      if (getLastRecord() >= me.source.recordCount) {
        firstRecord -= getLastRecord() - (me.source.recordCount - 1);
      }
      if (me.source.recordCount === 0) {
        await createRecord(0);
        const emptyRow = getRowElement(0).firstChild.firstChild;
        if (emptyRow.classList.contains("grid-row")) {
          emptyRow.empty = true;
        }
        me.onRecordCountChange?.(me);
      } else {
        await me.source.acquireRecords(firstRecord, visibleRows, load);
        me.onRecordCountChange?.(me);
        // const id = await me.source.getRecordID(saveActiveRecord);
        for (let i = 0; i < visibleRows; i++) {
          await createRecord(i);
        }
      }
      for (const child of oldRecords) {
        // if (!child.old) continue;
        me.data.removeChild(child);
      }
      me.source.activeRecord = saveActiveRecord;
      createResizers();
      resolve();
    });
  }

  function getFixedCol() {
    if (fixedColumn !== null) {
      if (!viewInfo.horizontal) {
        if (me.columns.title && me.columns.title[0].fieldName !== fixedColumn.fieldName && fixedColumn.level === 0) {
          const items = me.columns.title,
            item = fixedColumn,
            i = items.indexOf(item);
          if (i != -1) {
            const j = 0;
            if (j != -1) {
              items.splice(i, 1);
              items.splice(j, 0, item);
            }
          }
          prepareLevels();
        }
      }
    }
  }

  function getEl(json, fieldName) {
    for (const value of Object.values(json)) {
      if (value.items) {
        getEl(value.items, fieldName);
      }
      if (value.field.fieldName === fieldName) return value;
    }
  }

  async function createStyleByField(table, isGroup) {
    if (table) {
      if (me.BkClrField && !isGroup) {
        //bg color
        table.style.backgroundColor = setColor(Number(await me.source.getFieldText(me.BkClrField)));
      } else {
        table.style.backgroundColor = "";
      }
      if (me.ColorField && !isGroup) {
        //Цвет шрифта
        table.style.color = setColor(Number(await me.source.getFieldText(me.ColorField)));
      } else {
        table.style.color = "";
      }
      if (me.StyleField && !isGroup) {
        // стиль шрифта
        const style = Number(await me.source.getFieldText(me.StyleField));
        table.style.fontWeight = style & 1 ? "bold" : "";
        table.style.fontStyle = style & 2 ? "italic" : "";
        table.style.textDecoration = style & 4 ? "underline" : style & 8 ? "line-through" : "";
      } else {
        table.style.fontWeight = "";
        table.style.fontStyle = "";
        table.style.textDecoration = "";
      }
      const recordData = await me.getActiveSource().getRecordData();
      if (recordData.info.hidden) {
        table.style.textDecoration = "line-through";
      }
    }
  }

  function deleteStyleByField(tr) {
    if (tr) {
      tr.style.backgroundColor = "";
      tr.style.color = "";
      tr.style.fontWeight = "";
      tr.style.fontStyle = "";
      tr.style.textDecoration = "";
    }
  }

  async function createImageFields(el) {
    return new Promise(async (resolve) => {
      if (el && el.firstChild && el.firstChild.id === "ImageFields") {
        el.firstChild.remove();
      }
      let imageArr = [];
      let imageIndexesFromFields = imageFields;
      const imageIndexesFromEvent = me.onGetImageIndex && (await me.onGetImageIndex(me));
      if (imageFields.length > 0) {
        imageIndexesFromFields = await Promise.all(
          imageFields.map(async (imageField) => {
            let imageIndex =
              me.getActiveSource().booksGetImage !== undefined
                ? await me
                    .getActiveSource()
                    .booksGetImage(await me.getActiveSource().getFieldText(imageField), imageField)
                : await me.getActiveSource().getFieldText(imageField);
            if (imageField === "Status") imageIndex = await me.getActiveSource().getFieldValue(imageField);
            if (Number(imageIndex) > 1) {
              imageIndex = parseInt(imageIndex);
              if (isNaN(imageIndex)) {
                imageIndex = parseInt(await me.getActiveSource().getFieldValue(imageField));
              }
              return imageIndex;
            }
          }),
        );
      }
      imageArr = imageArr.concat(imageIndexesFromFields, imageIndexesFromEvent);
      if (viewInfo.horizontal) console.log("imageFields");
      const arrOfDOMImages = document.createElement("div");
      arrOfDOMImages.classList.add("grid-image-fields");
      // arrOfDOMImages.style.height = 16 + "px";
      // arrOfDOMImages.style.display = "flex";
      // arrOfDOMImages.style.alignItems = "center";
      // arrOfDOMImages.style.overflow = "hidden";
      // arrOfDOMImages.style.whiteSpace = "nowrap";
      // arrOfDOMImages.style.textOverflow = "ellipsis";
      // arrOfDOMImages.style.marginLeft = "3px";
      arrOfDOMImages.id = "ImageFields";
      arrOfDOMImages.onmouseover = async function (e) {
        const imgF = e.target;
        if (imgF.imgIndex && imgF.doccfgid && imgF.docid && (imgF.title === "" || imgF.title === undefined)) {
          const img = e.target;
          const titl = await getImageHint(imgF.doccfgid, imgF.imgIndex, imgF.docid);
          if (titl !== undefined && !isEmptyObject(titl)) img.title = titl;
          else img.title = null;
        }
      };
      for (const img of imageArr) {
        let imgIndex = img;
        if (imgIndex) {
          imgIndex = parseInt(imgIndex);
          if (isNaN(imgIndex)) {
            imgIndex = parseInt(await me.source.getFieldValue(img));
          }
          const imgF = document.createElement("img");
          imgF.style.width = "16px";
          imgF.style.height = "16px";
          const icon = await getIconsAsync(imgIndex);
          if (icon !== undefined && (icon !== null) & (imgIndex !== 0)) {
            imgF.src = ImgURLSRC(icon);
            imgF.imgIndex = imgIndex;
            imgF.docid = await me.getActiveSource().getFieldText("ID");
            imgF.doccfgid = await me.getActiveSource().getFieldText("DocCfgID");
            arrOfDOMImages.appendChild(imgF);
          }
        }
      }
      el.appendChild(arrOfDOMImages);
      // return arrOfDOMImages;
      resolve();
    });
  }

  function placeIndicator(tr) {
    if (tr && showIndicator) {
      const oldPar = indicator.parent;
      let newPar = tr.firstChild;
      if (viewInfo.horizontal && tr.className === "grid-indicator") newPar = tr;
      if (newPar) {
        indicator.parent = null;
        if (oldPar && oldPar.childElementCount > 0 && oldPar.firstChild.style.display !== "flex") {
          oldPar.firstChild.style.display = "";
        }
        if (newPar.childElementCount > 0 && newPar.id !== "ImageFields" && newPar.firstChild.id !== "ImageFields") {
          newPar.firstChild.style.display = "none";
        }
        newPar.appendChild(indicator);
        indicator.parent = newPar;

        const updated = sourceActive() && me.source.getUpdateStatus(me.source.activeRecord) > 0;
        if (indicator.updated !== updated) {
          indicator.updated = updated;
          if (updated) {
            indicator.setAttribute("src", INDICATOR_IMAGE_UPDATED);
          } else indicator.setAttribute("src", me.OnlyViewMode ? INDICATOR_IMAGE_ONLYVIEW : INDICATOR_IMAGE_BROWSE);
        }
      }
    }
  }

  async function applyFilter(filtered) {
    if (sourceActive()) {
      const filter = {};
      const currentfilters = {};
      // проверка наличия отфильтрованных полей и заполнение объекта отфильтрованными полями
      for (const [key, value] of Object.entries(filterData)) {
        if (value.filtered) {
          currentfilters[key] = value.value;
        }
      }

      if (filtered) {
        for (let i = 0, el, f, t; i < me.filter.childElementCount; i++) {
          el = me.filter.children[i];
          f = el.field;
          if (f && el.value) {
            // удаление фильтрации текущего поля если оно было отфильтровано ранее
            if (currentfilters[f.fieldName]) {
              // кнопка фильтрации внутри поля
              const filterBttn = f.el.querySelector(`#filter-bttn_${f.fieldName}`);

              // очистка состояния кнопки фильтрации внутри поля
              if (filterBttn) filterBttn.clearFilter();

              // очистка данных из объекта фильтрации для состояния таблицы
              delete filterData[f.fieldName];
              // очистка данных из объекта для запроса ApplyFilter
              delete currentfilters[f.fieldName];
            }

            t = {};
            Object.defineProperty(t, el.value, {
              value: null,
              configurable: true,
              writable: true,
              enumerable: true,
            });
            t.$tag = 1;
            Object.defineProperty(filter, f.fieldName, {
              value: t,
              configurable: true,
              writable: true,
              enumerable: true,
            });
          }
        }
        filterData.rowFilter = filter;
      }
      const result = getFilterContent(currentfilters);
      saveState();
      await me.source.applyFieldFilter({ ...filter, ...result });
      await updateRecordTable();
      scrollToRecord(me.source.activeRecord, true);
      me.onMultiSelectChange?.(me);
    }
  }

  function buildFilters() {
    if (filterSize == 0 || !me.columns.fields) return;
    let el = me.filter;
    // top = me.filter.getBoundingClientRect().top;
    while (el.childElementCount > 0) {
      const ch = el.lastChild;
      if (ch.field) {
        ch.field.filterText = ch.value;
      }
      el.removeChild(ch);
    }
    const applyButton = document.createElement("button");
    applyButton.style.position = "relative";
    applyButton.style.top = "1px";
    applyButton.style.left = "2px";
    applyButton.style.width = `calc(${indicatorSize}px - 5px)`;
    applyButton.style.height = "20px";
    applyButton.filtered = filterData.rowFilterFiltered ? true : false;
    applyButton.innerText = filterData.rowFilterFiltered ? "Вкл" : "Выкл";
    applyButton.onclick = (ev) => {
      if (ev.target.filtered) {
        ev.target.innerText = "Выкл";
      } else {
        ev.target.innerText = "Вкл";
      }
      ev.target.filtered = !ev.target.filtered;
      filterData.rowFilterFiltered = ev.target.filtered;
      saveState();
      applyFilter(ev.target.filtered);
    };
    me.filter.appendChild(applyButton);
    for (let i = 0, fields = me.columns.fields, f; i < fields.length; i++) {
      f = fields[i];
      if (filterData.rowFilter && filterData.rowFilter[f.fieldName]) {
        f.filterText = Object.keys(filterData.rowFilter[f.fieldName])[0];
      } else f.filterText = "";
      el = document.createElement("input");
      el.style.position = "absolute";
      el.style.top = "1px";
      el.style.left = f.offset + "px";
      el.style.width = f.elementWidth - 4 + "px";
      el.style.height = filterSize - 6 + "px";
      el.field = f;
      el.classList.add("grid-filter");
      el.role = ROLE_FILTER;
      if (f.filterText) {
        el.value = f.filterText;
      }
      el.onkeydown = function (e) {
        if (e.key == "Enter") {
          if (!applyButton.filtered) {
            applyButton.innerText = "Вкл";
            applyButton.filtered = true;
          }
          filterData.rowFilterFiltered = applyButton.filtered;
          saveState();
          applyFilter(applyButton.filtered);
        }
      };

      el.onblur = () => {
        if (applyButton.filtered) applyFilter(true);
      };

      me.filter.appendChild(el);
    }
    me.switchFilter = function (enabled) {
      if (enabled) {
        applyButton.innerText = "Вкл";
        applyButton.filtered = true;
        filterData.rowFilterFiltered = applyButton.filtered;
        saveState();
        applyFilter(applyButton.filtered);
      } else {
        applyButton.innerText = "Выкл";
        applyButton.filtered = false;
        filterData.rowFilterFiltered = applyButton.filtered;
        saveState();
        applyFilter(applyButton.filtered);
      }
    };
  }

  function updateFilters() {
    if (filterSize == 0) return;
    for (let i = 0, el, f; i < me.filter.childElementCount; i++) {
      el = me.filter.children[i];
      f = el.field;
      if (f) {
        el.style.left = f.offset + "px";
        el.style.width = f.elementWidth - 4 + "px";
        el.setAttribute("tabindex", me.columns.fields.indexOf(f) + 1);
      }
    }
  }

  function getRowElement(r) {
    return me.data.children[r];
  }

  function getColElement(c, r) {
    let rEl = getRowElement(r);
    const colIndex = c - columnOffset;
    if (rEl) {
      rEl = rEl.getElementsByTagName("tr");
      if (rEl) {
        rEl = rEl[0];
        if (showIndicator) {
          return rEl.children[colIndex + 2];
        } else return rEl.children[colIndex + 1];
      }
    }
    return null;
  }

  const getDemandParams = async (fieldInfo) => {
    if (fieldInfo && fieldInfo.columnID && fieldInfo.demandParams) {
      const keyFieldNameID = me.getActiveSource().getKeyFieldNameData();
      const newParams = await getColumnParams(fieldInfo.columnID, keyFieldNameID, me.doccfgid);
      return { module: newParams.Module, datatype: newParams.ObjType, type: newParams.Module };
    } else return {};
  };

  async function setColumnText(column, text) {
    await me.getActiveSource().setFieldText(column.fieldName, text, column.index);
  }

  async function setColumnValue(column, id) {
    await me.getActiveSource().setFieldValue(column.fieldName, id, column.index);
  }

  function clickAway(ev) {
    if (
      ev.target.closest("[checklist]") ||
      ev.target.closest("[calendar]") ||
      ev.target.closest("[details]") ||
      (ev.target.closest(".background_ModalDialog") &&
        ev.target.closest(".background_ModalDialog") !== inputEditor.closest(".background_ModalDialog")) ||
      (ev.target.closest("UL") && ev.target.closest("UL").role !== "menu") ||
      ev.target.classList.contains("CloseButtonForGrid") ||
      ev.target.classList.contains("ApplyButtonForGrid") ||
      ev.target.tagName === "BODY" ||
      ev.target.closest("[loadmask]") ||
      (viewInfo.horizontal && ev.target.closest("TR") && ev.target.closest("TR").querySelector("[componenteditor]"))
      // ev.target.classList.contains("MuiBackdrop-root") ||
    ) {
      if (
        ev.target.closest("[details]") ||
        (ev.target.closest(".background_ModalDialog") &&
          ev.target.closest(".background_ModalDialog") !== inputEditor.closest(".background_ModalDialog") &&
          inputEditor)
      ) {
        return;
      }
      inputEditor.focus();
      inputEditor.select();
      return;
    }

    if (editor.parentElement && !editor.parentElement.contains(ev.target)) {
      hideEditor();
      deleteEvent("click", clickAway);
    }
  }

  async function setObjectText(editData) {
    const params = new Map();
    params.set("prefix", editData.type);
    params.set("comand", "SetObjectText");
    params.set("Flag", "-1");
    params.set("ObjType", editData.datatype ? editData.datatype : "0");
    params.set("ObjRef", editData.addInfo.Cell.recid ? editData.addInfo.Cell.recid : editData.tag ? editData.tag : "0");
    params.set("Text", editData.value === "__.__.____" ? "" : editData.value);
    return AxiosRequest(true, params);
  }

  function getColumnStyle(id) {
    const params = new Map();
    params.set("prefix", "documents");
    params.set("comand", "GetColumnStyle");
    params.set("SectionID", me.sectionid);
    params.set("ID", id);
    params.set("DocID", me.source.getFieldTextSync("ID"));
    params.set("MasterID", me.source.Master.MasterID ? me.source.Master.MasterID : "0");
    params.set("DocCfgID", me.doccfgid);
    params.set("WSM", "1");
    return AxiosRequest(true, params);
  }

  // рендерит редактор в переданный котнейнер
  async function renderEditor(data, editorDiv, addCommands) {
    appendEvent("click", clickAway);
    // костыль для списка который приходит в source fields на запрос getFields
    const fieldIndex = me.getActiveSource().getFieldIndex(data.field.fieldName);
    const fieldData = me.getActiveSource().fields[fieldIndex];

    let editStyle = Number(data.field.fieldInfo.EditStyle),
      dataType = data.field.fieldInfo.DataType,
      module = data.field.fieldInfo.Module,
      onDropDownList = data.field.fieldInfo.onDropDownList,
      detailsData,
      customDefaultTag;
    const field = data.field.fieldName,
      list = data.field.fieldInfo.Values?.length > 0 ? "" : fieldData.list?.join("\r\n"),
      listValues = data.field.fieldInfo.Values,
      details = data.field.fieldInfo.details,
      accDetails = data.field.fieldInfo.accDetails,
      detailsByReq = data.field.fieldInfo.detailsByReq,
      buttonImage = data.field.fieldInfo.buttonImage,
      editMask = data.field.fieldInfo.editMask,
      onEditProgId = data.field.fieldInfo.onEdit,
      onList = data.field.fieldInfo.onList,
      onListCustom = data.field.fieldInfo.onListCustom,
      onCloseUpList = data.field.fieldInfo.onCloseUpList,
      onGetEditStyle = data.field.fieldInfo.onGetEditStyle,
      path = data.field.fieldInfo.Path,
      fieldName = data.field.fieldInfo.FieldName,
      columnID = data.field.fieldInfo.columnID,
      onEditButtonClick = data.field.fieldInfo.onEditButtonClick,
      hardCodeReadOnlyForEditor = data.field.fieldInfo.hardCodeReadOnlyForEditor,
      onDropDown = data.field.fieldInfo.onDropDown,
      tagField = data.field.fieldInfo.tagField,
      getCustomDefaultTag = data.field.fieldInfo.getCustomDefaultTag,
      title = data.field.title;

    if (data.field.fieldInfo && data.field.fieldInfo.columnID && data.field.fieldInfo.demandParams) {
      const newParams = await getDemandParams(data.field.fieldInfo);
      dataType = newParams.datatype;
      module = newParams.module || newParams.type;
    }

    // особый расчет id для календаря при необходимости
    if (tagField) {
      customDefaultTag = await me.getActiveSource().getFieldValue(tagField);
      customDefaultTag = getCustomDefaultTag(customDefaultTag);
    }

    if (!onDropDownList) {
      onDropDownList = async (data) => {
        //
        let json;
        const params = new Map();
        if (data.onlist) {
          params
            .set("prefix", "documents")
            .set("comand", "GetColumnValues")
            // ID=5059&SectionID=108&DocCfgID=3008&DocID=0&MasterID=0&WSM=1
            .set("ID", columnID)
            .set("SectionID", me.sectionid)
            .set("DocCfgID", me.doccfgid)
            .set(
              "DocID",
              me.getActiveSource().getFieldTextSync("ID") ? me.getActiveSource().getFieldTextSync("ID") : "0",
            )
            .set("MasterID", me.getActiveSource().Master.MasterID ? me.getActiveSource().Master.MasterID : "0")
            .set("WSM", "1");
          json = await AxiosRequest(true, params);
        } else if (onDropDown) {
          params.set("prefix", "programs").set("comand", "GetParamValues").set("ProgID", onDropDown).set("WSM", "1");
          json = await AxiosRequest(true, params);
        } else {
          params.set("prefix", data.module).set("comand", "GetObjectValues").set("ObjType", data.datatype);
          json = await AxiosRequest(true, params);
        }

        if (json && json.Items) {
          return json.Items.map((item, index) => {
            if (typeof item === "object") {
              return { label: item.text, id: item.id };
            }
            return { label: item, id: index };
          });
        }
      };
    }

    editStyle += data.field.fieldInfo?.options?.readOnly && !(editStyle & 64) ? 64 : 0;

    if (onGetEditStyle) {
      const columnStyle = await getColumnStyle(columnID);
      editStyle = columnStyle.EditStyle ? Number(columnStyle.EditStyle) : 0;
      if (columnStyle.Token) {
        tokenProcessingTest(columnStyle);
      }
    }

    const parentID = await me.getActiveSource().getFieldText("ID");
    if (details !== "" && details !== undefined) {
      editStyle += !(editStyle & 64) ? 64 : 0;
      detailsData = await GetColumnDetails(details, parentID, path, fieldName, module);
    } else if (accDetails) {
      editStyle += !(editStyle & 64) ? 64 : 0;
      const subData = await GetColumnDetails(undefined, parentID, path, fieldName, "accounts");
      if (subData && subData.Items) {
        detailsData = {
          JSONType: subData.Items.JSONType,
          Items: subData.Items.items,
        };
      }
    } else if (detailsByReq) {
      detailsData = await detailsByReq({ ID: parentID });
    }

    editStyle -= editStyle & 4 ? 4 : 0;
    if (data.cell.style.marginLeft) {
      editorDiv.style.marginLeft = data.cell.style.marginLeft;
    }
    flushSync(() => {
      createRoot(editorDiv).render(
        // редактор
        // название свойства === название ключа(это необязательно, но нужно для удобства)
        <Editor
          // костыль для специфичной работы таблицы Просмотра проводок
          documentGrid={me.doccfgid !== undefined}
          placeholder={""}
          placeholderVisible="1"
          HardCodeReadOnlyForEditor={hardCodeReadOnlyForEditor}
          editor={editorDiv}
          grid={true}
          editStyle={isNaN(editStyle) ? data.field.fieldInfo.EditStyle : editStyle}
          editMask={editMask}
          value={data.value}
          datatype={dataType}
          objref={data.cell.recid || customDefaultTag}
          type={module}
          list={list}
          listValues={listValues}
          onlist={onList}
          onListCustom={onListCustom}
          doubleClickOnInput={true}
          settings={{ onEdit: onEditProgId }}
          buttonImage={buttonImage}
          title={title}
          openAfterRender={addCommands?.renderCommand}
          docProps={{
            ID: columnID,
            DocCfgID: me.doccfgid,
            SectionID: me.sectionid,
            DocID: me.getActiveSource().getFieldTextSync("ID"),
            MasterID: me.getActiveSource().Master.MasterID ? me.getActiveSource().Master.MasterID : "0",
            Reference: "0",
          }}
          details={
            (details || accDetails || detailsByReq) && !isEmptyObject(detailsData)
              ? {
                  Details: details,
                  AccDetails: accDetails,
                  DetailsByReq: detailsByReq,
                  OnEdit: detailsData.OnEdit,
                  OnEditCustom: detailsData.OnEditCustom,
                  OnList: detailsData.OnList,
                  OnListCustom: detailsData.OnListCustom,
                  OnCloseUpList: detailsData.OnCloseUpList,
                  OnCloseUpListCustom: detailsData.OnCloseUpListCustom,
                  ID: parentID,
                  OnGetEditStyle: onGetEditStyle,
                  GetDetails: detailsData,
                  getText: data.getText,
                  updateRecord: data.updateRecord,
                  Path: path,
                  FieldName: fieldName,
                  Module: module,
                  HardCodeReadOnlyForEditor: hardCodeReadOnlyForEditor,
                }
              : undefined
          }
          clickAway={(ev, edit, value) => {
            if (
              (ev.target.closest(".background_ModalDialog") &&
                ev.target.closest(".background_ModalDialog") === inputEditor.closest(".background_ModalDialog")) ||
              ev.target.closest(".CloseButtonForGrid")
            ) {
              return;
            }
            if (editor.ready) {
              edit(undefined, value);
            }
          }}
          onChange={async (val, changeData) => {
            editor.stepValue = val;
            if (data.value !== val) {
              if (!editorDiv.InputChange && changeData.valueChanged.current === true) {
                editorDiv.InputChange = true;
                // if (changeData.addInfo.Cell.closest("TR").empty !== true)
                me.CommitToSaveChanges?.(me);
                me.getActiveSource().modified = true;
              }
              if (me.getActiveSource().getState() !== dsInsert) await changeIndicator(dsEdit);
              // me.postSomeData(Field, { text: val })
            }
          }}
          onEditList={
            onCloseUpList && typeof onCloseUpList === "string" && me.doccfgid
              ? async (data) => {
                  const params = new Map();
                  params
                    .set("prefix", "documents")
                    .set("comand", "CloseUpList")
                    .set("ID", columnID)
                    .set("SectionID", me.sectionid)
                    .set("DocCfgID", me.doccfgid)
                    .set(
                      "DocID",
                      me.getActiveSource().getFieldTextSync("ID") ? me.getActiveSource().getFieldTextSync("ID") : "0",
                    )
                    .set("MasterID", me.getActiveSource().Master.MasterID ? me.getActiveSource().Master.MasterID : "0")
                    .set("Text", data.value ? data.value : "")
                    .set("ObjRef", data.tag ? data.tag : "0")
                    .set("WSM", "1");
                  const json = await AxiosRequest(true, params);
                  if (data.setValue) {
                    data.setValue({ label: data.value, id: data.tag });
                  }
                  if (data.setInputValue) {
                    data.setInputValue(data.value);
                  }

                  tokenProcessingTest(json, {
                    from: "grid",
                    func: () => {
                      if (me.getActiveSource().Master.refreshRecord) {
                        me.getActiveSource().Master.refreshRecord(true);
                      } else {
                        me.refreshSource("!");
                      }
                    },
                  });
                }
              : typeof onCloseUpList === "function" && onCloseUpList
          }
          onDropDownList={onDropDownList}
          addInfo={{
            FieldName: field,
            Field: data.field,
            Cell: data.cell,
            Index: data.index,
            ModalButtonCallBack: () => {
              if (me.getActiveSource().Master.refreshRecord) {
                me.getActiveSource().Master.refreshRecord(true);
              } else {
                me.refreshSource("!");
              }
            },
            onEditButtonClick: onEditButtonClick,
          }}
          onEdit={onEdit}
          onEditButtonClick={(editButtonData) => {
            tokenProcessingTest(editButtonData.json, editButtonData.subData);
          }}
        />,
      );
    });
  }

  const checkDataTypeOnStringType = (dataType) => {
    return dataType >= 7 && dataType <= 12;
  };

  const customResumeReq = async (requestId, data) => {
    const params = {
      RequestID: requestId,
      WSM: "1",
    };
    const config = {
      prefix: "project",
      method: "POST",
      url: "ResumeRequest",
      params,
      data: data,
    };
    return smetaAxios(config);
  };

  async function onEdit(data) {
    let editData = data;
    editor.stepValue = undefined;
    if (data.noEdit) return;
    const {
      requestId,
      addInfo: { needPost, checkObjRefBeforePost },
    } = editData;
    const oldRecordCount = me.getActiveSource().recordCount;
    const addInfo = editData.addInfo;
    const field = addInfo.Field;
    const cell = addInfo.Cell;

    if (checkDataTypeOnStringType(editData.datatype)) {
      editData = { ...editData, tag: undefined };
    }

    // проверка редактора с датой
    if (editData.addInfo?.Field?.fieldInfo?.EditStyle & 2 && editData.tag && !editData.forse) {
      const year = Number(getDateOfInt(editData.tag).split(".")[2]),
        currentYear = new Date().getFullYear();
      if (year < currentYear - 99 || year > currentYear + 99) {
        checkDateBeforeEdit(editData, year);
        return;
      }
    }

    if (field && field.fieldInfo && field.fieldInfo.onEditField) {
      me.onEditField?.(editData);
      return;
    }
    if (requestId) {
      if (needPost) {
        if (checkObjRefBeforePost) {
          const newObjRef = await customResumeReq(requestId, { Result: "1", ObjRef: editData.tag });
          // TODO: нужно доработать программы тонкого клиента или сервера(плохо работает: при певом выборе всегда выбирается первая запись, не зависимо от выбора)
          if (newObjRef.Token) {
            addInfo.checkObjRefBeforePost = false;
            tokenProcessingTest(newObjRef, {
              func: (res) => {
                console.log(res);
                onEdit({ ...editData, requestId: undefined, tag: res?.Value });
              },
            });
            return;
          }

          if (newObjRef?.Value) {
            await onEdit({ ...editData, requestId: undefined, tag: newObjRef?.Value });
            const res = await resumeRequest(requestId);
            if (res.Token) tokenProcessingTest(res);
            return;
          }
        }
        await onEdit({ ...editData, requestId: undefined });
        const res = await resumeRequest(requestId);
        if (res.Token) tokenProcessingTest(res);
      } else await onEditWithRequestId(editData, field, requestId);
      return;
    }

    if (cell.closest("TR").empty === true && !(editData.requestId && field.fieldInfo.onEdit)) {
      await me.getActiveSource().appendRecord();
      // changeIndicator(dsInsert);
    }

    const response = await getResponseObject(editData);
    if (!response) return;

    setFieldValues(editData, response);

    await postEditData(editData, response);

    await finalizeEdit(editData, oldRecordCount);
  }

  // Проверка даты перед редактированием
  const checkDateBeforeEdit = (editData, year) => {
    smetaModals.open(
      <MessageBox
        DlgType={DlgType.Confirmation}
        Buttons={DlgButton.Yes + DlgButton.No}
        Message={`Вы действительно уверены что правильно выбран год: ${year} ?`}
        onSelect={(e) => {
          if (e.target.value === String(DlgRes.Yes)) {
            onEdit({ ...editData, forse: true });
          } else hideEditor();
        }}
      />,
      {
        style: getStyleWindow("MessageBox"),
        hiddenButton: true,
        blockMaximize: true,
        blockSaveLocation: true,
        blockResize: true,
        Title: "Предупреждение",
        onClose: () => {
          hideEditor();
        },
      },
    );
  };

  // Редактирование через цепочки и программы с requestId
  const onEditWithRequestId = async (editData, field, requestId) => {
    const { addInfo, tag } = editData;
    const params = new Map([
      ["prefix", "project"],
      ["comand", "ResumeRequest"],
      ["RequestID", requestId],
      ["WSM", "1"],
    ]);

    if (field.OptionsDisable?.link && addInfo.editButtonClick) {
      await onEdit({ ...editData, requestId: undefined });
      const json = await AxiosRequest(true, params);
      tokenProcessingTest(json);
      return;
    }

    const json = await AxiosRequest(true, params, {
      Result: "1",
      DocID: tag,
      ObjRef: tag,
    });
    tokenProcessingTest(json, {
      from: "grid",
      func: () => {
        if (me.getActiveSource().Master.refreshRecord) {
          me.getActiveSource().Master.refreshRecord(true);
          me.CommitToSaveChanges?.(false);
        } else {
          me.refreshSource("!");
          me.CommitToSaveChanges?.(false);
        }
      },
    });
  };

  const getResponseObject = async (editData) => {
    const { type, value, proof, addInfo, tag, checkvalue } = editData;
    if (type && (value || tag) && proof) {
      let currentTag = tag;

      if (proof) {
        const json = await setObjectText(editData);
        if (json.Selection && json.Selection.length) {
          if (json.Selection.length === 1) {
            editData.onEdit({ ...editData, proof: false, tag: json.Selection[0].id, value: json.Selection[0].text });
          } else openModalSelection(editData, json);
          return;
        }
        if (json.CreateNew) {
          openModalCreateNew(editData, json);
          return;
        }
        currentTag = json.ObjRef;
      }

      if (currentTag === "-1") {
        return;
      }

      const response = await me.getActiveSource().CheckFieldText(addInfo.FieldName, currentTag);
      if (!response.Text) response.Text = value;

      return response;
    }

    return {
      EditVal: value,
      ObjRef: tag,
      Text: value === null ? checkvalue : value,
    };
  };

  const openModalSelection = (editData, json) => {
    editor.selection = true;
    smetaModals.open(
      <DialogSetObjText
        list={json.Selection}
        onEdit={editData.onEdit}
        data={editData}
        // record={data.record}
        // CheckState={data.CheckState}
      />,
      {
        Title: "Выберите элемент из списка",
        style: getStyleWindow(),
        blockMaximize: true,
      },
    );
  };

  const openModalCreateNew = (editData, json) => {
    editor.selection = true;
    smetaModals.open(
      <DialogCreateObj
        onEdit={editData.onEdit}
        inputNameObj={json.CreateNew.Text}
        spanText={json.CreateNew.Label}
        CLSID={json.CreateNew.CLSID}
        ObjType={editData.datatype}
        Module={editData.type}
        groups={json.CreateNew.Groups}
        data={editData}
      />,
      {
        Title: "Создать новый объект",
        style: getStyleWindow(`${json.CreateNew.CLSID}${json.CreateNew.Groups ? "Group" : ""}`),
        hiddenButton: true,
        blockMaximize: true,
        blockSaveLocation: true,
      },
    );
  };

  const setFieldValues = (editData, response) => {
    const { setValue, setInputValue, fixVal, addInfo } = editData;

    if (setValue) {
      setValue({
        label: fixVal ? fixVal(response.EditVal) : response.EditVal,
        id: response.ObjRef,
      });
    }

    if (setInputValue) {
      setInputValue(fixVal ? fixVal(response.EditVal) : response.EditVal);
    }

    inputEditor.modified = true;
    editor.content = response.Text;
    editor.objref = response.ObjRef;
    addInfo.Cell.text = response.Text;
    addInfo.Cell.editval = response.EditVal;
    addInfo.Cell.recid = response.ObjRef;

    if (editor.column === null) {
      addInfo.Cell.innerText = response.Text;
      // await updateRecordTable(true);
      // scrollToRecord(me.source.activeRecord, true);
    }
  };

  const postEditData = async (editData, response) => {
    if (me.getActiveSource().getState() === dsInsert) {
      hideEditor();
    }
    // me.postRecord(EditData.addInfo.Index);
    if (viewInfo.horizontal && multiSelect.length > 0) {
      //PostRecord
      const source = me.getActiveSource();
      const saveActiveRecord = source.activeRecord;

      for (const value of Object.values(multiSelect)) {
        source.activeRecord = Number(value);
        await postSomeDataEditor(editData, response);
      }
      source.activeRecord = saveActiveRecord;
    } else {
      await postSomeDataEditor(editData, response);
    }
  };

  const finalizeEdit = async (editData, oldRecordCount) => {
    me.CommitToSaveChanges?.(false);
    if (me.getActiveSource().getState() !== dsInsert) {
      await changeIndicator(dsBrowse);
    }
    // if (EditData.addInfo.Cell.closest("TR").empty === true) {
    if (viewInfo.horizontal) {
      await me.getActiveSource().getFieldText("ID");
      await updateCard(true);
    } else {
      await updateOrBuild(oldRecordCount, false);
      // await updateRecordTable();
      if (editData.addInfo.Field.sortDirect) hideEditor();
      await scrollToRecord(me.getActiveSource().activeRecord, true);
    }
    editor.stepValue = undefined;
    if (oldRecordCount !== me.getActiveSource().recordCount && editor.visible) {
      await showEditor();
    } else if (inputEditor) {
      inputEditor.focus();
    }
  };

  async function postSomeDataEditor(data, res) {
    const indexForPostRecord = viewInfo.horizontal ? me.getActiveSource().activeRecord : data.addInfo.Index;
    if (!me.getActiveSource().isEditMode()) {
      await me.getActiveSource().editRecord(indexForPostRecord);
      // changeIndicator(dsEdit);
    }

    await setColumnText({ fieldName: data.addInfo.FieldName, index: indexForPostRecord }, res.Text);

    // При ручном вводе ObjRef отсутствует: сбрасываем старый id, чтобы сервер применил новый текст.
    await setColumnValue({ fieldName: data.addInfo.FieldName, index: indexForPostRecord }, res.ObjRef);

    await me.getActiveSource().postRecord(indexForPostRecord);
  }

  async function showEditor(key, addCommands) {
    if ((await isGroupRecord(false)) === true || me.OnlyViewMode === true) return;

    function getModifyFlag() {
      const source = me.getActiveSource();
      if (source.isEmpty()) return mfInsert;
      else return mfEdit;
    }
    // getFieldForEditor();
    let el = getColElement(currentCol, currentRow),
      column;

    if (el) {
      if (viewInfo.horizontal) {
        currentCol = 1;
        el = getColElement(1, currentRow);
        column = getColElement(0, currentRow).levelsField.field;
      } else column = el.field;
      const cellInner = el.getElementsByClassName("grid-cell-inner")[0];
      // const fieldInfo =
      //   cellInner.parentElement.field.fieldInfo === undefined
      //     ? true
      //     : (Number(cellInner.parentElement.field.fieldInfo.Options) & 8) === 0;
      if (cellInner.parentElement.field.fieldInfo === undefined) {
        cellInner.parentElement.field.fieldInfo = {
          ...defaultFieldInfo,
        };
      }

      if (column && (await canModifyViewInfo(getModifyFlag(), column, me))) {
        // данные для редактора
        // объект для передачи данных в редактор
        async function getEditValue(cell) {
          if (!cell.editval && me.getActiveSource().getState() !== dsInsert) {
            const editValue = await me.getActiveSource().GetFieldTextRequest("1", column.fieldName); //Запрос к серверу, можно ли модифицировать
            cell.editval = editValue.Text === undefined ? "" : editValue.Text;
          }
          cell.text = cell.innerText;
          return cell.editval;
        }

        const editData = {
          value: editor && editor.stepValue !== undefined ? editor.stepValue : await getEditValue(cellInner),
          cell: cellInner,
          field: viewInfo.horizontal ? column : cellInner.parentElement.field,
          index: currentRow + firstRecord,
          getText: async () => {
            const editValue = await me.getActiveSource().GetFieldTextRequest("1", column.fieldName); //Запрос к серверу, можно ли модифицировать
            return editValue.Text === undefined ? "" : editValue.Text;
          },
          updateRecord: () => {
            if (me.source.Master.refreshRecord) {
              me.source.Master.refreshRecord(true);
            } else {
              me.getActiveSource().onHandleRequest({
                Command: "RefreshRecord",
                Count: "1",
                RecordKey: me.getActiveSource().getFieldTextSync("ID"),
              });
              me.refreshSource("!");
            }
          },
        };
        const readOnlyProps =
          editData.field.fieldInfo?.options?.readOnly ||
          Number(editData.field.fieldInfo.EditStyle) & 64 ||
          editData.field.fieldInfo.hardCodeReadOnlyForEditor;

        // Добавление редактора в ячейку
        // Создание контейнера для рендера
        editor = document.createElement("div");
        // настройка стилей контейнера
        editor.style.height = "21px";
        if (viewInfo.horizontal) editor.style.width = "calc(100% - 25px)";
        // рендер реакт компонента внутри созданного контейнера
        // рендерить редактор необходимо каждый раз, чтобы была возможность менять входные данные
        editor.column = column;
        // cellInner.style.display = "none"

        await renderEditor(editData, editor, addCommands);

        editor.ready = true;
        // получение элемента input
        inputEditor = editor.querySelector("[inputeditor=true]");

        // inputEditor.onkeydown = function () {
        //   if (!me.source.isEditMode()) {
        //     me.source.editRecord();
        //     changeIndicator(dsEdit);
        //   }
        //   inputEditor.modified = inputEditor.content !== inputEditor.value;
        // };

        editor.el = el;
        el.appendChild(editor);
        editor.visible = true;
        const cell = el.getElementsByClassName("grid-cell-inner")[0];
        // el.classList.remove("grid-item-focused");
        el.style.backgroundColor = "white";
        if (cell) {
          const img = cell.parentElement.querySelector(".grid-cell-img");
          if (img) img.style.display = "none";
          inputEditor.content = cell.textContent;
          inputEditor.value = cell.textContent;
          cell.textContent = "";
          cell.style.display = "none";
          // фокусировка после полного рендера компонента
          setTimeout(() => {
            inputEditor.focus();
            inputEditor.select();
            const editorBlock = el.querySelector(`div[componenteditor="true"]`);
            if (editorBlock && key !== "" && key !== undefined && !readOnlyProps) {
              editorBlock.changeValue(key);
            }
          });
        }
        inputEditor.modified = false;
      }
    }
  }

  async function canModifyViewInfo(modifyFlag, column, me) {
    let canModify;
    if (viewInfo.horizontal && multiSelect.length > 0) {
      const source = me.getActiveSource(),
        saveacrivrecord = source.activeRecord;
      for (const value of Object.values(multiSelect)) {
        source.activeRecord = Number(value);
        await source.getFieldText("ID");
        canModify = me.canModify(modifyFlag, column, me);
        if (canModify === false) {
          source.activeRecord = saveacrivrecord;
          return false;
        }
      }
      return canModify;
    } else {
      canModify = me.canModify(modifyFlag, column, me);

      return canModify;
    }
  }

  function hideEditor(update) {
    if (editor && editor.visible) {
      editor.stepValue = undefined;
      editor.visible = false;
      if (editor.SearchRecord) {
        editor.onblur({ currentTarget: editor });
        return;
      }
      const el = editor.el;
      if (el) {
        el.style.backgroundColor = "";
        const cell = el.getElementsByClassName("grid-cell-inner")[0];
        cell.style.display = "";
        if (cell) {
          const state = me.getActiveSource().getState();
          const fieldInfo = viewInfo.horizontal ? cell.parentElement.levelsField.field : cell.parentElement.field;
          const recordIndex = viewInfo.horizontal
            ? me.getActiveSource().activeRecord
            : Number(cell.closest(".grid-item").recordIndex);
          cell.innerText = cell.text || me.getActiveSource().getFieldTextSync(fieldInfo.fieldName, recordIndex);
          delete cell.editval;
          if (state !== dsInsert) {
            me.CommitToSaveChanges?.(false);
            changeIndicator(dsBrowse);
          }
          //   if (update) {
          //     setColumnText(editor.column, cell.text);
          //     cell.textContent = me.source.getFieldText(editor.column.fieldName);
          //   } else cell.textContent = cell.text;
        }
      }
      if (el && el.contains(editor)) {
        el.removeChild(editor);
        editor.el = null;
      }
      editor.column = null;

      panel.focus();
      // me.CommitToSaveChanges && me.CommitToSaveChanges(false);
      // changeIndicator(dsBrowse);
      // return updateRecordTable(true);
      // scrollToRecord(me.source.activeRecord, true);
    }
  }
  function updateEditor() {}

  function getActiveRecord() {
    return currentRow + firstRecord;
  }
  function getFirstRecord() {
    return firstRecord;
  }
  function getLastRecord() {
    return firstRecord + visibleRows - 1;
  }

  async function moveColRow(newCol, newRow, e) {
    return new Promise(async (resolve) => {
      selectedField = null;
      async function scrollData(distance) {
        me.source.moveBy(distance);
        let bool;
        //
        // if (moddiv(me.data.clientHeight, rowHeight) !== me.source.recordCount && me.source.activeRecord < getLastRecord())distance = 0
        // else
        if (me.source.activeRecord > getLastRecord()) {
          distance = me.source.activeRecord - getLastRecord();
        } else if (me.source.activeRecord < getFirstRecord()) {
          distance = me.source.activeRecord - getFirstRecord();
        } else distance = 0;
        if (me.source.recordCount === 0) distance = 0;
        if (distance != 0) {
          firstRecord += distance;
          currentRow = me.source.activeRecord - firstRecord;
          // drawing = true
          await updateCurrentView();
          // drawing = false
          bool = true;
          // return false;
        } else {
          currentRow = me.source.activeRecord - firstRecord;
          bool = false;
        }
        multiSelectStyles(e, rowDelta, Array.prototype.indexOf.call(me.data.children, el));
        me.onMultiSelectChange?.(me);
        return bool;
      }

      let el,
        rowDelta = newRow - currentRow;
      const colDelta = newCol - currentCol;
      if (currentRow === -1) {
        currentRow = 0;
      }

      if (colDelta || rowDelta) {
        // hideEditor(true);
        if (
          newRow !== currentRow &&
          me.getActiveSource() &&
          me.source.recordCount > 0 &&
          me.source.isEditModeState() === 3
        ) {
          //для отмены добавления новой записи, при клике на другую запись.
          if (newRow > currentRow) {
            await me.cancelRecord(false);
            rowDelta = newRow - (currentRow + 1);
          } else {
            await me.cancelRecord(false);
            rowDelta = newRow - currentRow;
          }
          // if(newRow>currentRow) rowDelta = newRow - currentRow; else rowDelta=0;

          // return
        }
        el = getColElement(currentCol, currentRow);
        let needToChangeFocused = true;
        if (
          me.source.recordCount !== 0 &&
          rowDelta !== me.source.recordCount &&
          rowDelta !== -Math.abs(me.source.recordCount)
        ) {
          if ((currentRow === 0 && rowDelta === -1) || -Math.abs(visibleRows) === rowDelta) {
            needToChangeFocused = false;
          } else if (currentRow + rowDelta === visibleRows || visibleRows === rowDelta) {
            needToChangeFocused = false;
          }
        }
        if (el && needToChangeFocused) el.classList.remove("grid-item-focused");
        if (me.source.recordCount > 0) {
          if (rowDelta != 0 || getActiveRecord() < getFirstRecord() || getActiveRecord() > getLastRecord()) {
            if (me.getActiveSource().isEditMode()) {
              // if (me.getActiveSource().modified) me.postExicstedEditRec();
              // else await me.getActiveSource().cancelRecord();
            }
            el = getRowElement(currentRow);
            if (el) el.classList.remove(gridItemClassName); //старая запись
            if (el) el.classList.remove("grid-item-focused"); //старая запись
            clearStylesForGroupRec(el);
            if (!(await scrollData(rowDelta))) {
              el = getRowElement(currentRow);
              me.source.updateCurrentMarkedValues();
              if (el) {
                el.classList.add(gridItemClassName);
                placeIndicator(el.firstChild.firstChild);
              }
            }
          }
        }
        if (colDelta != 0) {
          if (newCol < 0) {
            if (columnOffset > 0) {
              columnOffset--;
              await updateAllGrid();
            }
            newCol = 0 + columnOffset;
          } else if (newCol > me.columns.fields.length - 1 + columnOffset) {
            if (rightOverflow) {
              columnOffset++;
              await updateAllGrid();
            }
            newCol = me.columns.fields.length - 1 + columnOffset;
          } else if (newCol < columnOffset) {
            if (columnOffset > 0) {
              columnOffset--;
              await updateAllGrid();
            }
          }
          currentCol = newCol;
          if (rowDelta === 0) {
            multiSelectStyles(e, rowDelta, Array.prototype.indexOf.call(me.data.children, el));
            me.onMultiSelectChange?.(me);
          }
        }
        el = getColElement(currentCol, currentRow);
        if (el) {
          if (el.field) selectedField = el.field.fieldName;
          if (!viewInfo.horizontal) el.classList.add("grid-item-focused");
        }
        el = getRowElement(currentRow);
        if (el && el.firstChild && el.firstChild.firstChild.isGroup === true) {
          el = getColElement(0, currentRow);
          el.classList.add("grid-item-focused");
        }
      }
      resolve();
    });
  }

  function clearStylesForGroupRec(table) {
    if (table && table.firstChild && table.firstChild.firstChild && table.firstChild.firstChild.isGroup === true) {
      const el = getColElement(0, currentRow);
      el.classList.remove("grid-item-focused");
    }
  }

  function multiSelectStyles(e, rowDelta, prevRowIndex) {
    //функция сохранение и отрисовки выделенных записей
    const row = getRowElement(currentRow), //текущий(новый)
      prevRow = getRowElement(prevRowIndex), //Прошлый
      nextRow = getRowElement(currentRow + rowDelta); //След элемент
    //
    if (viewInfo.horizontal) return;
    function selectManyRecords(index) {
      const signRowDelta = Math.sign(rowDelta) === 1;
      const breakPont = index ? index : me.source.activeRecord;
      for (let i = prevRowIndex; i >= 0; signRowDelta ? i++ : i--) {
        //на основе boolean, понимаем что надо делать с i, i изначально считается от предыдущего элемента
        if (i === breakPont) break; //если мы дошли до currentRow(активной записи)
        if (!multiSelect.includes(`${i}`)) {
          //если нет в массиве
          multiSelect.push(`${i}`);
          createMultiRow(getRowElement(i)); //получаем элемент и рисуем на нем стили
        }
      }
    }
    let index;
    if (
      e &&
      !isEmptyObject(e) &&
      !multiSelect.includes(`${me.source.activeRecord}`) && //если у нас не сохранено в массиве
      ((e.ctrlKey && e.type === "mousedown") || e.shiftKey) //смотрим на ивенты ctrl + mouse и shift + keyDown
    ) {
      multiSelect.push(`${me.source.activeRecord}`); //Сохраняем в массив текущий
      if (row) {
        createMultiRow(row);
        if (e.key === "PageUp" || e.key === "PageDown") {
          //только для page Up/down
          selectManyRecords();
          me.onMultiSelectChange?.(me);
        }
        if (prevRow && row && e.shiftKey && e.type === "mousedown") {
          selectManyRecords(currentRow);
        } else if (
          //Для предыдущего элемента, мы делаем + 1 шаг если выбираем через shift, выбрали 4 запись, перешли на 3. А 4 осталась не выделенной. Вот для чего это условие
          prevRow &&
          nextRow &&
          !containsMultiRow(prevRow) &&
          !containsMultiRow(nextRow)
          // && e.shiftKey
        ) {
          if (rowDelta === 1 || rowDelta === -1) {
            multiSelect.push(`${me.source.activeRecord - rowDelta}`);
            createMultiRow(prevRow);
          }
        }
      }
    } else {
      //если элемент есть в массиве
      if (row && containsMultiRow(row) && (e.shiftKey || e.ctrlKey)) {
        //проверка на ошибки
        if (e.shiftKey && e.type === "keydown") {
          if (nextRow !== undefined && nextRow !== row) {
            //если мы пошли в обратную сторону, снимаем выделение
            index = multiSelect.indexOf(prevRow);
            deleteStyleInRow(prevRow, index);
          }
        } else {
          if (rowDelta === undefined && row && containsMultiRow(row))
            // если кликаем по той же записи
            return;
          // if (row && !containsMultiRow(row)) {
          //   createMultiRow(row);
          // }
          index = multiSelect.indexOf(me.source.activeRecord);
          deleteStyleInRow(row, index);
        }
      } else {
        // значит клик напустое место, удаляем все стили и очищаем массив с записями
        if (viewInfo.horizontal) return;
        document.querySelectorAll(".grid-multi-selection-row").forEach((rowWithStyle) => {
          deleteStyleInRow(rowWithStyle);
        });
        multiSelect.length = 0;
      }
    }
  }

  const containsMultiRow = (row) => {
    return row ? row.classList.contains("grid-multi-selection-row") : undefined;
  };

  const createMultiRow = (row) => {
    if (viewInfo.horizontal) return;
    if ((row && !containsMultiRow(row)) || row.backgroundColor !== "#464646") {
      row.classList.add("grid-multi-selection-row");
      // row.style.backgroundColor = "#464646";
      // row.style.color = "white";
    }
  };

  const deleteStyleInRow = (row, index) => {
    if (viewInfo.horizontal) return;
    if (row) {
      if (containsMultiRow(row)) {
        row.classList.remove("grid-multi-selection-row");
        row.style.backgroundColor = "";
        row.style.color = "";
        me.changeGridStyles?.(row, me);
      }
    }
    try {
      if (index) {
        multiSelect.splice(index, 1);
      } else if (index === 0) {
        multiSelect.splice(index, 1);
      }
    } finally {
      // me.onMultiSelectChange?.(me);
    }
  };

  async function scrollToRecord(record, moveCurrent, changeSource) {
    if (sourceActive()) {
      if (moveCurrent) {
        if (me.getActiveSource().activeRecord != record && changeSource !== false) {
          // hideEditor();
          if (me.getActiveSource().isEditMode()) {
            if (me.getActiveSource().modified) await me.getActiveSource().postRecord();
            else await me.getActiveSource().cancelRecord();
          }
          me.getActiveSource().setRecordIndex(record);
        }
        if (viewInfo.horizontal) {
          me.source.setRecordIndex(record);
        }
        let distance;
        if (me.source.activeRecord > getLastRecord()) {
          distance = me.source.activeRecord - getLastRecord();
        } else if (me.source.activeRecord < getFirstRecord()) {
          distance = me.source.activeRecord - getFirstRecord();
        } else distance = 0;
        if (distance !== 0) firstRecord += distance;
        // me.source.moveBy(distance);
        currentRow = me.source.activeRecord - firstRecord;
        await updateCurrentView();
      } else {
        record = midint(0, me.source.recordCount - visibleRows, record);
        if (record != firstRecord) {
          firstRecord = record;
          currentRow = me.source.activeRecord - firstRecord;
          await updateCurrentView();
        }
      }
    }
  }

  me.scrollToRecord = scrollToRecord;

  function getSelection() {
    let selection = "";
    for (const index of multiSelect) {
      selection += index;
    }
    return selection;
  }
  function setSelection(value) {}
  function notifyGrid(notify) {}

  function saveState() {
    if (me.columns) {
      const groupFields = groups
        .map((val) => {
          return val.fieldName;
        })
        .join();
      const stateObj = {
        IndicatorSize: `${Math.round(indicatorSize)}`,
        ViewMode: `${me.OnlyViewMode ? "1" : "0"}`,
        SelectedColumn: `${currentCol}`,
        ColumnOffset: columnOffset,
        ShowHint: "0",
        sortedFileds: sortedFileds,
        filterData: JSON.stringify(filterData),
        GroupFields: groupFields,
        details: JSON.stringify(me.source.details),
        CardMode: `${viewInfo.horizontal ? "1" : "0"}`,
      };
      if (groupFields === "") delete stateObj.GroupFields;
      for (const value of Object.values(viewInfo.horizontal ? viewInfo.saveColumns : me.columns.title)) {
        if (value) {
          if (value.state) {
            const keyWithLevel = `${value.fieldName}_${value.level}`;
            Object.assign(stateObj, { [keyWithLevel]: value.state }); // todos добавить в ключ level
          } else {
            // createStateForRecord(value, key);
          }
        }
      }

      me.getActiveSource().setGridState(stateObj, true);
      //
      /*
      // SelectedColumn
      ShowHint
      TitleSize
      // ViewMode
      ColumnCount
      // ColumnOffset
      DetailRate
      // GroupFields
      */
    }
  }

  me.ChangeViewMode = function () {
    me.OnlyViewMode = !me.OnlyViewMode;
    changeIndicator(dsBrowse);
    saveState();
  };

  me.updateStateValues = function () {
    saveState();
  };

  function createStateForRecord(field) {
    // грид стейт
    try {
      field.state = {
        0: field.inParentIndex, //index
        1: field.hide === true ? "0" : "1", //visible
        2: field.width, // width
        3: field.marked !== undefined && field.marked === true ? "1" : "0", // marked
        4: "0", // hidden
        5: field.expanded === false ? "1" : "0", // collapsed
        6: field.sortDirect === "up" ? "1" : field.sortDirect === "down" ? "2" : "0", // sortDirect 1-up, 2-down
        7: "0", // filter
        8: "", // defaultText
        9: "0", // defaultCheck
      };
    } catch (err) {}
  }

  function updStateValue(field, index, value) {
    if (!field.state) {
      createStateForRecord(field);
    }
    field.state[index] = value;
    saveState();
  }

  function processLevels(f) {
    function processLevel(level) {
      for (let i = 0, l; i < level.length; i++) {
        l = level[i];
        f.call(me, l);
        if (l.items) {
          processLevel(l.items);
        }
      }
    }

    processLevel(me.columns.levels);
  }

  function getIndexFieldName() {
    let value = "";

    processLevels(function (level) {
      switch (level.field.sortDirect) {
        case "up":
          if (value != "") value += ";";
          value += level.field.fieldName;
          break;
        case "down":
          if (value != "") value += ";";
          value += "-";
          value += level.field.fieldName;
          break;
      }
    });
    //
    sortedFileds = value;
    return value;
  }

  function getGroupFieldNames() {
    let value = "";
    for (let i = 0, field, s; i < groups.length; i++) {
      field = groups[i];
      s = field.fieldName;
      if (field.params) {
        s = s + "." + field.params;
      }
      if (field.sortDirect == "down") {
        s = "-" + s;
      }
      if (value != "") value += ";";
      value += s;
    }
    return value;
  }

  async function checkOrderColumns(fieldName) {
    if (sourceActive()) {
      showApplicationMask(panel);
      try {
        const selection = { value: getSelection() };
        await me.source.orderRecords(fieldName, selection);
        if (multiSelect.length > 0) {
          multiSelect = selection.value.split(",");
        }
        await scrollToRecord(me.source.activeRecord, true);
        await updateCurrentView();
      } finally {
        hideApplicationMask(panel);
        saveState();
      }
      notifyGrid(nfStateChanged);
    }
  }

  me.getGroups = () => {
    return groups;
  };

  me.setGroups = (newGroups) => {
    groups = [...newGroups];
  };

  me.groupByField = (field, clear) => {
    if (clear && groups.indexOf(field) !== -1) {
      groups.splice(groups.indexOf(field), 1);
    } else {
      groups.push(field);
    }
    checkGroupColumnns();
    buildGroupsContent();
    me.onRowGroupingChange?.(groups);
  };

  async function checkGroupColumnns() {
    if (sourceActive()) {
      showApplicationMask(panel);
      try {
        await me.source.groupRecords(getGroupFieldNames());
        await updateRecordTable();
        await scrollToRecord(me.source.activeRecord, true);
      } finally {
        hideApplicationMask(panel);
        saveState();
      }
      notifyGrid(nfStateChanged);
    }
  }

  /**
   * @param {MouseEvent} e
   */
  async function handleMouseUp(e) {
    if (e.button !== 0) return;

    const resizeCardMode = () => {
      if (viewInfo.horizontal) {
        const width = me.panel.offsetWidth - indicatorSize;
        for (const field of Object.values(me.columns.title)) {
          if (handleColumnField.fieldName !== field.fieldName) {
            field.width = width - handleColumnField.width;
          }
        }
      }
    };

    isJustMouseDown = false;
    if (sizeMarker?.style.opacity === "1") {
      //resize
      deleteEvent("mousemove", sizeColumn);
      if (handleColumnField && handleColumnField.eventSize) {
        handleColumnField.width = Math.trunc(handleColumnField.eventSize) - handleColumnField.offset;
        handleColumnField.width = handleColumnField.width >= 25 ? handleColumnField.width : 25;
        resizeCardMode();
        if (handleColumnField.indicator) {
          indicatorSize = handleColumnField.width;
          saveState();
        } else updStateValue(handleColumnField, 2, handleColumnField.width);
        if (handleColumnField && !handleColumnField.indicator) await updateColumns();
        else if (handleColumnField && handleColumnField.indicator) {
          // await updateAllGrid();
          zaglushka();
        }
        await updateAllGrid();
        handleColumnField.eventSize = undefined;
      }
      sizeMarker.style.opacity = "0";
      handleColumnField = null;
      panel.focus();
      me.onColumnWidthChange?.();
      return;
    }
    deleteEvent("mousemove", moveColumn);
    if (dragZone && dragZone.initRect) {
      dragZone.initRect = null;
      hideElement(dragZone);
      hideElement(dragZone.moveTop);
      hideElement(dragZone.moveBottom);

      if (dragZone.isGroup && me.canGroup(handleColumnField)) {
        let i = groups.indexOf(handleColumnField);
        if (i !== -1) groups.splice(i, 1);
        if (dragZone.field) {
          i = groups.indexOf(dragZone.field);
          if (i !== -1) groups.splice(i, 0, handleColumnField);
          else groups.push(handleColumnField);
        } else groups.push(handleColumnField);
        handleColumnField = null;
        dragZone.field = null;
        buildGroups();
        panel.focus();
        me.onRowGroupingChange?.(groups);
        return;
      }

      const findIndexByField = (fieldName, array) =>
        array.find((item) => item.field.fieldName === fieldName)?.field.index;

      if (dragZone.field && dragZone.field.el) {
        const items = handleColumnField.parent,
          item = dragZone.field.el.level,
          oldIndex = findIndexByField(handleColumnField.el.level.field.fieldName, items);
        if (oldIndex !== undefined) {
          const newIndex = findIndexByField(item.field.fieldName, items);
          if (newIndex !== undefined) {
            const updateIndexes = (items) => {
              const direction = newIndex > oldIndex ? -1 : 1;
              items.forEach((item) => {
                const field = item.field;
                const index = field.index;
                if (
                  (newIndex > oldIndex && index > oldIndex && index <= newIndex) ||
                  (newIndex < oldIndex && index >= newIndex && index < oldIndex)
                ) {
                  if (!field.state) {
                    createStateForRecord(field);
                  }
                  field.state[0] = field.index + direction;
                }
                if (item.items) updateIndexes(item.items);
              });
            };
            updateIndexes(items);
            updStateValue(handleColumnField.el.level.field, 0, newIndex); //новый индекс поля
            items.splice(oldIndex, 1);
            items.splice(newIndex, 0, handleColumnField.el.level);
            me.onColumnOrderChange?.(oldIndex, newIndex);
          }
        }
        prepareLevels();
      }
      await updateColumns();
      if (handleColumnField.groupEl) {
        const i = groups.indexOf(handleColumnField);
        if (i !== -1) {
          groups.splice(i, 1);
          buildGroups();
          me.onRowGroupingChange?.(groups);
        }
        handleColumnField.groupEl = null;
      }
      handleColumnField = null;
      dragZone.field = null;
      panel.focus();
      return;
    }

    let el = document.elementFromPoint(e.x, e.y),
      role;
    while (el) {
      role = el.role;
      if (role) break;
      el = el.parentElement;
    }
    if (role) {
      switch (role) {
        case ROLE_COLUMN: {
          if (me.canSort(el.field)) await me.sortByRecord(el, e.shiftKey);
          panel.focus();
          break;
        }
      }
    }
    if (!me.editorMode() && e.target.className.animVal === undefined && !e.target.className.includes("grid-filter"))
      panel.focus();
  }

  async function editColumnFieldClick(el, e) {
    return new Promise(async (resolve) => {
      // if (me.doccfgid === undefined) return resolve(true);
      if (me.RefWithCtrl === undefined) {
        const optionsForUser = getOptionsForUser().RefWithCtrl;
        me.RefWithCtrl = optionsForUser === undefined ? false : optionsForUser;
      }
      let column;
      if (viewInfo.horizontal && el.field.fieldName === "Value") {
        column = el.levelsField.field;
      } else {
        column = el.field;
      }
      if ((me.RefWithCtrl === true && !e.ctrlKey) || column === undefined) return resolve(true);
      const reference = me.getActiveSource().getFieldTextSync(column.fieldName) === "" ? "0" : "1";
      if (
        reference === "1" &&
        me.doccfgid &&
        column.fieldInfo &&
        column.fieldInfo.onEdit !== "" &&
        column.fieldInfo?.options?.link &&
        !me.editorMode()
      ) {
        const linkClick = await EditColumnField({
          DocCfgID: me.doccfgid,
          SectionID: me.sectionid,
          Module: "documents",
          ID: column.fieldInfo.columnID,
          DocID: me.getActiveSource().getFieldTextSync("ID"),
          MasterID: me.getActiveSource().Master.MasterID,
          Reference: me.getActiveSource().getFieldTextSync(column.fieldName) === "" ? "0" : "1",
        });
        tokenProcessingTest(linkClick, {
          from: "grid",
          func: () => {
            if (me.getActiveSource().Master.refreshRecord) {
              me.getActiveSource().Master.refreshRecord(true);
              me.CommitToSaveChanges?.(false);
              resolve(true);
            } else {
              me.refreshSource("!");
              me.CommitToSaveChanges?.(false);
              resolve(true);
            }
          },
          props: {
            Module: el.field.fieldInfo.Module,
            ObjType: el.field.fieldInfo.ObjType,
            ObjRef: el.field.fieldInfo.ObjRef,
          },
        });
      } else if (
        reference === "1" &&
        column.fieldInfo &&
        column.fieldInfo.EditStyle & 16 &&
        column.fieldInfo?.options?.link &&
        !column.fieldInfo.onEdit &&
        !me.editorMode()
      ) {
        const subData = {
          props: {
            ObjType: column.fieldInfo.DataType,
            ObjRef: me.getActiveSource().getFieldValueSync(column.fieldName),
            Buttons: 2,
            PlaneView: "1",
          },
        };
        const json = await GetDocDialogParams(
          column.fieldInfo.DataType,
          me.getActiveSource().getFieldValueSync(column.fieldName),
        );
        if (json.ObjType) subData.props.ObjType = json.ObjType;
        if (json.ObjRef) subData.props.ObjRef = json.ObjRef;

        if (!json.Break) json.Break = "";
        if (!json.Token) json.Token = "HandleTable";
        if (json) tokenProcessingTest(json, subData);
        resolve(false);
      }
    });
  }

  async function handleMouseDown(e) {
    if (e.button != 0 && !e.type.includes("touch")) return;
    let el = e.target || document.elementFromPoint(e.x, e.y),
      role;
    while (el) {
      role = el.role;
      if (role) break;
      el = el.parentElement;
    }
    if (role) {
      switch (role) {
        // start move column
        case ROLE_COLUMN: {
          if (handleColumnField) return;

          handleColumnField = el.field;
          handleColumnField.groupEl = null;
          appendEvent("mousemove", moveColumn);
          break;
        }
        case ROLE_GROUP: {
          if (handleColumnField) return;
          handleColumnField = el.field;
          handleColumnField.groupEl = el;
          appendEvent("mousemove", moveColumn);
          break;
        }
        case ROLE_COLDATA: {
          const newCol = el.col,
            newRow = el.parentElement.row;
          if (newCol === currentCol && newRow === currentRow) {
            // прерывание создания редактора при клике на иконку распахивания записи
            if (e.target.closest("div").id === "ExpandIcon") break;
            if (!me.editorMode() && !e.ctrlKey) {
              await showEditor();
            }
            if (e.ctrlKey) {
              multiSelectStyles(e, 0, currentRow);
              me.onMultiSelectChange?.(me);
            }
          } else await moveColRow(newCol, newRow, e);
          if (me.source.getState() !== dsInsert) await changeIndicator(dsBrowse);
          if (await editColumnFieldClick(el, e)) return;
          break;
        }
        case ROLE_COLLAPSE: {
          const level = el.parentElement.level;
          if (level) {
            if (!el.parentElement.state) {
              saveState();
            }
            if (el.classList.contains("collapse-minus")) {
              el.classList.remove("collapse-minus");
              el.classList.add("collapse-plus");
              level.expanded = false;
              updStateValue(el.parentElement.field, 5, 1);
              hideEditor();
            } else {
              el.classList.remove("collapse-plus");
              el.classList.add("collapse-minus");
              level.expanded = true;
              updStateValue(el.parentElement.field, 5, 0);
              hideEditor();
            }
            // saveState();

            buildColumns();
            await queuedGridScroll.scrollGrid(undefined, buildRecords).then(() => {
              updateScrollBar();
              panel.focus();
            });
          }
          break;
        }
        case ROLE_MARKED: {
          e.stopPropagation();
          el.style.backgroundColor = el.style.backgroundColor === "white" ? "blue" : "white";
          el.field.marked = !el.field.marked;
          saveCurrentMarkedValue(el.field);
          break;
        }
        case ROLE_COLLAPSE_GROUP: {
          const row = el.parentElement.parentElement.row;
          if (row != undefined) {
            await moveColRow(currentCol, row);
            const collapse = await getRecordCollapsed();
            await setRecordCollapsed(!collapse);
          }
          break;
        }
        case ROLE_FILTER: {
          break;
        }
        case ROLE_CHECKBOX: {
          const td = el.closest("td");
          if (td?.col !== currentCol || td?.parentElement?.row !== currentRow) {
            await moveColRow(td?.col, td?.parentElement?.row, e);
          }
        }
      }
    }
    if (me.source.getState() !== dsInsert) await changeIndicator(dsBrowse);
  }

  function saveCurrentMarkedValue(field) {
    if (sourceActive()) {
      me.getActiveSource().saveCurrentMarkedValues(field);
      updStateValue(field, 3, field.marked === true ? "1" : "0");
    }
  }

  async function switchEditorMode() {
    // тут был save, enter - true, f2 - false
    if (inputEditor && inputEditor.deleteClickAway) {
      inputEditor.deleteClickAway();
    }
    if (!me.editorMode()) {
      showEditorThrottle();
    } else {
      await hideEditorMode();
    }
  }

  async function hideEditorMode() {
    if (me.editorMode()) {
      if (me.getActiveSource().modified && editor.onEdit) await editor.onEdit(undefined, inputEditor.value);
      if (!editor.selection) hideEditor(inputEditor.modified);
    }
  }

  async function hideEditorOnKeyDown() {
    if (me.editorMode()) {
      if (me.getActiveSource().modified && editor.onEdit) {
        await editor.onEdit(undefined, inputEditor.value);
      }
      hideEditor(inputEditor.modified);
    }
  }

  function moveColRowCardMode(distance) {
    if (viewInfo.horizontal) {
      me.getActiveSource().moveBy(distance);
      updateCard();
    }
  }

  const showEditorThrottle = throttle((e, keyPass) => {
    setTimeout(async () => {
      if (!e && !me.editorMode()) {
        showEditor();
        return;
      }
      if (!me.editorMode() && !keyPass.includes(e.key) && !document.activeElement.className.includes("grid-filter")) {
        e.preventDefault();
        await showEditor(getKeyForEditor(e));
      } else {
        e.stopPropagation();
      }
    });
  }, 20);

  const copyTextOfCell = (e) => {
    if (e.ctrlKey && e.shiftKey && !me.editorMode()) {
      try {
        const colElement = getColElement(viewInfo.horizontal ? 0 : currentCol, currentRow);
        navigator.clipboard.writeText(
          viewInfo.horizontal ? colElement.nextElementSibling.textContent : colElement.textContent,
        );
        e.preventDefault();
      } catch (err) {
        console.error("Не удалось скопировать", err);
      }
    }
  };

  const keyB = (e) => {
    //todo уточнить на какое сочетание переназначить
    if (e.ctrlKey && !e.shiftKey && !me.editorMode()) {
      e.preventDefault();
      me.ChangeViewMode();
      me.changeIndicator();
    }
  };

  const keyF3Filter = (e) => {
    if (!me.editorMode()) {
      e.preventDefault();
      me.setOptions(1);
    }
  };

  const keyF = (e) => {
    if (e.ctrlKey) {
      hideEditor(true);
      me.searchByColumn(e);
    }
  };

  const keyP = async (e) => {
    if (e.ctrlKey) {
      e.preventDefault();
      if (inputEditor && inputEditor.deleteClickAway) {
        inputEditor.deleteClickAway();
      }
      await hideEditor(true);
    }
  };

  const keyDelete = (e) => {
    if (e.ctrlKey && !me.editorMode() && me.canModify(mfDelete, undefined, me)) {
      e.preventDefault();
      me.deleteRecord();
    }
  };

  const clickEditorButton = async (e, button) => {
    e.preventDefault();
    if (!me.editorMode()) {
      await showEditor(undefined, { renderCommand: button });
    } else inputEditor?.focus();
  };

  /**
   * @param {KeyboardEvent} e
   * @returns {Promise<void>}
   */
  async function handleKeyDown(e) {
    const keyPass = ["F5", "F12", "CapsLock", "Shift", "Alt", "Meta", "Tab"];
    const gridPanel = document.activeElement.closest("div[rcsgrid_panel]");
    const focusCell = gridPanel?.querySelector(".grid-item-focused") || gridPanel?.querySelector(".grid-card-selected");

    // e.stopPropagation();
    // console.log(e);

    if (keypress) return;
    switch (e.code) {
      case "ArrowLeft":
        if (me.editorMode()) break;
        e.preventDefault();
        if (me.source.onRecordCollapsed !== null) {
          const colElement = getColElement(viewInfo.horizontal ? 0 : currentCol, currentRow);
          if (
            colElement.children.length >= 2 &&
            colElement.firstChild.id === "ExpandIcon" &&
            colElement.firstChild.type === "-"
          ) {
            const dataToRecordCollapsed = viewInfo.horizontal
              ? { currentTarget: colElement.firstChild }
              : colElement.firstChild.getAttribute("recordIndex");

            await me.source.onRecordCollapsed(dataToRecordCollapsed);
            // scrollToRecord(ColElement.firstChild.getAttribute("recordIndex"), true);
            break;
          }
        }
        if (await isGroupRecord(true)) {
          if (await getRecordCollapsed()) {
            const record = await me.source.getGroupRecord();
            if (record != -1) scrollToRecord(record, true);
          } else await setRecordCollapsed(true);
        } else {
          if (currentCol == 0 && (await getLevelOffset()) > 0 && columnOffset === 0) {
            const record = await me.source.getGroupRecord();
            if (record != -1) scrollToRecord(record, true);
          } else if (!viewInfo.horizontal) await moveColRow(currentCol - 1, currentRow, e);
          else moveColRowCardMode(-1);
        }
        break;
      case "ArrowRight":
        if (me.editorMode()) break;
        e.preventDefault();
        if (me.source.onRecordCollapsed !== null) {
          const colElement = getColElement(viewInfo.horizontal ? 0 : currentCol, currentRow);
          if (
            colElement.children.length >= 2 &&
            colElement.firstChild.id === "ExpandIcon" &&
            colElement.firstChild.type === "+"
          ) {
            const dataToRecordCollapsed = viewInfo.horizontal
              ? { currentTarget: colElement.firstChild }
              : colElement.firstChild.getAttribute("recordIndex");
            await me.source.onRecordCollapsed(dataToRecordCollapsed);
            break;
          }
        }
        if (await isGroupRecord(true)) {
          if (await getRecordCollapsed()) await setRecordCollapsed(false);
        } else if (!viewInfo.horizontal) await moveColRow(currentCol + 1, currentRow, e);
        else moveColRowCardMode(1);
        break;
      case "ArrowUp":
        e.preventDefault();
        if (e.altKey) {
          clickEditorButton(e, listButton);
          return;
        }
        await hideEditorOnKeyDown();
        if (e.ctrlKey) await scrollView(-1);
        else await moveColRow(currentCol, currentRow - 1, e);
        await changeIndicator(dsBrowse);
        break;
      case "ArrowDown":
        e.preventDefault();
        if (e.altKey) {
          clickEditorButton(e, listButton);
          return;
        }
        await hideEditorOnKeyDown();
        if (e.ctrlKey) await scrollView(1);
        else {
          if (me.source.recordCount !== 0 && me.source.recordCount - 1 === me.source.activeRecord) {
            if (!viewInfo.horizontal && !e.shiftKey && !e.ctrlKey) await me.insertRecord(true);
          } else {
            await moveColRow(currentCol, currentRow + 1, e);
            await changeIndicator(dsBrowse);
          }
        }
        break;
      case "PageUp":
        e.preventDefault();
        await hideEditorOnKeyDown();
        if (e.ctrlKey) await scrollView(-visibleRows, e);
        else await moveColRow(currentCol, currentRow - visibleRows, e);
        break;
      case "PageDown":
        e.preventDefault();
        await hideEditorOnKeyDown();
        if (e.ctrlKey) await scrollView(visibleRows, e);
        else await moveColRow(currentCol, currentRow + visibleRows, e);
        break;
      case "Home":
        if (me.editorMode()) break;
        if (e.ctrlKey) scrollToRecord(-1, true);
        else await moveColRow(0, currentRow);
        break;
      case "End":
        if (me.editorMode()) break;
        if (e.ctrlKey) scrollToRecord(me.source.recordCount, true);
        else await moveColRow(me.columns.fields.length - 1, currentRow);
        break;
      case "Insert":
        if (await me.canModify(mfInsert, undefined, me)) {
          await me.insertRecord(!e.ctrlKey);
        }
        break;
      case "Escape":
        if (me.editorMode()) await hideEditor(false);
        else await me.cancelRecord();
        break;
      case "F1":
        e.preventDefault();
        openHelpContextDialog();
        break;
      case "F2":
        await switchEditorMode();
        break;
      case "F3": {
        keyF3Filter(e);
        break;
      }
      case "NumpadEnter":
      case "Enter":
        if (
          !document.activeElement.className.includes("grid-filter") &&
          !document.activeElement.className.includes("grid-search-input")
        ) {
          if (e.ctrlKey) {
            await clickEditorButton(e, modalButton);
            break;
          }
          e.preventDefault();
          await switchEditorMode();
        }
        break;
      case "KeyA":
        if (!me.editorMode() && !document.activeElement.className.includes("grid-filter") && e.ctrlKey) {
          e.preventDefault();
          multiSelect.length = 0;
          for (let i = 0; i < me.source.recordCount; i++) {
            multiSelect.push(i);
            const row = getRowElement(i);
            if (row) {
              createMultiRow(row);
            }
          }
          me.onMultiSelectChange?.(me);
        }
        break;
      case "KeyP": {
        keyP(e);
        break;
      }
      case "KeyB": {
        keyB(e);
        break;
      }
      case "KeyF": {
        keyF(e);
        break;
      }
      case "KeyQ": {
        if (e.ctrlKey) {
          me.Rotate();
        }
        break;
      }
      case "KeyC": {
        copyTextOfCell(e);
        break;
      }
      case "Space": {
        if (e.ctrlKey) {
          focusCell?.querySelector("div[role=check-box]")?.querySelector("input")?.click();
          break;
        }
      }
      case "KeyO": {
        if (!e.ctrlKey && !e.shiftKey) return;
        if (me.editorMode()) return;
        e.preventDefault();
        const id = me.getActiveSource().getKeyFieldNameData();
        const recCount = me.getActiveSource().recordCount;
        renderMessageBox({
          dlgType: 2,
          message: ` Record Count:${recCount} \n Current ID: ${id} \n IndicatorSize: ${indicatorSize}`,
          buttons: 1,
          selectF: () => {
            me.panel.focus();
          },
        });
        break;
      }
      case "Delete": {
        keyDelete(e);
        break;
      }
      default: {
        if (!e.ctrlKey && e.key !== "Unidentified") showEditorThrottle(e, keyPass);
        break;
      }
    }
  }

  function getKeyForEditor(e) {
    switch (e.code) {
      case "Backspace": {
        return "";
      }
      case "Equal": {
        return "";
      }
      case "F1":
      case "F2":
      case "F3":
      case "F4":
      case "F5":
      case "F6":
      case "F7":
      case "F8":
      case "F9":
      case "F10":
      case "F11":
      case "F12":
        return "";
      default: {
        return e.key;
      }
    }
  }

  me.searchByColumn = async function (e, el) {
    if (e !== undefined) {
      e.preventDefault();
    } else {
      await moveColRow(Array.from(el.parentNode.children).indexOf(el) - 1, currentRow);
    }
    const column = el ? el : getColElement(currentCol, currentRow).field.el;
    const input = document.createElement("input");
    input.type = "text";
    input.className = "grid-search-input";
    input.unhideelements = function () {
      for (let i = 0; i < column.children.length; i++) {
        const child = column.children[i];
        child.style.display = child.style.display === "none" ? "" : "none";
      }
    };
    input.unhideelements();
    input.oninput = async function (e) {
      e.stopPropagation();
      const record = await me.source.SearchRecord(column.field.fieldName, e.currentTarget.value);
      scrollToRecord(record, true);
    };
    input.onkeydown = async function (e) {
      if (e.key === "Enter") {
        e.stopPropagation();
        const record = await me.source.SearchRecord(
          column.field.fieldName,
          e.currentTarget.value,
          me.source.activeRecord + 1,
        );
        scrollToRecord(record, true);
      }
    };
    let removed = false;
    input.visible = true;
    input.SearchRecord = true;
    input.onblur = async function (e) {
      if (removed) return;
      e.currentTarget.unhideelements();
      removed = true;
      e.currentTarget.remove();
      await me.source.SearchRecord(undefined, undefined, -1);
      editor = null;
    };
    column.appendChild(input);
    input.focus();
    editor = input;
  };

  async function scrollView(distance, load) {
    if (sourceActive()) {
      const oldFirstRecord = firstRecord;
      if (distance > 0) {
        firstRecord += distance;
        const max = me.source.recordCount - visibleRows;
        if (firstRecord > max) firstRecord = max;
      } else if (distance < 0) {
        firstRecord += distance;
        if (firstRecord < 0) firstRecord = 0;
      }
      if (oldFirstRecord != firstRecord) {
        currentRow = me.source.activeRecord - firstRecord; // todo проверить в мозилле при скролле
        await updateCurrentView(load);
      }
    }
  }

  async function handleMouseWheel(e) {
    if (me.getActiveSource().modified && editor.onEdit) editor.onEdit(undefined, inputEditor.value);
    if (me.editorMode()) await hideEditor(); //todo postRecord with Scroll
    //
    const deltaY = e.type === "touchmove" ? touchStartY - e.touches[0].clientY : e.deltaY;
    e.preventDefault();
    if (e.shiftKey) {
      if (e.deltaY < 0) {
        if (columnOffset > 0) {
          columnOffset--;
          await updateAllGrid(false);
        }
      } else if (e.deltaY > 0) {
        if (rightOverflow) {
          columnOffset++;
          await updateAllGrid(false);
        }
      }
    } else {
      if (deltaY < 0) {
        await scrollView(-1);
      } else if (deltaY > 0) {
        await scrollView(1);
      }
    }
  }

  function buildColumns() {
    if (editor) editor.ready = false;
    getFixedCol();
    let last,
      left = 0,
      maxlev = 1,
      checkMargin = columnOffset;
    const totalWidth = me.header.getBoundingClientRect().width,
      levels = me.columns.levels;

    while ((last = me.header.lastChild)) {
      me.header.removeChild(last);
    }

    if (!levels) return;

    function getMaxLevel(level) {
      const res = 1;
      let max = 0;
      if (level.items && level.expanded) {
        for (let i = 0; i < level.items.length; i++) {
          max = maxint(max, getMaxLevel(level.items[i]));
        }
      }
      return res + max;
    }

    for (let i = 0; i < levels.length; i++) {
      maxlev = maxint(maxlev, getMaxLevel(levels[i]));
    }

    childColumnSize = rowHeight;
    titleSize = maxlev * childColumnSize;

    me.header.style.height = titleSize + "px";

    if (showIndicator) {
      // let anchorElButton = null
      const el = document.createElement("div");
      el.className = "grid-column";
      el.id = "indicatorColumn";
      el.style.position = "absolute";
      el.style.left = left + "px";
      el.style.width = Math.trunc(indicatorSize) + "px";
      el.style.height = "100%";
      el.style.display = "flex";
      el.style.justifyContent = "flex-start";
      el.style.alignItems = "center";
      el.style.backgroundColor = "#faf9f5";
      el.style.border = "none";
      el.field = { offset: left };
      const collumnsButton = document.createElement("div");
      el.appendChild(collumnsButton);
      const dataOfHiddenCols = viewInfo.horizontal ? viewInfo.saveColumns.levels : me.columns.levels;
      if (!isEmptyObject(dataOfHiddenCols)) {
        createRoot(collumnsButton).render(
          <ColumnButton onClick={onMenuItemClick} data={dataOfHiddenCols} viewInfo={viewInfo} />,
        );
        createStatusButtonForCardMode();
        me.header.appendChild(el);
      }
      if (me.doccfgid && me.getActiveSource() && me.getActiveSource().Master.MasterID) {
        const cardModeButtonDiv = document.createElement("div");
        el.appendChild(cardModeButtonDiv);
        createRoot(cardModeButtonDiv).render(<CardModeButton rotateState={viewInfo.horizontal} onClick={me.Rotate} />);
      }
      left += Math.trunc(indicatorSize);
    }

    function onMenuItemClick(field) {
      me.hideColumn(field);
    }

    function createFieldElement(level, left, top, width, height) {
      let tmp;
      const field = level.field;
      if (field.hide === true || field.hideInGrid === true) {
        return 0;
      }
      if (level.items && level.expanded) {
        //рисование под-записей
        width = 0;
        for (let i = 0, l = left, w, lev, fld; i < level.items.length; i++) {
          lev = level.items[i];
          fld = lev.field;
          w = Math.trunc(fld.width);
          if (l + w > totalWidth) {
            overflowColumns = true;
            rightOverflow = true;
            w -= l + w - totalWidth;
            if (w < rowHeight) break;
            i = level.items.length;
          }
          w = createFieldElement(lev, l, top + childColumnSize, w, height - childColumnSize);
          width += w;
          l += w;
        }
        height = childColumnSize;
      } else {
        if (checkMargin > 0 && !(field.fieldInfo && field.fieldInfo?.options?.fixed)) {
          checkMargin--;
          return 0;
        }
        me.columns.fields.push(field);
      }
      const el = document.createElement("div");
      el.className = "grid-column";
      el.style.position = "absolute";
      el.style.left = left + "px";
      el.style.top = top + "px";
      el.style.width = Math.trunc(width) + "px";
      el.style.height = height + "px";
      el.style.display = "flex";
      el.style.alignItems = "top";
      if (field.fieldInfo && field.fieldInfo.titleBackColor) el.style.backgroundColor = field.fieldInfo.titleBackColor;
      el.role = ROLE_COLUMN;
      field.offset = left;
      field.top = top;
      field.height = height;
      field.elementWidth = width;
      el.field = field;
      el.level = level;
      field.el = el;

      const flexContainer = document.createElement("div");
      flexContainer.style.display = "flex";
      flexContainer.style.alignItems = "flex-start";
      flexContainer.style.justifyContent = "space-between";
      flexContainer.style.flexFlow = "column warp";
      flexContainer.style.width = "10px";
      // el.appendChild(flexContainer);

      if (level.items) {
        tmp = document.createElement("div");
        tmp.classList.add("collapse-img");
        tmp.style.position = "inherit";
        if (level.expanded) {
          tmp.classList.add("collapse-minus");
        } else {
          tmp.classList.add("collapse-plus");
        }

        tmp.role = ROLE_COLLAPSE;
        el.appendChild(tmp);
      }

      if (field.marked !== undefined) {
        el.appendChild(createRoundButton(field));
      }

      tmp = document.createElement("div");
      tmp.style.textAlign = "center";
      tmp.style.width = "calc(100%)";
      const parentdiv = document.createElement("div");
      const spanForText = document.createElement("span");
      spanForText.className = "column-span";
      spanForText.style.width = "100%";
      parentdiv.className = "column-header-text";
      createStyleColumn(parentdiv, field);
      if (!field.fieldInfo?.NoTitle) {
        spanForText.innerText = field.title;
      }
      parentdiv.appendChild(spanForText);
      tmp.appendChild(parentdiv);
      if (field.fieldInfo && field.fieldInfo.titleAjust === "0") {
        parentdiv.style.justifyContent = "flex-start";
        spanForText.style.marginLeft = "3px";
      }
      // tmp.innerHTML =
      //   '<span class="column-header-text">' + field.title + "</span>";
      tmp.className = "grid-column-title";
      if ((level.items && level.items.length > 0) || field.marked !== undefined) {
        tmp.style.marginLeft = "10px";
        tmp.style.width = `calc(100% - ${tmp.style.marginLeft}px - ${el.style.paddingRight}px)`;
        spanForText.style.width = "86%";
      }
      el.appendChild(tmp);

      switch (field.sortDirect) {
        case "up":
          tmp.children[0].classList.add("column-sort-asc");
          break;
        case "down":
          tmp.children[0].classList.add("column-sort-desc");
          break;
      }

      if (
        field &&
        field.fieldInfo?.options &&
        field.fieldInfo?.options?.filterByField === true //кнопка фильтра
      ) {
        const sortIcon = document.createElement("div");
        sortIcon.style.backgroundColor = "inherit";
        sortIcon.style.border = "none";
        sortIcon.style.position = "absolute";
        sortIcon.style.right = "-1px";
        sortIcon.style.width = "15px";
        sortIcon.style.height = "15px";
        sortIcon.style.cursor = "pointer";
        sortIcon.style.zIndex = "6";
        sortIcon.style.bottom = "3px";
        sortIcon.role = "filter";

        el.appendChild(sortIcon);
        // organizations~HandleTable?LicGUID=9B48C3FA4500D58FDE37289B4EBA91E1&SectionID=145&GroupID=931&ObjType=2310&ID=359
        // documents~HandleDocument?LicGUID=4BD600B446FEC0F05E57528346D3366D&DocCfgID=3000&SectionID=109&ParentID=0
        el.style.paddingRight = "12px";
        tmp.style.width = `calc(100% - ${tmp.style.marginLeft} - ${el.style.paddingRight})`;
        //
        createRoot(sortIcon).render(
          <FilterGridComponent
            props={{
              request: me.getActiveSource().onHandleRequest,
              dataForReq: {
                Command: "FilterValues",
                FieldName: field.fieldName,
              },
              searchProps: {
                editMask: field.fieldInfo.editMask,
                datatype: field.fieldInfo.EditStyle & 2 && "date",
              },
              ParentID: me.source.Master.MasterID,
              DocCfgID: me.doccfgid,
              applyFilter: me.applyColumnFilter,
              filterDiv: me.filter,
              filterData: filterData,
            }}
          />,
        );
      }
      //
      // panel.querySelectorAll(".grid-size-marker").map((resizer)=>{
      //   resizer.remove()
      // })

      me.header.appendChild(el);
      return Math.trunc(width);
    }

    function createStyleColumn(span, field) {
      if (field.fieldInfo) {
        if (field.fieldInfo.Image) {
          const imgDiv = document.createElement("div");
          imgDiv.position = "absolute";
          const img = createImgByIndex(field.fieldInfo.Image);
          img.style.width = "12px";
          img.className = "grid-column-img";
          imgDiv.style.width = "17px";
          if (img.src) {
            imgDiv.appendChild(img);
            span.appendChild(imgDiv);
          }
          // span.style.background = `url(${img.src}) left center no-repeat`;
          // span.style.backgroundSize = "contain"
        }
        if (field.fieldInfo.titleTextStyle) {
          const style = Number(field.fieldInfo.titleTextStyle);
          span.style.fontWeight = style & 1 ? "bold" : "";
          span.style.fontStyle = style & 2 ? "italic" : "";
          span.style.textDecoration = style & 4 ? "underline" : style & 8 ? "line-through" : "";
        }
        if (field.fieldInfo.textColor) {
          span.style.color = setColor(Number(field.fieldInfo.textColor));
        }
      }
    }

    me.columns.fields = [];
    overflowColumns = columnOffset != 0;
    rightOverflow = false;

    for (let i = 0, level, field, width; i < levels.length; i++) {
      level = levels[i];
      field = level.field;
      if (field.hide !== true) {
        width = Math.trunc(field.width);
        if (left + width > totalWidth) {
          overflowColumns = true;
          rightOverflow = true;
          width -= left + width - totalWidth;
          if (width < rowHeight) break;
          i = levels.length;
        }
        left += createFieldElement(level, left, 0, width, titleSize);
      }
    }

    me.header.style.height = titleSize + "px";
    if (viewInfo.horizontal) {
      const divTitleForHorizontal = document.createElement("div");
      divTitleForHorizontal.style.height = titleSize - 2 + "px";
      divTitleForHorizontal.style.position = "relative";
      divTitleForHorizontal.style.left = indicatorSize + "px";
      divTitleForHorizontal.style.width = `calc(100% - ${indicatorSize + "px"})`;
      divTitleForHorizontal.style.backgroundColor = "rgb(250, 249, 245)";
      divTitleForHorizontal.id = "TitleForHorizontal";
      divTitleForHorizontal.className = "TitleForHorizontal";
      me.header.appendChild(divTitleForHorizontal);
    }
    if (me.columns.fields.length > 1) {
      const field = me.columns.fields[me.columns.fields.length - 1];
      me.columns.stubField = {
        offset: field.offset + field.width,
        el: field.el,
        parent: me.columns.levels,
      };
    }
    buildFilters();
    if (overflowColumns && !leftRightMover.parentElement && !viewInfo.horizontal) {
      me.header.appendChild(leftRightMover);
    }
  }

  function createImgByIndex(index) {
    const imgDiv = document.createElement("div");
    imgDiv.position = "absolute";
    const img = document.createElement("img");
    img.draggable = false;
    const src = getIcons(index);
    if (src) img.src = ImgURLSRC(src);
    return img;
  }

  function createRoundButton(field) {
    const button = document.createElement("div");
    button.style.width = "6px";
    button.style.height = "6px";
    button.style.borderRadius = "50%";
    button.style.border = "1px solid";
    button.style.backgroundColor = field.marked === false ? "white" : "blue";
    button.style.position = "absolute";
    button.style.bottom = "3px";
    button.style.left = "2.2px";
    // button.style.inset = "0px 0px 3px 2.2px";
    button.style.cursor = "pointer";
    button.field = field;
    button.role = ROLE_MARKED;
    return button;
  }

  me.hideColumn = async function (field) {
    if (field.hide === undefined) {
      field.hide = true;
    } else {
      field.hide = !field.hide;
    }
    updStateValue(field, 1, field.hide ? "0" : "1");
    if (viewInfo.horizontal) updateCard(false);
    await updateAllGrid();
  };

  function createResizers() {
    if (me.DisableResize !== false) {
      panel.querySelectorAll(".grid-size-marker").forEach((r) => {
        r.remove();
      });
      const resizerHeight = visibleRows * rowHeight + titleSize + "px";
      let i = 0;
      for (const column of me.header.children) {
        if (column.className === "pagination") break;
        if (
          (me.header.children[i - 1] && column.field && column.field.level < me.header.children[i - 1].field.level) ||
          (viewInfo.horizontal && column === me.header.children[0]) ||
          (viewInfo.horizontal && column === me.header.children[2])
        ) {
        } else {
          const resizer = document.createElement("div");
          resizer.classList = "grid-size-marker";
          resizer.style.left = parseInt(column.style.width) + parseInt(column.style.left) + "px";
          resizer.style.opacity = "0";
          resizer.style.height = resizerHeight;
          if (column === me.header.children[0]) {
            resizer.style.height = "100%";
            column.field.indicator = true;
          }
          resizer.ondblclick = () => {
            autoFitColumnWidth(column.field);
          };
          resizer.onmousedown = (e) => {
            if (e.button !== 0) return;
            if (handleColumnField === null || handleColumnField === undefined) {
              handleColumnField = column.field;
              resizer.style.opacity = "1";
              sizeMarker = resizer;
              if (handleColumnField) {
                appendEvent("mousemove", sizeColumn);
              }
            }
          };
          panel.appendChild(resizer);
        }
        i++;
      }
    }
  }

  function buildGroups(fieldName) {
    //todo сделать внешней для контекстного меню
    if (me.groups) {
      groupSize = me.groups.getBoundingClientRect().height;
      let last;
      while ((last = me.groups.lastChild)) {
        me.groups.removeChild(last);
      }
      buildGroupsContent();
      groupSize = me.groups.getBoundingClientRect().height;
      me.table.style.top = groupSize + filterSize + titleSize + "px";
    }
    checkGroupColumnns();
    // zaglushka();
  }

  function buildGroupsContent() {
    if (groups.length > 0) {
      me.groups.innerHTML = "";
      groupSize = maxint(groupSize, rowHeight * groups.length);
      me.groups.style.height = groupSize + "px";
      for (let i = 0, el, field, l = 3, w, t = 3; i < groups.length; i++) {
        field = groups[i];
        w = 100;
        el = document.createElement("div");
        el.style.position = "absolute";
        el.style.left = l + "px";
        el.style.top = t + "px";
        el.style.width = w + "px";
        el.textContent = field.title;
        el.field = field;
        el.classList.add("grid-column");
        el.role = ROLE_GROUP;
        me.groups.appendChild(el);
        t += 7;
        l += w + 3;
      }
      groupSize = me.groups.lastChild.getBoundingClientRect().bottom - me.groups.getBoundingClientRect().top + 3;
      if (groupSize < 43) groupSize = 43;
      me.groups.style.height = groupSize + "px";
    } else {
      me.groups.style.height = rowHeight + "px";
      me.groups.innerHTML = '<p class="grid-groups-text">Для группировки перетащите сюда заголовок колонки</p>';
    }
    groupSize = me.groups.getBoundingClientRect().height;
    me.table.style.top = groupSize + filterSize + titleSize + "px";
  }

  const sortFieldsByState = () => {
    if (!me.getActiveSource()) return;
    const state = me.getActiveSource().getGridState();
    if (!state) return;
    const sortLevels = (levels) => {
      const indexedLevels = levels.map((level, index) => {
        const keyInState = level.field.fieldName + `_${level.level}`;
        if (state[keyInState]) {
          return { index: state[keyInState][0], level };
        }
        return { index: index, level };
      });
      indexedLevels.sort((a, b) => {
        return a.index - b.index;
      });
      return indexedLevels.map(({ level }) => {
        if (level.items && Array.isArray(level.items)) {
          return { ...level, items: sortLevels(level.items) };
        }
        return level;
      });
    };

    // Перезаписываем levels новым отсортированным массивом
    const sortedCols = sortLevels(me.columns.levels);
    if (sortedCols) {
      me.columns.levels = sortedCols;
    }
  };

  function prepareLevels() {
    me.columns.levels = [];
    me.columns.fields = [];
    groups = [];
    const title = me.columns.title,
      parents = [];

    function getParent(value) {
      let level;
      if (intInRange(value, 0, parents.length - 1)) {
        level = parents[value];
        if (level) {
          if (!level.items) level.items = [];
          return level.items;
        }
      }
      return me.columns.levels;
    }
    const stateData = useageDataFromState();
    const stateGroupFields = stateData?.GroupFields ?? [];
    const stateGroupOrder = new Map(stateGroupFields.map((fieldName, index) => [fieldName, index]));
    selectedField = title[0] ? title[0].fieldName : "";
    currentCol = 0;
    for (let i = 0, level, field, parent, state; i < title.length; i++) {
      field = title[i];
      level = { field: field };
      state = getGridStateFieldValue(field);
      if (field.level) level.level = maxint(0, field.level);
      else level.level = 0;
      if (!field.title) field.title = field.fieldName;
      while (parents.length <= level.level) parents.push({});
      parents[level.level] = level;
      parent = getParent(level.level - 1);
      parent.push(level);
      const inParentIndex = parent.indexOf(level);
      if (parents[0].field && (parents[0].field.hideInGrid || parents[0].field.hideInCard)) {
        field.hideInCard = parents[0].field.hideInCard;
        field.hideInGrid = parents[0].field.hideInGrid;
      }
      field.index = i;
      field.inParentIndex = Number(inParentIndex);
      field.levelsIndex = parent.level - 1;
      if (field.fieldInfo && field.fieldInfo.options) {
        if (field.fieldInfo?.options?.markable) {
          field.marked = false;
        }
        if (!viewInfo.horizontal) {
          if (field.fieldInfo?.options?.fixed) {
            field.fixed = true;
            fixedColumn = field;
          }
        }
      }
      if (state) {
        field.state = state;
        field.index = Number(state[0]);
        field.inParentIndex = Number(state[0]);
        field.hide = state[1] === "0";
        field.width = Number(state[2]);
        if (state[6].includes("1") || state[6].includes("2")) {
          //сортировка
          field.sortDirect = state[6] === "1" ? "up" : "down";
        }
        if (state[3] === "1") {
          //маркированный колумн
          field.marked = true;
          // saveCurrentMarkedValue(field);
          if (sourceActive()) me.source.saveCurrentMarkedValues(field);
        }
        level.expanded = state[5] !== "1"; // expand for field state[5] === "1" ? true : false;
      } else {
        level.expanded = false; // expand for field
      }

      field.expanded = level.expanded;
      field.parent = parent;
      if (stateGroupOrder.has(field.fieldName)) {
        groups.push(field);
      }
    }
    groups.sort((a, b) => stateGroupOrder.get(a.fieldName) - stateGroupOrder.get(b.fieldName));
    sortFieldsByState();
  }

  function useageDataFromState() {
    const state = getGridStateFieldValue();
    let returnStateData = {};
    if (state) {
      if (state.IndicatorSize) indicatorSize = Number(state.IndicatorSize);
      if (state.filterData) filterData = JSON.parse(state.filterData);
      else filterData = {};
      if (state.GroupFields)
        returnStateData = {
          ...returnStateData,
          GroupFields: state.GroupFields.split(","),
        };
    }
    return returnStateData;
  }

  function getGridStateFieldValue(field, index) {
    //Получение инфо для поля
    if (sourceActive() && !isEmptyObject(me.source.getGridState())) {
      if (index) {
        return me.source.getGridState()[field.fieldName + `_${field.level}`][index];
      } else if (field) {
        return me.source.getGridState()[field.fieldName + `_${field.level}`];
      } else {
        return me.source.getGridState();
      }
    }
  }

  me.setImageFields = function (imgFields) {
    if (typeof imgFields === "string") {
      imageFields = imgFields.split(",");
    } else if (typeof imgFields === "object") {
      imageFields = imgFields;
    }
    indicatorSize = imageFields.length * 15 + 42 > 123 ? 123 : imageFields.length * 15 + 42;
    // zaglushka()
  };

  me.setColumns = function (columns) {
    me.columns = columns;
    prepareLevels();
    me.defaultColumns = false;
  };

  me.setIndicatorSize = function (size) {
    indicatorSize = size;
  };

  me.deleteRecord = function (index) {
    return new Promise(async (resolve) => {
      if (viewInfo.horizontal) return resolve();
      const deleteRecords = async (e) => {
        if (e.currentTarget.value == DlgRes.No) return resolve();
        if (me.onDeleteRecord) {
          return resolve(await me.onDeleteRecord(index, me));
        }
        if (multiSelect.length > 0) {
          const sortedMultiSelect = multiSelect.toSorted();
          for (let i = sortedMultiSelect.length - 1; i >= 0; i--) {
            await me.getActiveSource().deleteRecord(sortedMultiSelect[i]);
            await me.getActiveSource().Master?.refreshRecord?.();
          }
          // multiSelect.forEach(async (index) => {
          //   await me.getActiveSource().deleteRecord(index);
          // });
          multiSelect.length = 0;
        } else {
          await me.getActiveSource().deleteRecord(index);
          await me.getActiveSource().Master?.refreshRecord?.();
        }
        resolve(await updateRecordTable(true));
      };
      const message = multiSelect.length > 0 ? "Удалить выбранные записи?" : "Удалить текущую запись?";
      renderMessageBox({ dlgType: 3, buttons: 12, message: message, selectF: deleteRecords });
    });
  };

  me.firstScroll = function () {
    me.getActiveSource().first();
    if (!viewInfo.horizontal) scrollToRecord(0, true);
    else updateCard();
  };

  me.lastScroll = function () {
    me.getActiveSource().last();
    if (!viewInfo.horizontal) scrollToRecord(me.getActiveSource().recordCount - 1, true);
    else updateCard();
  };

  me.scrollTo = async function (index) {
    await scrollToRecord(index, true);
  };

  me.getMultiSelect = function () {
    return multiSelect;
  };

  me.sortByRecord = async function (el, multi, clear) {
    deleteEvent("mousemove", moveColumn);
    handleColumnField = null;
    let temp;
    const field = el.field;
    if (!el.classList.contains("column-header-text")) {
      temp = el.getElementsByClassName("column-header-text");
      if (temp && temp.length > 0) el = temp[0];
      else el = null;
    }
    if (el && me.source.onRecordCollapsed === null) {
      temp = me.header.getElementsByClassName("column-header-text");
      if (!multi) {
        const clearSortDirect = (level) => {
          level.field.sortDirect = "";
          if (level.items) {
            level.items.forEach(clearSortDirect);
          }
        };

        me.columns.levels.forEach(clearSortDirect);
        if (temp) {
          for (let i = 0, t; i < temp.length; i++) {
            t = temp[i];
            if (t != el) {
              t.classList.remove("column-sort-asc");
              t.classList.remove("column-sort-desc");
            }
          }
        }
      }

      const chooseSortDirect = (classList, sortDirect) => {
        if (!clear) {
          el.classList.add(classList);
          field.sortDirect = sortDirect;
        } else {
          delete field.sortDirect;
        }
      };
      if (el.classList.contains("column-sort-asc")) {
        el.classList.remove("column-sort-asc");
        chooseSortDirect("column-sort-desc", "down");
      } else {
        el.classList.remove("column-sort-desc");
        chooseSortDirect("column-sort-asc", "up");
      }
      const sortDirect = field.sortDirect === "up" ? "1" : field.sortDirect === "down" ? "2" : "0";
      updStateValue(field, 6, sortDirect);
      await checkOrderColumns(getIndexFieldName());
    }
  };

  me.moveRecord = async function (record) {
    if (viewInfo.horizontal) {
      moveColRowCardMode(record);
      return;
    }
    const moveCol = throttle(moveColRow, 10);
    drawing = true;
    moveCol(currentCol, currentRow + record);
    // setTimeout(() => {
    //   handleKeyDown(e)
    // .then(() => {
    drawing = false;
    // const moverecordNext =
    //   record === -1 ? me.getActiveSource().activeRecord - 1 : me.getActiveSource().activeRecord + 1;
    // if (moverecordNext >= 0 && moverecordNext <= me.getActiveSource().recordCount - 1)
    // await moveColRow(currentCol, currentRow + record);
    // await scrollToRecord(moverecordNext, true);
  };

  me.ChangeSave = function (bool) {
    if (me.source) me.source.ChangeSave(bool);
  };

  me.getFieldInfo = (fieldName = selectedField) => {
    return me.columns.title.find((field) => field.fieldName === fieldName);
  };

  me.getSelectedField = function () {
    return selectedField;
  };

  me.ShowIndicatorF = function (bool) {
    showIndicator = bool;
    if (indicator !== null) {
      indicator.remove();
      indicator = null;
    }
    if (me.zaglushka) {
      me.zaglushka.remove();
    }
  };

  async function updateRowCount() {
    // let rowCount = 1000;
    if (me.source.recordCount < firstRecord) firstRecord = 0;
    // rowCount = maxint(
    //   await me.source.acquireRecords(firstRecord, visibleRows),
    //   1
    // );//todo
    updateActive();
    if (viewInfo.horizontal && viewInfo.fixedColumn && viewInfo.columnSource) {
      //todo// moveFixedColumn()
    }
  }

  me.postSomeData = async function (fieldName, data, recordIndex) {
    // Для данных снаружи(текстовые блоки и т д)
    const source = me.getActiveSource();
    if (!source.isEditMode()) {
      await source.editRecord(recordIndex);
      // changeIndicator(dsEdit);
    }
    // await source.editRecord();
    await setColumnText(
      { fieldName: fieldName, index: recordIndex },
      data.text !== undefined ? data.text : await source.getFieldText(fieldName),
    );
    await setColumnValue(
      { fieldName: fieldName, index: recordIndex },
      data.id !== undefined ? data.id : await source.getFieldValue(fieldName),
    );
    // me.CommitToSaveChanges && me.CommitToSaveChanges(me);
  };

  me.postExicstedEditRec = async function (load) {
    // if(editor && editor.EditData){
    //
    //   const setObjTextData =  SetObjectText({...editor.EditData, value:editor.text})
    //   const dataWithCheck=  me.getActiveSource().CheckFieldText(editor.column.fieldName, setObjTextData.ObjRef, setObjTextData.Text);
    //   me.postSomeData(editor.column.fieldName, {text:dataWithCheck.Text, id:dataWithCheck.ObjRef})
    // }
    await changeIndicator(dsBrowse);
    await me.CommitToSaveChanges?.(false);
    if (me.editorMode() && editor.InputChange) {
      inputEditor.focus();
      delete editor.InputChange;
      await hideEditor();
      return;
    } else {
      // updateRecordTable();
    }

    const recIndex = me.source.activeRecord;
    await me.getActiveSource().postRecord();
    if (!viewInfo.horizontal) {
      await updateRecordTable(load);
      await scrollToRecord(recIndex, true);
    } else {
      if (viewInfo.horizontal) await updateCard(false);
    }
    await hideEditor();
    //
  };

  me.refreshSource = async function (key, info) {
    if (me.source && me.source.checkActive(key != undefined && key != "")) {
      // showApplicationMask(panel);
      let dataFromRefrsh;
      if (viewInfo.horizontal) {
        await viewInfo.saveSource.refresh(key);
        await viewInfo.saveSource.acquireRecords(viewInfo.saveSource.activeRecord, 1);
        await me.source.refresh("!");
        if (assignBMList.length === 0) await me.source.refresh();
      } else {
        dataFromRefrsh = await me.source.refresh(key, info);
        updFieldsFromRefresh(dataFromRefrsh);
      }
      if (sourceActive()) {
        let distance;
        //
        //   `moddiv ${moddiv(me.data.clientHeight, rowHeight)} `,
        //   `ClientHeight ${me.data.clientHeight} `,
        //   `activeRecord ${me.source.activeRecord} `,
        //   `lastRecord ${getLastRecord()} `,
        //   `firstRecord ${getFirstRecord()} `,
        //   `rowHeight ${rowHeight} `,
        //   `recordCount ${me.source.recordCount} `
        // );
        updateRowCount();
        // if (me.source.activeRecord > getLastRecord()) {
        //   if (
        //     moddiv(me.data.clientHeight, rowHeight) < me.source.recordCount &&
        //     me.source.activeRecord - getLastRecord() >
        //       moddiv(me.data.clientHeight, rowHeight)
        //   ) {
        //     if (
        //       me.source.activeRecord + moddiv(me.data.clientHeight, rowHeight) <
        //       me.source.recordCount
        //     ) {
        //       distance = me.source.activeRecord;
        //     } else {
        //       distance =
        //         me.source.activeRecord -
        //         moddiv(me.data.clientHeight, rowHeight);
        //     }
        //     // if (distance < 0) distance = 0;
        //   } else {
        //     distance = 0;
        //   }
        // } else if (me.source.activeRecord < getLastRecord()) {
        //   if((me.source.activeRecord -
        //     moddiv(me.data.clientHeight, rowHeight)) > 0){
        //       distance =
        //       me.source.activeRecord -
        //       moddiv(me.data.clientHeight, rowHeight);

        //     }

        // }

        visibleRows = moddiv(me.data.clientHeight, rowHeight);
        if (visibleRows > me.source.recordCount) {
          visibleRows = me.source.recordCount;
        }

        if (me.source.activeRecord > getLastRecord()) {
          if (getLastRecord() == -1) {
            distance = me.source.activeRecord - moddiv(me.data.clientHeight, rowHeight) + 1;
            if (distance < 0) distance = 0;
          } else {
            distance = 0;
            distance = me.source.activeRecord - getLastRecord();
          }
        } else if (me.source.activeRecord < getFirstRecord()) {
          distance = me.source.activeRecord - getFirstRecord();
        } else distance = 0;

        // else if (maxint(me.source.acquireRecords(firstRecord, visibleRows), 1) < visibleRows)
        //   distance = maxint(me.source.acquireRecords(firstRecord, visibleRows), 1) - minint(visibleRows, me.source.recordCount);
        // else distance = 0;
        if (distance === undefined) {
          distance = 0;
        }
        //
        if (distance != 0) {
          firstRecord += distance;
          updateRowCount();
        }
        updateEditor();
      }
      // delayCall(updateCurrentView);
      // hideApplicationMask(panel)
      multiSelect = [];
      await updateAllGrid();
      // me.CommitToSaveChanges && me.CommitToSaveChanges(false);
      me.onMultiSelectChange?.(me);
    }
  };

  function updFieldsFromRefresh(data) {
    if (data && data.Columns) {
      for (const [key, value] of Object.entries(data.Columns)) {
        let col = {};
        let field = me.columns.title.filter((val) => {
          return val.fieldName === key;
        });
        field = field[0];
        const index = me.columns.title.indexOf(field);
        const isHidden = value.Hidden === "1";
        if (field) {
          if (isHidden && index) {
            me.columns.title.splice(index, 1);
          } else {
            field.hide = isHidden;
            if (field.state && field.state[1]) field.state[1] = isHidden ? "0" : "1";
            if (value.Caption) field.title = value.Caption;
            me.columns.title[index] = field;
          }
        } else {
          if (isHidden) continue;
          const findedFieldInSource = me.getActiveSource().fields.find((field) => field.fieldName === key);
          col = {
            fieldName: key,
            title: findedFieldInSource.displayLabel || key,
            width: parseInt(value.Width * 1.33) || 100,
            level: parseInt(value.Deep || value.Level) || 0,
          };
          me.columns.title.push(col);
        }
      }
      me.setColumns(me.columns);
    }
  }

  me.setOptions = async function (options) {
    for (const [key, value] of Object.entries(constOptions)) {
      if ((value & options) === value) {
        switch (key) {
          case "filter":
            showFilter();
            break;
          case "groupBy":
            showGroup();
            break;
        }
      }
    }
    await updateRecordTable();
    await updateAllGrid();
  };

  me.updateGridSize = async function () {
    await updateAllGrid();
    // RebuildSizeMaker()
  };

  function getFieldForEditor() {
    console.log(viewInfo);
  }

  function getCorrectionHorizontalOn(arr, data) {
    for (const item of arr) {
      if (data.indexCol > data.trueCurrentCol) return data.result;
      data.indexCol++;

      if (item.expanded) {
        data.result++;
        data.trueCurrentCol++;
      }

      if (item.expanded && item.items && item.items.length !== 0) {
        data.result = getCorrectionHorizontalOn(item.items, data);
      }
    }
    return data.result;
  }

  function getCorrectionHorizontalOff(arr, data) {
    for (const item of arr) {
      if (data.indexCol >= data.trueCurrentCol) return data.result;
      data.indexCol++;

      if (item.expanded) {
        data.result++;
        data.trueCurrentCol++;
      }

      if (item.expanded && item.items && item.items.length !== 0) {
        data.result = getCorrectionHorizontalOff(item.items, data);
      }
    }
    return data.result;
  }

  me.Rotate = async function (view, newSource) {
    // if (window.location.host !== "localhost:3000") {
    //   alert("Функционал находится в разработке.");
    //   return;
    // }
    if (!canRotate) return;
    // if(viewInfo.horizontal) return
    if (me.editorMode()) {
      await hideEditor();
    }
    let sourceHorizontal = {};
    updateGridSelectedClass();
    if (!viewInfo.horizontal) {
      if (!viewInfo.source) {
        sourceHorizontal = await createColumnSource();
      } else {
        sourceHorizontal = viewInfo.source;
      }
      if (!viewInfo.columns) {
        viewInfo.columns = createViewColumns();
      }
      viewInfo.saveSource = me.source;
      viewInfo.saveColumns = me.columns;
      viewInfo.source = sourceHorizontal;
      viewInfo.currentRow = currentCol;
      if (me.filter.style.display === "grid") {
        // скрытие
        await me.setOptions(1);
      }
      viewInfo.horizontal = true;
      columnOffset = 0;
      me.onButtonsStateChange?.(me);
      saveState();
      me.setColumns(viewInfo.columns, false);
      sourceHorizontal.refresh("!").then(async () => {
        indicatorSize = 62;
        await me.setSource(sourceHorizontal, false);

        const collapseCorrection = getCorrectionHorizontalOn(viewInfo.saveColumns.levels, {
          trueCurrentCol: currentCol,
          result: 0,
          indexCol: 0,
        });

        scrollToRecord(viewInfo.currentRow + collapseCorrection, true, false);

        updateScrollBar();
      });
    } else {
      viewInfo.horizontal = false;
      if (newSource !== false) {
        columnOffset = calculateColumnOffset(viewInfo.saveColumns.levels, me.source.activeRecord);

        const collapseCorrection = getCorrectionHorizontalOff(viewInfo.saveColumns.levels, {
          trueCurrentCol: me.source.activeRecord,
          result: 0,
          indexCol: 0,
        });
        const newCol = me.source.activeRecord - collapseCorrection;
        me.setColumns(viewInfo.saveColumns, false);
        viewInfo.saveSource.onDataChanged = me.source.onDataChanged;
        await me.setSource(viewInfo.saveSource, false);
        currentCol = newCol;
        await scrollToRecord(me.source.activeRecord, true);
        zaglushka();
      }
      await me.onButtonsStateChange?.(me);
      updateScrollBar();
      saveState();
    }
  };

  function calculateColumnOffset(data, col, indexToFind) {
    let field,
      coloffset = 0,
      width,
      level,
      left = 0,
      index = indexToFind ? indexToFind : -1;
    const totalWidth = me.panel.offsetWidth - indicatorSize;

    for (const value of Object.values(data)) {
      index++;
      level = value;
      field = level.field;

      if (field.hide !== true && field.hideInCard !== true) {
        // if (value.expanded) {
        //   width = calculateColumnOffset(value, col, index);
        // } else {
        width = field.width;
        if (left + width > totalWidth) {
          if (width > 130) coloffset += 1;
          else coloffset += 1;
          overflowColumns = true;
          rightOverflow = true;
          // width -= left + width - totalWidth;
          // if (width < rowHeight) break;
          // i = levels.length;
        }
        if (col === index) return coloffset;
        left += width;
      }
    }
    if (indexToFind !== undefined) return left;
    else return 0;
  }

  async function createColumnSource() {
    const sourceHorizontal = new createRecordSource();
    sourceHorizontal.CreateCollapsibleRecords = async function (div, me, i, td) {
      const recordInfo = await me.source.getRecordInfo();
      // const recordLevel = await me.source.getRecordLevel();
      const recordState = await me.source.getRecordState();

      const classfiresIcon = document.createElement("img");
      td.levelsField = recordInfo.levelsField;
      if (i !== 0) return;
      if (isCollapsibleRecord(recordState)) {
        classfiresIcon.textContent = recordState === 160 || recordState === 161 ? "+" : "-";
        classfiresIcon.type = recordState === 160 || recordState === 161 ? "+" : "-";
        classfiresIcon.src = "data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
        classfiresIcon.classList.add("collapse-img");
        classfiresIcon.classList.add(recordState === 160 || recordState === 161 ? "collapse-plus" : "collapse-minus");
        classfiresIcon.style.position = "absolute";
        classfiresIcon.style.cursor = "pointer";
        classfiresIcon.style.marginLeft = 6 + "px";
        classfiresIcon.style.marginTop = "5px";
        classfiresIcon.id = "ExpandIcon";
        classfiresIcon.setAttribute("recordindex", me.source.activeRecord);
        classfiresIcon.onclick = function (e) {
          me.source.onRecordCollapsed(e);
        };
      }
      div.style.marginLeft = 15 + "px";

      // функция монтирования иконок
      if (classfiresIcon.textContent !== "") {
        classfiresIcon.role = "expandCard";
        td.appendChild(classfiresIcon);
      }

      return classfiresIcon.textContent === "" ? null : classfiresIcon;
    };
    sourceHorizontal.onRecordCollapsed = async function (e) {
      const levelsField = e.currentTarget.parentElement.levelsField;
      levelsField.expanded = !levelsField.expanded;
      updateCard(true);
    };
    sourceHorizontal.onDataChanged = me.getActiveSource().onDataChanged;
    sourceHorizontal.onHandleRequest = handlePlaneSourceRequest;
    sourceHorizontal.onNeedToSaveChanged = me.getActiveSource().onNeedToSaveChanged;
    // await sourceHorizontal.open();
    return sourceHorizontal;
  }

  function createViewColumns() {
    const width = me.panel.offsetWidth - indicatorSize;

    return {
      title: [
        {
          title: "",
          fieldName: "Title",
          width: width * 0.25,
          level: 0,
          collapseRecord: true,
          fieldInfo: { options: getParamColumnsOptions(ParamSetOption.Disabled) }, //запрет открытия редактора
        },
        {
          title: "",
          fieldName: "Value",
          width: width * 0.75,
          level: 0,
          fieldInfo: { options: getParamColumnsOptions(ParamSetOption.Disabled) },
        },
      ],
    };
  }

  async function handlePlaneSourceRequest(data) {
    const isVisibleInCard = (level) => !level.field.hide && level.field.hideInCard !== true;

    async function getRecords(dataFromParent, first, count) {
      const objOfLevels = dataFromParent ? dataFromParent : viewInfo.saveColumns.levels;
      // const valueInfo = grid.getActiveSource().getRecordInfo()
      // for (let index = first; index <= count; index++) {
      //   const element = objOfLevels[index];
      //   console.log(element.field);
      //   if (element.items && element.expanded) {
      //     for (let index = 0; index <= element.items.le; index++) {
      //       const element = objOfLevels[index];
      //       console.log(element.field);
      //     }
      //   }
      // }
      for (const value of Object.values(objOfLevels)) {
        if (isVisibleInCard(value)) {
          let objData;
          const info = { levelsField: value, updateStatus: 0 };
          const id = await me.getActiveSource().getFieldValue(value.field.fieldName);
          // id = result;
          const text = me.getActiveSource().getFieldTextSync(value.field.fieldName);
          //32 распахнутая. 160 запахнутая
          if (id) {
            objData = { id: id, text: text };
          } else {
            objData = text;
          }
          if (value.items) {
            info.RecordState = value.expanded ? 32 : 160;
            if (value.expanded) {
            }
          }
          if (value.level > 0) {
            info.RecordLevel = value.level;
          }
          dataRecord.RecordSet.Records.push({
            ...info,
            Data: [value.field.title, objData],
          });
          if (value.items && value.expanded) {
            await getRecords(value.items);
          }
        }
      }
    }

    function getRecordCount(data) {
      let recordCount = 0;
      const levels = data ? data : viewInfo.saveColumns.levels;
      for (const val of Object.values(levels)) {
        if (isVisibleInCard(val)) {
          recordCount += 1;
          if (val.expanded === true && val.items) {
            recordCount += getRecordCount(val.items);
          }
        }
      }
      return recordCount;
    }

    function updPending() {
      return me.getActiveSource().updatesPending === true ? "1" : "0";
    }

    function getFields() {
      const recordCount = getRecordCount();
      return {
        Fields: [
          { Name: "Index", Title: "" },
          { Name: "Title", Title: "" },
          { Name: "Value", Title: "" },
          { Name: "MultiValue", Title: "" },
          { Name: "MultiCheck", Title: "" },
          { Name: "MultiCanEditing", Title: "" },
          { Name: "MultiCanModify", Title: "" },
        ],
        RecordCount: recordCount,
        UpdatesPending: updPending(),
      };
    }
    const dataRecord = {
      UpdatesPending: updPending(),
      RecordSet: {
        Attributes: ["Title", "Value"],
        Records: [],
      },
    };
    switch (data.command) {
      case "getFields":
        return getFields();
      case "getRecords":
        await getRecords();
        return dataRecord;
      case "GetRecordCount":
        const recordCount = getRecordCount();
        return { UpdatesPending: updPending(), RecordCount: recordCount };
      default:
        console.log(data.command);
        break;
    }
  }

  async function updateCard(needToReBuild) {
    if (viewInfo.horizontal) {
      await me.source.refresh("!");
      if (needToReBuild !== false) await buildRecords();
      await createStatusButtonForCardMode();
      updateScrollBar();
      if (me.editorMode()) {
        await showEditor();
      }
    }
  }

  async function createStatusButtonForCardMode() {
    const oldbutton = panel.querySelector(".statusButtonForCardGrid");
    if (oldbutton) oldbutton.remove();
    if (viewInfo.horizontal && me.statusData) {
      const statusButtonDiv = document.createElement("div");
      statusButtonDiv.className = "statusButtonForCardGrid";
      statusButtonDiv.style.width = indicatorSize + "px";
      statusButtonDiv.style.position = "relative";
      statusButtonDiv.style.top = "21px";
      statusButtonDiv.style.left = "0px";
      statusButtonDiv.style.zIndex = "1";
      panel.appendChild(statusButtonDiv);
      const icon = await me.getActiveSource().getFieldValue("Status");
      createRoot(statusButtonDiv).render(
        <StatusButtonCardMode
          icon={icon || "1"}
          handleStatuses={me.statusData.handleStatuses}
          changeStatus={me.statusData.changeStatus}
        />,
      );
    }
  }

  me.isCard = function () {
    return viewInfo.horizontal;
  };

  me.updateCard = async function () {
    await updateCard();
  };

  function updateGridSizeForCardMode() {
    if (viewInfo.horizontal && me.columns.fields.length > 0) {
      const width = me.panel.offsetWidth - indicatorSize;
      const totalWidth = me.columns.fields[0].width + me.columns.fields[1].width;
      if (totalWidth !== width) {
        console.log(width - totalWidth);
        const plusWidth = (width - totalWidth) / 2;
        me.columns.fields[0].width += plusWidth;
        me.columns.fields[1].width += plusWidth;
      }
    }
  }

  function zaglushka() {
    if (showIndicator) {
      if (me.zaglushka) me.zaglushka.remove();
      const zaglushkaDiv = document.createElement("div");
      // zaglushkaDiv.style.position = "absolute";
      zaglushkaDiv.className = "zaglushkaGrid";
      zaglushkaDiv.style.zIndex = "0";
      zaglushkaDiv.style.top = 0 + "px";
      // zaglushkaDiv.style.bottom = "0";
      zaglushkaDiv.style.height = "100%";
      zaglushkaDiv.style.width = indicatorSize + "px";
      zaglushkaDiv.style.backgroundColor = "#faf9f5";
      zaglushkaDiv.style.borderRightStyle = "solid";
      zaglushkaDiv.style.borderRightColor = "#d0d0d0";
      zaglushkaDiv.style.borderRightWidth = "1px";
      me.zaglushka = zaglushkaDiv;
      me.table.appendChild(me.zaglushka);
      // return zaglushkaDiv;
    }
  }

  function showFilter() {
    const display = me.filter.style.display;
    me.filter.style.display = display === "grid" ? "none" : "grid";
    filterSize = display === "grid" ? 0 : rowHeight + 2;
    buildFilters();
    me.onButtonsStateChange?.(me);
  }

  function showGroup() {
    const display = me.groups.style.display;
    // const pattern = new RegExp(/(.*)px/);
    me.groups.style.display = display === "" ? "none" : "";
    buildGroupsContent();
    groupSize = display === "" ? 0 : me.groups.getBoundingClientRect().height;
  }
  let keypress = false,
    drawing = false;
  panel.style.userSelect = "none";
  panel.style.overflow = "hidden";
  panel.className = "grid-panel";
  panel.tabIndex = 0;

  const test = throttle(handleKeyDown, 10);
  setTimeout(() => {
    appendEvent("mousedown", handleMouseDown, panel);
    appendEvent("doubleclick", handleMouseDown, panel);
    appendEvent("mouseup", handleMouseUp, panel);
    appendEvent(
      "keydown",
      (e) => {
        if (e.repeat === false) {
          keypress = false;
          drawing = false;
          handleKeyDown(e);
        } else {
          if (!me.editorMode()) e.preventDefault();
          // e.stopPropagation()
          if (!drawing) {
            drawing = true;
            test(e);
            // setTimeout(() => {
            //   handleKeyDown(e)
            // .then(() => {
            drawing = false;
            // });
            // });
          }
        }
      },
      panel,
    );
    // panel.addEventListener("keydown", (function(canMove) {
    //   return function(e) {
    //     keypress = false;
    //     if (!canMove) return false;
    //     canMove = false;
    //     setTimeout(function() { canMove = true; }, 0);
    //     handleKeyDown(e)
    //   };
    // })(true), false);
    appendEvent(
      "keyup",
      () => {
        keypress = true;
      },
      panel,
    );
  }, 100);

  // sizeMarker = document.createElement("div");
  // sizeMarker.className = "grid-size-marker";
  // sizeMarker.style.left = "0px";
  // sizeMarker.style.top = "0px";
  // sizeMarker.style.height = "100%";
  // sizeMarker.style.opacity = 0;
  // sizeMarker.onmousedown = function (e) {
  //   e.stopPropagation()
  //   if (sizeMarker.sizeEl && handleColumnField === null) {
  //     handleColumnField = sizeMarker.sizeEl.field;
  //     sizeMarker.style.opacity = 1;
  //     if (handleColumnField) {
  //       appendEvent("mousemove", sizeColumn);
  //     }
  //   }
  // };
  // sizeMarker.ondblclick = function (e) {
  //   ajustColumnWidth(sizeMarker.sizeEl.field);
  // };
  // panel.appendChild(sizeMarker);

  let lastOverElement, prevEl;
  // panelLeftOffset = panel.getBoundingClientRect().left;
  setTimeout(() => {
    panel.onmousemove = function (e) {
      let el = e.target;
      if (el !== prevEl && el.className === "grid-cell-inner") {
        let field,
          recordIndex = me.getActiveSource().activeRecord;
        if (viewInfo.horizontal) {
          field = el.closest("TD")?.levelsField?.field;
        } else {
          field = el.closest("TD").field;
          recordIndex = el.closest("TABLE").recordIndex;
        }

        if (!field) return;
        if (field.fieldInfo && field.fieldInfo.onHint) {
          if (me.doccfgid && !el.title) {
            const json = GetColumnHintDocs({
              ID: field.fieldInfo.columnID,
              DocCfgID: me.doccfgid,
              DocID: me.getActiveSource().getFieldTextSync("ID", recordIndex),
              MasterID: me.getActiveSource().Master.MasterID,
            });
            el.title = json && json.Text ? json.Text : "";
          }
        } else {
          if (el.scrollWidth > el.offsetWidth) {
            if (el.title !== el.innerText) {
              el.title = el.innerText;
            }
          } else el.title = "";
        }
        prevEl = el;
      }
      if (el !== prevEl && el.className === "column-header-text") {
        if (el.scrollWidth > el.offsetWidth) {
          if (el.title !== el.innerText) {
            el.title = el.innerText;
          }
        } else el.title = "";
        prevEl = el;
      }
      if (lastOverElement != el) {
        lastOverElement = el;
        while (!el.role) {
          el = el.parentElement;
          if (!el) return;
        }
        // const Test = panel.getBoundingClientRect().left;
        // sizeMarker.style.left =
        //   el.getBoundingClientRect().right - Test - 5 + "px";
        // sizeMarker.sizeEl = el;
      }
    };
  }, 15);

  panel.classList.add("grid-main-parent");
  me.panel = panel;

  filterSize = 0;

  me.filter = document.createElement("div");
  me.filter.style.display = "none";
  me.filter.className = "grid-filter";
  me.filter.style.position = "relative";
  me.filter.style.top = "0px";
  me.filter.style.width = "100%";
  me.filter.style.height = rowHeight + 2 + "px";
  panel.appendChild(me.filter);

  groupSize = rowHeight + 4;

  if (groupSize > 0) {
    me.groups = document.createElement("div");
    me.groups.className = "grid-groups";
    me.groups.style.display = "none";
    me.groups.style.position = "relative";
    me.groups.style.width = "100%";
    me.groups.style.height = groupSize + "px";
    me.groups.style.overflow = "hidden";
    me.groups.style.whiteSpace = "nowrap";
    panel.appendChild(me.groups);
  }

  me.header = document.createElement("div");
  me.header.className = "grid-header";
  me.header.style.position = "absolute";
  me.header.style.width = "100%";
  panel.appendChild(me.header);

  leftRightMover = document.createElement("ul");
  leftRightMover.className = "pagination";
  leftRightMover.innerHTML = '<li><span role="l">❮</span></li><li><span role="r">❯</span></li>';
  leftRightMover.style.position = "absolute";
  leftRightMover.style.right = "-7px";
  leftRightMover.style.top = "2px";
  leftRightMover.style.width = "40px";
  leftRightMover.style.height = "20px";
  leftRightMover.style.opacity = "1";
  leftRightMover.style.backgroundColor = "white";
  leftRightMover.onclick = async function (el) {
    if (el.target.innerText == "❮") {
      if (columnOffset > 0) {
        columnOffset--;
        if (me.editorMode()) await hideEditor();
        await updateAllGrid();
      }
    } else if (el.target.innerText == "❯") {
      if (rightOverflow) {
        columnOffset++;
        if (me.editorMode()) await hideEditor();
        await updateAllGrid();
      }
    }
  };
  me.header.appendChild(leftRightMover);

  me.table = document.createElement("div");
  me.table.className = "grid-table";
  me.table.style.position = "absolute";
  me.table.style.width = "100%";
  me.table.style.bottom = "1px";

  zaglushka();

  panel.appendChild(me.table);
  me.data = document.createElement("div");
  me.data.style.float = "left";
  me.data.style.width = "100%";
  me.data.style.height = "100%";
  me.data.style.backgroundColor = GRID_BACKGROUND;
  // me.data.style.zIndex = 1;
  me.data.classList.add("grid-data");
  me.data.classList.add("grid-with-row-lines");
  appendEvent(
    "wheel",
    (e) => {
      queuedGridScroll.scrollGrid(e, handleMouseWheel).then(() => {
        queuedGridScroll.stopQueued();
      });
    },
    me.table,
  );
  let touchStartY = 0;
  appendEvent(
    "touchstart",
    (e) => {
      const touchObj = e.changedTouches[0];
      touchStartY = parseInt(touchObj.clientY);
    },
    me.table,
  );
  appendEvent(
    "touchmove",
    (e) => {
      queuedGridScroll.scrollGrid(e, handleMouseWheel).then(() => {
        queuedGridScroll.stopQueued();
      });
      e.preventDefault();
    },
    me.table,
  );
  appendEvent(
    "touchend",
    (e) => {
      handleMouseDown(e);
    },
    me.table,
  );
  if (showIndicator) {
    indicator = createIndicator("strelka");
    indicator.updated = false;
    setTimeout(() => {
      changeIndicator(dsBrowse);
    }, 100);
  }

  panel.onfocus = function (e) {
    me.onfocus(e);
  };
  panel.onblur = function (e) {
    me.onblur(e);
  };

  me.onfocus = function (e) {};

  me.onblur = function (e) {};

  me.table.appendChild(me.data);

  me.scrollBar = new createScrollbar(me.table, scrollView, async function (ratio) {
    const pos = Math.round((me.source.recordCount - visibleRows) * ratio);

    if (pos != firstRecord) {
      firstRecord = pos;
      const max = me.source.recordCount - visibleRows;
      if (firstRecord > max) firstRecord = max;
      currentRow = me.source.activeRecord - firstRecord;
      // await queuedGridScroll.scrollGrid(undefined, buildRecords);
      await buildRecords();
    }
  });

  return me;
}
